{
    "SEGMENT": {
        "ACTIVE": "Aktiv",
        "CALENDAR_EVENT": "Termine",
        "INACTIVE": "Inaktiv",
        "NO_SHOW": "Abgelaufen",
        "CANCELED": "Abgebrochen"
    },
    "2FA": {
        "ACTIVATED": "Aktiviert",
        "DEACTIVATED": "Deaktiviert",
        "NAME": "Zwei-Faktor-Authentifizierung"
    },
    "ACADEMIC_TITLE": {
        "DR": "Dr.",
        "NONE": "Keine Angabe",
        "PROF": "Prof.",
        "PROF_DR": "Prof. Dr.",
        "TITLE": "Titel"
    },
    "ACCEPT_REQUEST": "Anfrage annehmen",
    "ACCEPT_REQUEST_BUTTON": "Anfrage annehmen",
    "ACCESS": {
        "CAREGIVER": "Berechtigung Betreuer",
        "NONE": "Gesperrt",
        "PATIENT": "Berechtigung Patient",
        "READ": "Sichtbar",
        "SUPERVISOR": "Berechtigung Co-Betreuer",
        "WRITE": "Bearbeitbar"
    },
    "ACCOUNT_TYPE": {
        "LOGIN_USER": "Aktiv",
        "NAME": "Kontostatus",
        "PLAIN_USER": "Passiv",
        "REQUIRED": "Kontostatus benötigt"
    },
    "LOGIN_USER": "Aktiv",
    "PLAIN_USER": "Passiv",
    "ACT": "Akte",
    "ACTION": "Aktion",
    "ACTIONS": "Aktionen",
    "ACTIVATED": "Aktiv",
    "ACTIVE": "Sitzung gestartet",
    "ADD": "Hinzufügen",
    "ADDRESS": "Adresse",
    "ADDRESS_SUFFIX": "Adresszusatz",
    "ADD_APPOINTMENT": "Sitzung hinzufügen",
    "ADD_CONTENT": "Element hinzufügen",
    "ADD_EXERCISE": "Übung hinzufügen",
    "ADD_EXERCISE_COURSE": "Sitzungsvorlagen hinzufügen",
    "ADD_LEARNING_PLAN_SUCCESS_MESSAGE": "Lernplan wurde hinzugefügt.",
    "ADD_MEASUREMENT": "Messungen hinzufügen",
    "ADD_PATIENT_BUTTON": "Patient hinzufügen",
    "ADD_PATIENT_TITLE": "Patient Hinzufügen",
    "ADD_TASK_PLAN_SUCCESS_MESSAGE": "Aufgabenplan wurde hinzugefügt.",
    "ADD_THERAPY_TO_USER": "Training hinzufügen",
    "ADHESIVE": "Haftend",
    "ADMISSION": "Einlass",
    "ALFAVIEW": "alfaview",
    "ALFAVIEW_SYSTEM": {
        "ERROR": {
            "MEETING_NOT_AVAILABLE": "Das Alfaview Meeting ist zur Zeit nicht erreichbar."
        }
    },
    "ALL": "Alle",
    "ALL_PATIENTS": "Alle Patienten",
    "ALTERNATIVE": "Alternativ",
    "ALTERNATIVE_APOINTMENT_EXERCISE": "Alternative Sitzungsvorlagen",
    "ALTERNATIVE_APPOINTMENT_EXERCISE_SELECT": "Sitzungsvorlagen auswählen",
    "ALTERNATIVE_COURSE_EXERCISE": "Alternative Sitzungsvorlage",
    "ALTERNATIVE_COURSE_EXERCISE_SELECT": "Sitzungsvorlage auswählen",
    "ALTROSA": "Altrosa",
    "ANALYST": "Analyst",
    "ANAMNESE": "Anamnese",
    "ANNOUNCEMENT": {
        "ERROR": {
            "TITLE_NEEDED": "Es muss ein Text angegeben werden.",
            "BODY_NEEDED": "Es muss ein Text angegeben werden.",
            "TITLE_TOO_SHORT": "Der eingegebene Text ist zu kurz. Der eingegebene Text muss mindestens 3 Zeichen lang sein.",
            "BODY_TOO_SHORT": "Der eingegebene Text ist zu kurz. Der eingegebene Text muss mindestens 3 Zeichen lang sein.",
            "SAVE": "Beim speichern der Neuigkeit ist ein Fehler aufgetreten.",
            "LOAD": "Beim laden der Neuigkeiten ist ein Fehler aufgetreten."
        },
        "SINGULAR": "Neuigkeit",
        "PLURAL": "Neuigkeiten",
        "TITLE": "Titel",
        "BODY": "Text",
        "CONTENT": {
            "PLURAL": "Medien"
        },
        "SUCCESS": {
            "SAVE": "Speichern der Neuigkeit erfolgreich."
        },
        "VISIBILITY": {
            "SET": "Sichtbarkeit festlegen",
            "SUPERVISORS": {
                "VISIBLE": "Sichtbar",
                "NOT_VISIBLE": "Nicht sichtbar",
                "FOR_ALL": "Sichtbarkeit für alle Co-Betreuer"
            },
            "PATIENTS": {
                "VISIBLE": "Sichtbar",
                "NOT_VISIBLE": "Nicht sichtbar",
                "FOR_ALL": "Sichtbarkeit für alle Patienten",
                "MY": "Sichtbar für mir zugeordnete Patienten"
            },
            "COURSES": {
                "FOR_ALL": "Sichtbarkeit für Benutzer der Kurse",
                "ADD": "Kurse hinzufügen"
            },
            "PROGRAMS": {
                "FOR_ALL": "Sichtbarkeit für Benutzer der Programme",
                "ADD": "Programme hinzufügen"
            }
        },
        "PROMPT": {
            "DELETE_TITLE": "Neuigkeit löschen",
            "DELETE": "Sind sie sicher, dass sie die Neuigkeit löschen wollen?"
        },
        "PUBLISHED": {
            "SET": "Veröffentlichungszeitraum festlegen",
            "START_DATE": "Start der Veröffentlichung",
            "END_DATE": "Ende der Veröffentlichung",
            "ANY_END_DATE": "Kein Enddatum"
        },
        "ACTION_DELETE": "Neuigkeit löschen",
        "ACTION_OPEN": "Neuigkeiten öffnen",
        "ANY": "Es liegen keine Neuigkeiten für Sie vor.",
        "UNREAD_HINT": {
            "TITLE": "Es liegen ungelesene Neuigkeiten vor",
            "DESCRIPTION": "Haben Sie gesehen, dass neue Neuigkeiten für Sie bereitstehen? Klicken Sie oben im Menu auf Neuigkeiten, um diese lesen zu können."
        }
    },
    "ANY_ITEM": "Es liegen keine Element vor.",
    "ANY_CAREGIVER": "Es liegen keine Betreuer vor.",
    "ANY_CATEGORY": "Es liegen keine Kategorien vor.",
    "ANY_CHAT": "Es liegen keine Nachrichten vor.",
    "ANY_COURSE_TEMPLATE": "Es liegen keine Kursvorlagen vor.",
    "ANY_EXERCISE": "Es liegen keine Sitzungsvorlagen vor.",
    "ANY_EXERCISE_LEARNING": "Es liegen keine Lerneinheitvorlagen vor.",
    "ANY_EXERCISE_TRAINING": "Es liegen keine Übungen vor.",
    "ANY_HOMEWORK": "Es liegen keine Aufgaben vor.",
    "ANY_HOMEWORK_TEMPLATE": "Es liegen keine Aufgabenvorlagen vor.",
    "ANY_ITEMS": "Es liegen keine Einträge vor.",
    "ANY_LEARNING": "Es liegen keine Lerneinheiten vor.",
    "ANY_LEARNING_TEMPLATE": "Es liegen keine Lerneinheitvorlagen vor.",
    "ANY_ORDER": "Es liegen keine Aufträge vor.",
    "ANY_PATIENT": "Es liegen keine Patienten vor.",
    "ANY_ROLE": "Es liegen keine Rollen vor.",
    "ANY_SUPERVISOR": "Es liegen keine Co-Betreuer vor.",
    "ANY_TASK": "Es liegen keine Aufgaben vor.",
    "ANY_TASK_TEMPLATE": "Es liegen keine Aufgabenplanvorlagen vor.",
    "ANY_THERAPIST": "Es liegen keine Betreuer vor.",
    "ANY_THERAPY_SESSION": "Es liegen keine Einheiten vor.",
    "ANY_TRAINING": "Es liegen keine Trainingspläne vor.",
    "ANY_TRAINING_TEMPLATE": "Es liegen keine Trainingsplanvorlagen vor.",
    "ANY_USER": "Es liegen keine Benutzer vor.",
    "APP_NEEDED": "Sie benötigen die {{appName}} App, um diese Funktion nutzen zu können.",
    "APPROVAL": "Freigabe",
    "APPLICATION_AREA": "Zielgruppe",
    "APPLY": "Anwenden",
    "APPOINTMENT": "Termin",
    "APPOINTMENTS": "Termine",
    "APPOINTMENT_CREATED_FAILURE_MESSAGE": "Beim Anlegen des Termins ist ein Fehler aufgetreten.",
    "APPOINTMENT_DURATION_MESSAGE": "Ein Termin darf nicht kürzer als 1 Minute sein.",
    "APPOINTMENT_PLAN": "Sitzungen",
    "APPOINTMENT_PLAN_DETAIL_PAGE_TITLE": "Sitzungsvorlage",
    "APPOINTMENT_PLAN_DETAIL_PAGE_TITLE_NEW": "Sitzungsvorlage erstellen",
    "APPOINTMENT_TIMELINE": {
        "DELAYED_TIME": "Fällig am",
        "END_TIME": "Bearbeitung spätestens bis",
        "START_TIME": "Bearbeitung frühestens ab"
    },
    "APPROVE_FINDING": "Befund freigeben",
    "ASK_BUDDY": "Buddy fragen",
    "ASSIGNMENT": "Auftrag",
    "AUDITED": "Geprüft",
    "AUTHENTICATION_WEBSHOP": "Anmelden/\nRegistrieren",
    "AUTHORIZATION": {
        "NO_SITE_ENTITLEMENT": "Sie haben nicht die nötigen Rechte, um diese Seite anzuzeigen",
        "NO_SITE_ENTITLEMENT_LOGOUT": "Sie haben nicht die nötigen Rechte, um diese Seite anzuzeigen. Sie werden bald abgemeldet."
    },
    "AVAILABLE_COURSE": "Verfügbare Kurse",
    "BACK": "Zurück",
    "BACK_CALENDAR": "Zurück zum Planer",
    "BACK_HOME": "Zurück zur Übersicht",
    "BACK_LEFT_CORE": "Oberkörper hinten links",
    "BACK_LEFT_HEAD": "Kopf hinten links",
    "BACK_LEFT_LOWER_ARM": "Unterarm hinten links",
    "BACK_LEFT_LOWER_LEG": "Unterschenkel hinten links",
    "BACK_LEFT_UPPER_ARM": "Oberarm hinten links",
    "BACK_LEFT_UPPER_LEG": "Oberschenkel hinten links",
    "BACK_RIGHT_CORE": "Oberkörper hinten rechts",
    "BACK_RIGHT_HEAD": "Kopf hinten rechts",
    "BACK_RIGHT_LOWER_ARM": "Unterarm hinten rechts",
    "BACK_RIGHT_LOWER_LEG": "Unterschenkel hinten rechts",
    "BACK_RIGHT_UPPER_ARM": "Oberarm hinten rechts",
    "BACK_RIGHT_UPPER_LEG": "Oberschenkel hinten rechts",
    "BACK_TO_START": "Zurück",
    "BALANCE": "Gleichgewicht",
    "BEHAVIOR": "Verhalten",
    "BEING_REMOVED": {
        "CAREGIVER": "Betreuer wird entfernt",
        "PATIENT": "Patient wird entfernt"
    },
    "BEGIN": "Beginn",
    "BIRTH_DATE": "Geburtsdatum",
    "BLOODY": "Blutig",
    "BLOOD_OXYGEN_LEVEL": "Sauerstoffsättigung",
    "BLOOD_OXYGEN_LEVEL_PERCENT": "Sauerstoffsättigung (%)",
    "BLOOD_PRESSURE": "Blutdruck",
    "BLOOD_PRESSURE_MMHG": "Blutdruck (mmHg)",
    "BLOOD_PRESSURE_DIASTOLIC_MMHG": "Blutdruck diastolisch (mmHg)",
    "BLOOD_PRESSURE_SYSTOLIC_MMHG": "Blutdruck systolisch (mmHg)",
    "BLUETOOTH_LE": {
        "READ_DATA": "Messung übertragen",
        "CONNECTION_INFO": {
            "DEVICE_NOT_READY": "Bluetooth nicht aktiviert oder fehlende Berechtigungen.",
            "BLUETOOTH_BLOOD_PRESSURE_DEVICE_CONNECTION_HINT": "Messwerte werden übertragen sobald das Bluetooth Symbol auf dem Gerät zu sehen ist. Führen Sie dafür entweder eine Messung durch oder drücken Sie den Messwert-Button unten links auf dem Gerät.",
            "BLUETOOTH_BLOOD_GLUCOSE_DEVICE_CONNECTION_HINT": "Messwerte werden übertragen sobald das Bluetooth Symbol auf dem Gerät zu sehen ist. Drücken Sie dafür auf der linken Seite des Geräts auf die Minus-Taste und warten einen kurzen Moment. Es muss bereits min. eine Messung druchgeführt worden sein.",
            "TOOLBAR_TITLE": "Messwerte per Bluetooth auslesen",
            "HEADLINE": "Bluetooth-Verbindung herstellen",
            "INTRO": "Damit Ihr Gerät mit der App verbunden werden kann, müssen auf Ihrem Smartphone ein paar Einstellungen aktiviert sein. Die folgenden Schritte helfen Ihnen dabei.",
            "STEP_BLUETOOTH_ON": {
                "TITLE": "1. Bluetooth einschalten",
                "ANDROID": "Öffnen Sie die Einstellungen Ihres Smartphones und tippen Sie auf „Verbundene Geräte“. Schalten Sie dort Bluetooth ein. Sie können Bluetooth auch schneller über das Schnellmenü einschalten – wischen Sie dazu von oben nach unten über den Bildschirm.",
                "IOS": "Öffnen Sie die Einstellungen Ihres iPhones und tippen Sie auf „Bluetooth“. Schalten Sie es dort ein. Alternativ öffnen Sie das Kontrollzentrum (von der oberen rechten Ecke nach unten wischen) und tippen auf das Bluetooth-Symbol, bis es blau leuchtet."
            },
            "STEP_APP_PERMISSION": {
                "TITLE": "2. Der App den Zugriff auf Bluetooth erlauben",
                "ANDROID_INFO": "Wenn Sie die Verbindung zum ersten Mal einrichten, fragt die App, ob sie auf Bluetooth zugreifen darf bzw. Geräte in der Nähe suchen darf. Bitte bestätigen Sie das. Bei etwas älteren Smartphones fragt die App zusätzlich nach der Standort-Berechtigung – das ist eine technische Voraussetzung des Betriebssystems und bedeutet nicht, dass die App Ihren Standort speichert oder nutzt.",
                "ANDROID_CHANGE_LATER": "Haben Sie eine Anfrage versehentlich abgelehnt, können Sie das nachträglich ändern: Einstellungen → Apps → [App-Name] → Berechtigungen.",
                "ANDROID_ENABLE_LOCATION": "Bei manchen älteren Android-Smartphones muss zusätzlich der Standort eingeschaltet sein, damit Bluetooth-Geräte gefunden werden können. Das hat nichts damit zu tun, dass die App Ihren Standort nutzt – es ist lediglich eine technische Voraussetzung des Betriebssystems. Öffnen Sie dazu Einstellungen → Standort und schalten Sie ihn ein.",
                "IOS_INFO": "Wenn Sie die Verbindung zum ersten Mal einrichten, fragt Ihr iPhone, ob die App Bluetooth verwenden darf bzw. Geräte in der Nähe suchen darf. Bitte bestätigen Sie das mit „Erlauben“.",
                "IOS_CHANGE_LATER": "Haben Sie das versehentlich abgelehnt, können Sie es nachträglich ändern: Einstellungen → [App-Name] → Bluetooth.",
                "GO_TO_SETTINGS": "Zu den App-Einstellungen"
            },
            "STEP_BLOOD_PRESSURE_MEASUREMENT": {
                "TITLE": "3. Messung durchführen",
                "INTRODUCTION": "Sofern Bluetooth auf die App alle nötigen Berechtigungen hat und Bluetooth aktiviert ist, können Sie nun mit der Übertragung der Messwerte beginnen. Dafür gehen Sie wie folgt vor:",
                "STEP_1": "Messen Sie Ihren Blutdruck mit dem Blutdruckmessgerät von Beurer (Modell BM64).",
                "STEP_2": "Klicken Sie nach erfolgreicher Messung auf den Button \"Messung übertragen\" in der App. Die Messwerte werden nun automatisch übertragen, sofern Ihr Gerät bereits mit der App verbunden ist.",
                "STEP_3": "Wenn Sie das Gerät noch nicht verbunden haben, dann wird jetzt automatisch danach gesucht.",
                "STEP_4": "Wurde das Gerät gefunden und Sie verbinden Sie das Gerät zum ersten Mal, dann werden Sie dazu aufgefordert einen 6-stelligen Sicherheitscode einzugeben. Dieser wird Ihnen von dem Blutdruckmessgerät angezeigt.",
                "STEP_5": "Ist die App jetzt erfolgreich mit dem Messgerät verbunden, dann wird der Messwert nach einer erfolgreichen Messung automatisch in der App eingetragen.",
                "HINTS": {
                    "TITLE": "Hinweise",
                    "HINT_1": "Voraussetzung für das Übertragen der Messwerte ist, dass das Blutdruckmessgerät bereit für die Datenübermittlung ist. Das erkennen Sie daran, dass auf dem Bildschirm das Bluetooth Symbol angezeigt wird. Das ist entweder direkt nach einer Messung der Fall oder per Klick auf das Messanzeige-Symbol unten links.",
                    "HINT_2": "Es wird immer der zuletzt gemessene Wert übertragen, unabhängig vom ausgewählten Nutzerprofil."
                }
            },
            "STEP_BLOOD_GLUCOSE_MEASUREMENT": {
                "TITLE": "3. Messung durchführen",
                "INTRODUCTION": "Sofern Bluetooth auf die App alle nötigen Berechtigungen hat und Bluetooth aktiviert ist, können Sie nun mit der Übertragung der Messwerte beginnen. Dafür gehen Sie wie folgt vor:",
                "STEP_1": "Führen Sie eine Blutzuckermessung mit dem Blutzuckermessgerät von Beurer durch (Modell GL49).",
                "STEP_2": "Drücken Sie nach erfolgreicher Messung, auf der linken Seite des Geräts, auf die Taste mit dem Minus-Symbol. Auf dem Bildschirm des Geräts erscheint nun nach kurzer Zeit ein Bluetooth-Symbol.",
                "STEP_3": "Jetzt können Sie in der App auf den Button \"Messung übertragen\" klicken. Die Messwerte werden nun automatisch übertragen, sofern Ihr Gerät bereits mit der App verbunden ist.",
                "STEP_4": "Wenn Sie das Gerät noch nicht verbunden haben, dann wird jetzt automatisch danach gesucht.",
                "STEP_5": "Wurde das Gerät gefunden und Sie verbinden Sie das Gerät zum ersten Mal, dann werden Sie dazu aufgefordert einen 6-stelligen Sicherheitscode einzugeben. Dieser wird Ihnen von dem Blutzuckermessgerät angezeigt.",
                "STEP_6": "Ist die App jetzt erfolgreich mit dem Messgerät verbunden, dann können Sie jetzt, wie zuvor angegeben, die Messung übertragen.",
                "HINTS": {
                    "TITLE": "Hinweise",
                    "HINT_1": "Voraussetzung für das Übertragen der Messwerte ist, dass bereits mindestens eine Messung durchgeführt wurde und das Blutzuckermessgerät bereit für die Datenübermittlung ist. Das erkennen Sie daran, dass auf dem Bildschirm das Bluetooth Symbol angezeigt wird.",
                    "HINT_2": "Es wird immer der zuletzt gemessene Wert übertragen."
                }
            },
            "TROUBLESHOOTING": {
                "TITLE": "4. Falls die Verbindung nicht funktioniert",
                "INTRO": "Gehen Sie die folgenden Schritte der Reihe nach durch und prüfen Sie nach jedem Schritt, ob \"Messung übertragen\" jetzt funktioniert.",
                "STEP_CHECK_BLUETOOTH": {
                    "TITLE": "Schritt 1: Bluetooth prüfen und neu starten",
                    "DESCRIPTION": "Prüfen Sie, ob Bluetooth an Ihrem Smartphone oder Tablet eingeschaltet ist (siehe Abschnitt 1 „Bluetooth einschalten“ weiter oben). Ist es bereits eingeschaltet, schalten Sie es einmal aus und wieder ein. Hilft das nicht, starten Sie Ihr Smartphone oder Tablet einmal neu."
                },
                "STEP_FORGET_DEVICE": {
                    "TITLE": "Schritt 2: Messgerät aus der Bluetooth-Liste entfernen",
                    "INTRODUCTION": "Das löscht die alte Verbindung, damit sich Ihr Gerät und das Messgerät neu miteinander verbinden können.",
                    "ANDROID": "Öffnen Sie die Einstellungen Ihres Smartphones oder Tablets und tippen Sie auf „Verbundene Geräte“ oder „Bluetooth“. Tippen Sie in der angezeigten Liste auf den Namen Ihres Messgeräts (z. B. „BM64“ oder „GL49“), dann auf das Zahnrad- oder Info-Symbol daneben und wählen Sie „Trennen“, „Entkoppeln“ oder „Vergessen“.",
                    "IOS": "Öffnen Sie die Einstellungen Ihres iPhones oder iPads und tippen Sie auf „Bluetooth“. Tippen Sie in der Liste „Meine Geräte“ auf das blaue „i“ neben dem Namen Ihres Messgeräts (z. B. „BM64“ oder „GL49“), dann auf „Gerät ignorieren“ und bestätigen Sie das."
                },
                "STEP_RESTART_DEVICE": {
                    "TITLE": "Schritt 3: Messgerät aus- und wieder einschalten",
                    "DESCRIPTION": "Halten Sie die Ein-/Aus-Taste des Messgeräts gedrückt, bis sich das Display ausschaltet. Warten Sie etwa 10 Sekunden und schalten Sie das Gerät dann wieder ein."
                },
                "STEP_REMOVE_BATTERY": {
                    "TITLE": "Schritt 4: Batterien kurz entnehmen",
                    "DESCRIPTION": "Öffnen Sie das Batteriefach an der Rückseite oder Unterseite des Messgeräts, nehmen Sie die Batterien heraus, warten Sie etwa 30 Sekunden und setzen Sie sie in der gleichen Ausrichtung wieder ein."
                },
                "STEP_PROXIMITY": {
                    "TITLE": "Schritt 5: Abstand und andere Geräte prüfen",
                    "DESCRIPTION": "Legen Sie das Messgerät während der Übertragung in die Nähe Ihres Smartphones oder Tablets, am besten unter einem Meter Abstand. Prüfen Sie außerdem, ob das Messgerät gerade zusätzlich mit einem anderen Smartphone oder Tablet verbunden ist, und schalten Sie in diesem Fall dort Bluetooth aus."
                },
                "STEP_BATTERY_LEVEL": {
                    "TITLE": "Schritt 6: Batteriestand des Messgeräts prüfen",
                    "DESCRIPTION": "Zeigt das Display des Messgeräts ein leeres oder blinkendes Batterie-Symbol, legen Sie neue Batterien ein. Schwache Batterien können die Bluetooth-Verbindung verhindern."
                },
                "STEP_CONTACT_SUPPORT": "Funktioniert die Verbindung danach immer noch nicht, wenden Sie sich bitte an unseren Support. Sie können die Messwerte in der Zwischenzeit auch von Hand in die App eintragen."
            }
        }
    },
    "SYSTOLIC_MMHG": "Systolisch (mmHg)",
    "DIASTOLIC_MMHG": "Diastolisch (mmHg)",
    "BLOOD_SUGAR_LEVEL": "Blutzucker",
    "BODY": "Body",
    "BODY_WEIGHT": "Körpergewicht",
    "BODY_WEIGHT_KG": "Gewicht (kg)",
    "BORG": "Borg",
    "BUMMER": "Schade",
    "BY": "von",
    "PLANER": "Planer",
    "CANCEL": "Abbrechen",
    "CANCEL_EDIT": "Bearbeiten\n beenden",
    "CANCELLED": "Abgebrochen",
    "CANCELLED_AT": "Abgebrochen am",
    "CANCEL_CONSULTATION_BUTTON": "Konsil abbrechen",
    "CANCEL_LEARNING": "Lerneinheit abbrechen",
    "CANCEL_LEARNING_MESSAGE": "Die Lerneinheit wurde abgebrochen.",
    "CANCEL_LEARNING_FAILURE": "Beim Abbrechen der Lerneinheit ist ein Fehler aufgetreten.",
    "CANCEL_LOWER": "abbrechen",
    "CANCEL_ORDER": "Anfrage abbrechen",
    "CANCEL_TASK": "Aufgabe abbrechen",
    "CANCEL_TASK_FAILURE": "Beim Ablehnen der Aufgabe ist ein Fehler aufgetreten.",
    "CANCEL_TASK_PROMPT": "Sind Sie sicher, dass Sie die Aufgabe abbrechen wollen? Diese Aufgabe kann dann nicht mehr abgeschlossen werden.",
    "CANCEL_TASK_SUCCESS": "Die Aufgabe wurde erfolgreich abgebrochen",
    "CAREGIVER": "Betreuer",
    "CASE_INFORMATIONS": "Falldaten",
    "CASE_NOTES": "Fallnotizen",
    "CASE_NUMBER": "Fallnummer",
    "CASE_PLAN": "Fallplanung",
    "CASE_STUDY": "Erfahrungen",
    "CATALOG_MANAGER": "Katalogmanager",
    "CATALOG": {
        "SINGULAR": "Katalog"
    },
    "CATEGORY": "Kategorie",
    "CENTRAL_FACILITY": "Zentrum",
    "CHARACTERS": "Zeichen",
    "CHAT": {
        "CONFIGURATION": "Konfiguration des Chat",
        "MODIFICATION_ALLOWED_PATIENT": "Beantwortbar durch Patient",
        "NOT_VISIBLE_TO_PATIENT": "Nicht sichtbar für Patient",
        "NONPATIENT_MESSAGE": {
            "ACTIVE": "Der Chat befindet sich nun im aktiven Modus",
            "PASSIVE": "Der Chat startet im passiven Modus.\n\nWenn Sie den Chat aktivieren möchten, müssen Sie ggf. die Sichtbarkeit und Bearbeitbarkeit einrichten."
        },
        "UNREAD_MESSAGE": {
            "SINGULAR": "ungelesene Nachricht",
            "PLURAL": "ungelesene Nachrichten"
        },
        "ONLY_CAREGIVER_CAN_SEND_MESSAGES": "Nur Benutzer mit den zugehörigen Rechten können Nachrichten senden",
        "PATIENT_MESSAGE": {
            "ACTIVE": "<strong>Der Chat ist aktuell im aktiven Modus. Sie können Nachrichten an Ihre Betreuungsperson schreiben.</strong>\n\nBitte beachten Sie, dass die Beantwortung Ihrer Fragen bis zu 48 Stunden in Anspruch nehmen kann. Falls Sie länger auf eine Rückmeldung warten müssen, kontaktieren Sie uns gerne über andere Kommunikationskanäle. Sie finden diese im Menü unter Kontakt.\n\nDanke & viel Freude auf der Plattform.",
            "PASSIVE": "<strong>Der Chat ist aktuell im passiven Modus. Sie können Nachrichten nur lesen, aber nicht antworten.</strong>\n\nIm Falle einer persönlichen Betreuung wird Ihre Betreuungsperson den Chat zeitnah aktiv schalten. Dieser Vorgang kann bis zu 48 Stunden dauern.\n\nNatürlich können Sie bei dringlichen Rückfragen jederzeit alle anderen Kommunikationskanäle nutzen."
        },
        "PATIENT_MODIFICATION": "Beantwortbarkeit durch Patient",
        "READ_ONLY_PATIENT": "Nur lesend für Patient",
        "SINGULAR": "Chat",
        "SUPERVISOR_MODIFICATION": "Beantwortbarkeit durch Co-Betreuer",
        "VISIBILITY_TO_SUPERVISOR": "Sichtbarkeit für Co-Betreuer",
        "VISIBILE_FOR_PATIENT": "Sichtbar für Patient",
        "VISIBILITY_TO_PATIENT": "Sichtbarkeit für Patienten",
        "ANY_MESSAGE": "Es wurden bisher keine Nachrichten ausgetauscht. Starten Sie gerne mit der Konversation.",
        "MESSAGE_TOO_LONG": "Maximale Nachrichtenlänge überschritten.",
        "PERMISSION_MISSING": "Sie dürfen in diesem Chat keine Nachrichten schreiben.",
        "PATIENT_CAN_WRITE": "Beantwortbar durch Patient",
        "PATIENT_CAN_READ": "Nur lesend für Patient"
    },
    "CHAT_INFORMATION": "Chat Informationen",
    "CHAT_MESSAGE_SEND_ERROR": "Nachricht konnte nicht versendet werden. Bitte versuchen Sie es später erneut.",
    "CHAT_PATIENT_HOME_EXPLANATION": "Wir, Ihre persönlichen Betreuer, stehen per Chat zur Verfügung.",
    "CITY": "Ort",
    "CLOSE": "Schließen",
    "CLOSED": "Abgeschlossen",
    "CLOSED_AT": "Abgeschlossen am",
    "CLOSE_CASE": "Fall abschließen",
    "CLOSE_CONSULTATION_BUTTON": "Konsil abschließen",
    "CLOSE_PAGE": "Seite schließen",
    "COMPANY": "Firma",
    "COMPLETED": "abgeschlossen",
    "COMPLETE_EXERCISE": "Übung abschließen",
    "CONCERNING_PERSON": "Betreffende Person",
    "CONFIGURATION": {
        "ADD_LOGO": "Logo aktualisieren",
        "ADD_FAVICON": "Favicon aktualisieren",
        "ADD_BACKGROUND": "Hintergrund aktualisieren",
        "TITLE": "Konfiguration",
        "THEME": "Theme",
        "FILES": "Dateien",
        "AI_ASSISTANT": "KI-Assistenten",
        "REGISTRATION": "Registrierung",
        "REGISTRATION_URL": "Registrierung Url",
        "DIRECTUS_URL": "Directus Url",
        "APP_NAME": "App Name",
        "PRIMARY_COLOR": "Primärfarbe",
        "SECONDARY_COLOR": "Sekundärfarbe",
        "LOGO": "Logo",
        "FAVICON": "Favicon",
        "BACKGROUND_IMAGE": "Hintergrundbild",
        "TASK": {
            "SKIP": "Aufgaben überspringen können",
            "BLUETOOTH": "Bluetooth-Messgeräte verwenden",
            "DESCRIPTION_PER_STATE": "Aufgaben Erklärung pro Status"
        },
        "CHAT": {
            "VIDEO": "Video",
            "TOOL": "Tool",
            "DOMAIN": "Domain"
        },
        "CATALOG": {
            "SHOP_URL": "Shop Url"
        },
        "AI": {
            "BUDDY_URL": "Buddy Url",
            "URL_INVALID": "Bitte eine vollständige URL angeben (z.B. https://buddy.example.com)."
        },
        "COURSE": {
            "ALTERNATIVE_MEETINGS": "Alternativsitzungen aktivieren",
            "DISABLE_AUTO_ACTIVATION": "Auto Activation deaktivieren",
            "HIDE_PATIENT_CONTENT": "Unterlagen für Patient verstecken",
            "HIDE_COURSE_TAB": "Kurse Tab verstecken"
        },
        "PATIENT": {
            "PLANER": "Planer aktivieren",
            "STATISTICS": "Erfolge aktivieren",
            "PSEUDONYMISE": "Bei Erstellung Pseudonymisieren",
            "DEFAULT_MODE": "Default Modus",
            "ENABLED_MODE": "Aktivierter Modus"
        },
        "PROFILE_SHOW": "Anzeigen"
    },
    "CONFIRM": "Bestätigen",
    "CONFIRM_CLOSE_REQUEST_BUTTON": "Schließung bestätigen",
    "CONNECTION_FIRST_TO_BOOKING_ARTICLE_EXPLANATION": "Um den Kurs buchen zu können, müssen Sie sich mit Ihrem Konto anmelden.",
    "CONSULTANT": "Konsildienst",
    "CONSULTATION": {
        "CHOOSE_FORM": "Formular wählen",
        "OPEN_FORM": "Formular öffnen",
        "CHOOSE_PATIENT": "Patient wählen",
        "CREATE_PATIENT": "Patient anlegen",
        "FORM": "Formular",
        "MODIFY_PATIENT": "Patient bearbeiten",
        "MODIFY_SUBJECT": "Fragestellung bearbeiten",
        "PLURAL": "Konsile",
        "CANCELLED": "Konsil abgebrochen",
        "CANCEL_ACTION": {
            "TITLE": "Konsil abbrechen",
            "DESCRIPTION": "Sind Sie sicher, dass Sie dieses Konsil abbrechen möchten?"
        },
        "DECLINE_ACTION": {
            "TITLE": "Konsil ablehnen",
            "DESCRIPTION": "Sind Sie sicher, dass Sie dieses Konsil ablehnen möchten?"
        },
        "REVOKE_ACTION": {
            "TITLE": "Konsil widerrufen",
            "DESCRIPTION": "Sind Sie sicher, dass Sie dieses Konsil widerrufen möchten?"
        },
        "DELETE_ACTION": {
            "TITLE": "Konsil löschen",
            "DESCRIPTION": "Sind Sie sicher, dass Sie dieses Konsil löschen möchten?"
        },
        "REQUESTED": "Konsil angefragt",
        "ACCEPTED": "Konsil angenommen",
        "DECLINED": "Konsil abgelehnt",
        "REVOKED": "Konsil widerrufen",
        "DELETED": "Konsil gelöscht",
        "CLOSED": "Konsil geschlossen",
        "CLOSURE_CONFIRMED": "Konsil final abgeschlossen",
        "REOPENED": "Konsil neueröffnet",
        "CONFIGURATION": "Einstellungen für Konsile",
        "SET_SUBJECT": "Fragestellung hinzufügen",
        "ANY": "Es liegen keine Konsile vor.",
        "ANY_FORM": "Es liegen keine Formulare vor.",
        "DATA_SAVE": "Daten gespeichert.",
        "EVENT": {
            "SINGULAR": "Ereignis",
            "CREATE": "Konsil erstellt",
            "REQUEST": "Anfrage bearbeitet",
            "ACCEPT": "Anfrage geprüft",
            "CLOSE": "Befund bearbeitet",
            "CONFIRM_CLOSURE": "Konsil abgeschlossen",
            "REOPEN": "Konsil wieder geöffnet",
            "NEW_MESSAGE": "Neue Chat Nachricht",
            "PDF_REPORT": "PDF Bericht erzeugt",
            "UNKNOWN": "Unbekanntes Event",
            "FILE_ADDED": "Datei hochgeladen",
            "FILE_DELETED": "Datei gelöscht",
            "FORM_NEW_VERSION": "Neue Version des Formulars",
            "FORM_LATEST_VERSION": "Neueste Version des Formulars",
            "RECORDING": "Aufnahme",
            "DOCUMENT": "Dokument",
            "FILLED_IN": "ausgefüllt",
            "UPLOADED": "hochgeladen",
            "DELETED": "gelöscht"
        },
        "ERROR": {
            "CONSULTANT_SETTINGS": "Beim Abrufen der Einstellungen des Konsildiensts ist ein Fehler aufgetreten.",
            "REQUEST": "Beim Anfragen des Konsils ist ein Fehler aufgetreten.",
            "ACCEPT": "Beim Annehmen des Konsils ist ein Fehler aufgetreten.",
            "DECLINE": "Beim Ablehnen des Konsils ist ein Fehler aufgetreten.",
            "REVOKE": "Beim Widerrufen des Konsils ist ein Fehler aufgetreten.",
            "DELETE": "Beim Löschen des Konsils ist ein Fehler aufgetreten.",
            "CANCEL": "Beim Zurückziehen des Konsils ist ein Fehler aufgetreten.",
            "CLOSE": "Beim Schließen des Konsils ist ein Fehler aufgetreten.",
            "CONFIRM_CLOSURE": "Beim Abschließen des Konsils ist ein Fehler aufgetreten.",
            "REOPEN": "Beim Neuöffnen des Konsils ist ein Fehler aufgetreten.",
            "DUPLICATE_CASE_NUMBER_IN_GROUP": "Speichern fehlgeschlagen. Für diesen Auftraggeber existiert bereits ein anderes Konsil mit der angegebenen Fallnummer.",
            "DATA_SAVE": "Beim Speichern der Daten ist ein Fehler aufgetreten."
        },
        "TOOLTIP": {
            "ENABLE_CENTRAL_FACILITY": "Alle Teilnehmer der Gruppe können Konsile sehen und bearbeiten. Diese Gruppe kann beim Konsil als Konsildienst ausgewählt werden.",
            "ENABLE_COOPERATION_FACILITY": "Alle Teilnehmer der Gruppe können Konsile sehen und anfragen.",
            "ACTIVATION": "Bei der Annahme eines Konsils erfolgt eine Abfrage, welche Leistungen angefordert werden sollen."
        }
    },
    "CONSULTATIONS_CARD_TITLE": "Konsile",
    "CONSULTATION_CANCELED": "Konsil\nabgebrochen",
    "CONSULTATION_CREATED": "Konsil\nerstellt",
    "CONSULTATION_CREATED_FAILURE_MESSAGE": "Fehler beim Erstellen des Konsils",
    "CONSULTATION_CREATED_SUCCESS_MESSAGE": "Konsil erfolgreich erstellt",
    "CONSULTATION_CREATE_TITLE": "Konsil erstellen",
    "CONSULTATION_DECLINED": "Konsil\nabgelehnt",
    "CONSULTATION_DELETED": "Konsil\ngelöscht",
    "CONSULTATION_FINISHED": "Konsil\nabgeschlossen",
    "CONSULTATION_IN_CLOSING": "Konsil in\nSchließung",
    "CONSULTATION_OVERVIEW_TITLE": "Konsilübersicht",
    "CONSULTATION_PAGE_TITLE": "Konsil",
    "CONSULTATION_REVOKED": "Konsil\nwiderrufen",
    "CONSULTATION_SUBJECT": "Fragestellung",
    "CONTACT": "Kontakt",
    "CONTACT_MENU": "Kontakt",
    "CONTACT_INFO": "Kontaktinformationen",
    "COOPERATION_FACILITY": "Kooperationseinrichtung",
    "COUNTRY": "Land",
    "COMMON": {
        "MAIN": "Rechtliches",
        "USER_AGREEMENT": "Nutzungsvereinbarung",
        "PRIVACY": "Datenschutz",
        "PRIVACY_POLICY": "Datenschutzerklärung",
        "IMPRINT": "Impressum",
        "TERMS_AND_CONDITIONS": "Allgemeine Geschäftsbedingungen (AGB)",
        "CONFORMITY": "Konformitätserklärung",
        "CONTACT": "Kontakt"
    },
    "CONTENT": {
        "CONTENT": "Inhalt",
        "SINGULAR": "Unterlage",
        "PLURAL": "Unterlagen",
        "ANY": "Es sind keine Inhalte vorhanden.",
        "MESSAGE": {
            "REMOVE_FAILURE": "Fehler beim entfernen des Mediums"
        },
        "ANY_MEDIUM": "Es liegen keine Medien vor.",
        "ANY_FILE": "Es liegen keine Dateien vor.",
        "FILE_REQUIRED": "Datei erforderlich"
    },
    "MEETING": {
        "PLANNED": "Veröffentlicht",
        "NOT_PLANNED": "Nicht veröffentlicht",
        "ANY": "Es sind keine Kurse vorhanden.",
        "ALL": "Alle Kurse",
        "BUYING": "Gebuchte Kurse",
        "ANY_BOOKED": "Es wurden keine Kurse gebucht.",
        "ANY_APPOINTMENT": "Kein Datum festgelegt",
        "TITLE_REMOVE_ACTION": "{{firstname}} {{lastname}} aus Kurs entfernen",
        "TITLE_REMOVE_USER_ACTION": "{{userRole}} aus Sitzung entfernen",
        "DESCRIPTION_REMOVE_ACTION": "{{userRole}} {{firstname}} {{lastname}} aus dem Kurs „{{courseName}}“ entfernen. Wenn Sie {{firstname}} {{lastname}} entfernen möchten, klicken Sie auf „Entfernen“.",
        "SUPERVISOR_SELF_ASSIGN": "Mich als Teilnehmer hinzufügen",
        "CONFIGURATION_TITLE": "Sitzungskonfiguration",
        "MAX_PARTICIPANT": "Maximale Teilnehmerzahl",
        "PARTICIPANT_TYPE": "Teilnahmeform",
        "COURSE": {
            "ANY_ITEM": "Es liegen keine Kurse vor.",
            "DELETE_ACTION": "Kurs abschließen",
            "NOTES": "Hinweise für Betreuer",
            "OPEN": "Kurs öffnen",
            "COURSE_END": "Kurs am {{date}} abgeschlossen",
            "ACTIVE": "Kurs aktiv"
        },
        "COURSE_TEMPLATE": {
            "ANY_ITEM": "Es liegen keine Sitzungsplanvorlagen vor.",
            "DELETE_ACTION": "Sitzungsplanvorlage löschen",
            "DELETE_ACTION_PLURAL": "Sitzungsplanvorlagen löschen",
            "TITLE": "Sitzungsplanvorlage",
            "PLURAL": "Sitzungsplanvorlagen",
            "TITLE_REMOVE_ACTION": "{{title}} löschen",
            "DESCRIPTION_REMOVE_ACTION": "Die Sitzungsplanvorlage wird unwiderruflich gelöscht.\nWenn Sie die Sitzungsplanvorlage „{{title}}“ dennoch löschen möchten, klicken Sie auf „Löschen“.",
            "REMOVE_SUCCESSFULLY": "Die Sitzungsplanvorlage wurde erfolgreich gelöscht.",
            "REMOVE_ERROR": "Beim Löschen der Sitzungsplanvorlage ist ein Fehler aufgetreten.",
            "FETCH_ERROR": "Beim Abruf der Kursvorlage ist ein Fehler aufgetreten.",
            "CREATE_ERROR": "Beim Erstellen der Kursvorlage ist ein Fehler aufgetreten.",
            "ADD_MEETING_TEMPLATE_ERROR": "Beim Hinzufügen der Sitzungsvorlage ist ein Fehler aufgetreten.",
            "REMOVE_DESCRIPTION": "Die Kurzsvorlage wird unwiderruflich gelöscht. Wenn Sie die Kurzsvorlage „{{title}}“ dennoch löschen möchten, klicken Sie auf „Löschen“.",
            "REMOVE_TEMPLATE_SUCCESSFULLY": "Die Kurzsvorlage wurde erfolgreich gelöscht"
        },
        "ALTERNATIVE_MEETING": {
            "ANY_ITEM_FOR_USER": "Für dieser Sitzung steht leider keine Alternativsitzung zur Verfügung.\nFalls Sie nicht teilnehmen können, rufen Sie bitte bei uns an.",
            "SELECT": "Alternativtermin auswählen",
            "TEMPLATE": "Alternative Sitzungsvorlagen",
            "DESCRIPTION_REMOVE_ACTION": "Die Daten werden unwiderruflich gelöscht.\nWenn Sie die alternative Sitzungsvorlage „{{title}}“ entfernen möchten, klicken Sie auf „Entfernen“.",
            "ANY_ITEM_FOR_MODERATOR": "Für diese Sitzung stehen leider keine Alternativsitzungen zur Verfügung.",
            "ANY_OTHER_ITEM_FOR_MODERATOR": "Für diese Sitzung stehen leider keine Sondersitzungen zur Verfügung.",
            "ANY_USER_ITEM_FOR_MODERATOR": "Für diese Sitzung stehen leider keine Alternativsitzungen für den Patient zur Verfügung.",
            "POSSIBLE_ALTERNATIV_MEETING": "Mögliche Alternativsitzungen",
            "POSSIBLE_OTHER_MEETING": "Mögliche Sondersitzungen",
            "POSSIBLE_USER_ALTERNATIV_MEETING": "Mögliche Alternativsitzungen\nfür den Patient",
            "MEETING_IS_FULL_ERROR": "Die ausgewählte Sitzung ist bereits voll belegt. Bitte wählen Sie eine andere Sitzung."
        },
        "MEETING": {
            "DESCRIPTION_REMOVE_ACTION": "{{userRole}} {{firstname}} {{lastname}} aus der Sitzung entfernen. Wenn Sie {{firstname}} {{lastname}} entfernen möchten, klicken Sie auf „Entfernen“.`",
            "ACTIVE": "Sitzung aktiv",
            "ASSIGN": "Sitzung zuordnen",
            "ANY_ITEM": "Es liegen keine Sitzungen vor.",
            "ANY_APPOINTMENT": "Kein Termin festgelegt",
            "ANY_APPOINTMENT_WITHOUT_PATIENT": "Termin nur festlegbar, wenn ein Patient zugeordnet ist",
            "ANY_APPOINTMENT_WHEN_THE_COURSE_IS_STILL_ENDED": "Termin nicht mehr festlegbar, da Kurs beendet ist",
            "ANY_SESSION": "Es sind keine Sitzungen vorhanden.",
            "CANCELED_ACTION": "Sitzung abbrechen",
            "CANCELLED": "Sitzung abgebrochen",
            "COPIED_URL_PATIENT": "URL für Patienten wurde erfolgreich in die Zwischenablage kopiert.",
            "COPIED_URL_SUPERVISOR": "URL für Co-/Betreuer wurde erfolgreich in die Zwischenablage kopiert.",
            "COPIED_URL": "URL wurde erfolgreich in die Zwischenablage kopiert.",
            "DELETED": "Sitzung gelöscht",
            "CANCEL_FAILED_MESSAGE": "Abbrechen der Sitzung fehlgeschlagen",
            "CAUSE": "Grund",
            "DELETE_WARNING_TITLE": "Sitzung „{{title}}“ abbrechen",
            "DELETE_WARNING_ERROR": "Beim Abbrechen der Sitzung ist ein Fehler aufgetreten.",
            "DELETE_WARNING_DESCRIPTION": "Sind Sie sicher, dass Sie die Sitzung abbrechen wollen? Diese Sitzung  kann dann nicht mehr bearbeitet oder abgeschlossen werden.",
            "FINISHED": "Sitzung abgeschlossen",
            "FINISHED_ACTION": "Sitzung abschließen",
            "FINISHED_PROCESS_EXPLANATION": "Wenn sie den Abschluss des Termins bestätigen, werden an alle Patienten, deren Status “Nicht teilgenommen”\n    oder “Entschuldigt gefehlt” ist, E-Mails mit der Aufforderung versendet, eine Alternativsitzung zu suchen.",
            "FORMAT": "Format",
            "GROUP": "Gruppensitzung",
            "GROUP_SESSION": "Gruppe",
            "MY_SESSIONS": "Meine Sitzungen",
            "NAME": "Sitzungen",
            "OPEN_ALTERNATIVE": "Alternativsitzungen auswählen",
            "PLURAL": "Sitzungen",
            "NOTIFICATION_RECEIVER": "Empfänger der Benachrichtigung",
            "NOT_PLANNED": "Sitzung ungeplant",
            "NO_SHOW": "Sitzung nicht teilgenommen",
            "OPEN_ACTION": "Sitzung öffnen",
            "PLANNED": "Sitzung geplant",
            "REMOVE_ACTION_PROMPT": "Sind Sie sicher, dass Sie \"{{firstname}} {{lastname}}\" aus der Sitzung entfernen möchten?\n\nDer Patient kann anschließend nicht mehr an der Sitzung teilnehmen.",
            "SCHEDULE": "Sitzung geplant",
            "SELECTED": "Ausgewählte Sitzung",
            "SHOW": "Sitzung teilgenommen",
            "SHOW_PREVIEW": "Einheit ansehen",
            "SINGLE": "Einzelsitzung",
            "SINGLE_SESSION": "Einzel",
            "SINGULAR": "Sitzung",
            "START": "Start",
            "STARTED_ACTION": "Sitzung starten",
            "TITLE_REMOVE_ACTION": "{{firstname}} {{lastname}} aus Sitzung entfernen",
            "URL_PATIENT": "URL für Patienten in die Zwischenablage kopieren",
            "URL_SUPERVISOR": "URL für Co-/Betreuer in die Zwischenablage kopieren",
            "URL_ANONYM": "Anonym URL für Zwischenablage kopieren",
            "URL_CAREGIVER": "URL für Betreuer in die Zwischenablage kopieren",
            "VISIBILITY_TYPE": "Teilnehmerkreis",
            "WAITING_FINISHED": "Sitzung abzuschließen",
            "UPDATE_STATE_SUCCESSFULLY": "Patientenstatus erfolgreich aktualisiert.",
            "UPDATE_STATE_ERROR": "Aktualisierung des Terminstatus fehlgeschlagen.",
            "UPDATE_ERROR": "Beim Aktualisieren der Sitzung ist ein Fehler aufgetreten."
        },
        "MEETING_TEMPLATE": {
            "ACTIVATED": "Aktiviert",
            "DEACTIVATED": "Deaktiviert",
            "ANY_ITEM": "Es liegen keine Sitzungsvorlagen vor.",
            "ADD": "Sitzungsvorlagen hinzufügen",
            "DELETE": "Sitzungsvorlage löschen",
            "REMOVE": "Sitzungsvorlage entfernen",
            "SINGULAR": "Sitzungsplanvorlage",
            "PLURAL": "Sitzungsvorlagen",
            "DELETE_MODAL": {
                "TITLE": "{{title}} löschen?",
                "DESCRIPTION": "Die Daten werden unwiderruflich gelöscht.\n Wenn Sie die Sitzungsvorlage \"{{title}}\" löschen möchten, klicken Sie auf \"Löschen\".",
                "DELETE_CONFIRMATION": "Sind Sie sicher, dass Sie die Leistung “{{title}}” löschen möchten?"
            },
            "SPECTATOR_MODE_TOOLTIP": "Beim deaktivierten Zuschauermodus sind Kamera und Ton bei allen Patienten aktiviert. Beim aktivierten Zuschauermodus sind Ton und Kamera bei allen Patient deaktiviert.",
            "PRESENCE_TYPE": {
                "ONLINE": "Online",
                "HYBRID": "Hybrid",
                "PRESENCE": "Vor Ort"
            },
            "REMOVE_ACTION": "Sitzungsvorlage entfernen",
            "SELECT": "Sitzungsvorlage auswählen",
            "FETCH_ERROR_MISSING_VIDEO": "Beim Laden ist ein Fehler aufgetreten. Das Videosystem fehlt in der Sitzungsvorlage."
        },
        "LOCATION": {
            "ROOM": "Raum",
            "STREET_AND_NUMBER": "Straße und Hausnummer",
            "ZIP": "PLZ",
            "CITY": "Ort"
        },
        "OPEN_ACTION": "Kurs öffnen",
        "PLURAL": "Kurse",
        "PUBLISH_APPOINTMENT": "Sitzungen veröffentlichen",
        "SINGULAR": "Kurs",
        "TOOLTIP": {
            "VISIBILITY_TYPE": "Öffentliche Sitzungen werden allen Benutzern automatisch eingeblendet. Für private Sitzungen müssen die Teilnehmer explizit eingeladen werden."
        }
    },
    "MEETING_PRIVATE": "Privat",
    "MEETING_PUBLIC": "Öffentlich",
    "COURSE_STILL_BOOKING": "Sie haben diesen Kurs schon gebucht.",
    "COURSE_WEB_HOME_EXPLANATION_MULTIPLE_COURSES": "Sie nehmen an unten stehenden Kursen teil.",
    "COURSE_WEB_HOME_EXPLANATION_MULTIPLE_PROGRAMS": "Sie nehmen an unten stehenden Kursen teil.",
    "COURSE_WEB_HOME_EXPLANATION_MULTIPLE_PROGRAMS_AND_COURSES": "Sie nehmen an unten stehenden Kursen und Programmen teil.",
    "COURSE_WEB_HOME_EXPLANATION_NO_ITEMS": "Schön, dass Sie hier sind. Folgende Funktionen stehen Ihnen zur Verfügung.",
    "COURSE_WEB_HOME_EXPLANATION_ONE_COURSE": "Sie nehmen an unten stehenden Kurs teil.",
    "COURSE_WEB_HOME_EXPLANATION_ONE_PROGRAM": "Sie nehmen am unten stehenden Programm teil.",
    "COURSE_WEB_HOME_EXTRA_EXPLANATIONS": "Wenn Sie mehr über einen Kurs oder Programm erfahren möchten, können Sie die Kursbeschreibung öffnen, in dem Sie auf den Kurs klicken.",
    "COMMENTS": "Anmerkungen",
    "CLINICAL_NOTES": "Klinische Daten",
    "CREATE": "Erstellen",
    "CREATED": "Erstellt",
    "CREATED_AT": "Erstellt am",
    "CREATED_BY": "Erstellt von",
    "CREATE_CASE": "Fall erstellen",
    "CREATE_CATEGORY": "Kategorie erstellen",
    "CREATE_COURSE_ARTICLE_FIRST": "Bitte zuerst einen Artikel für die Kursvorlage anlegen.",
    "CREATE_FINDING": "Befund erstellen",
    "CREATE_NEW_COURSE_TEMPLATE": "Sitzungsplanvorlage\nerstellen",
    "CREATE_NEW_EXERCISE": "Sitzungsvorlage erstellen",
    "CREATE_NEW_LEARNING_TEMPLATE": "Lernplanvorlage erstellen",
    "CREATE_NEW_PROGRAM_TEMPLATE": "Programmvorlage erstellen",
    "CREATE_NEW_TASK_TEMPLATE": "Aufgabenplanvorlage\nerstellen",
    "CREATE_NEW_THERAPY": "Kurs erstellen",
    "CREATE_TAG_COURSE": "Tag erstellen",
    "CREATE_TAG_TASK": "Tag erstellen",
    "CREATE_TAG_TRAINING": "Tag erstellen",
    "CREATE_TASK_LIST": "Aufgabenliste erstellen",
    "CREATE_TEMPLATE_FAILURE_MESSAGE": "Beim Erstellen der Vorlage ist ein Fehler aufgetreten.",
    "CREATE_WITH_TITLE": "{{ \ntitle }} erstellen",
    "CREATION": "Erstellung",
    "CREATION_DATE": "Erstellungsdatum",
    "CREATOR": "Ersteller",
    "DATE": "Datum",
    "DAYS": "Tag",
    "DE": "Deutsch",
    "DEACTIVATED": "Inaktiv",
    "DECLARATION_OF_CONFORMITY": "Konformitätserklärung",
    "DECLINE": "Ablehnen",
    "DECLINED": "Abgelehnt",
    "DECLINE_ORDER": "Anfrage ablehnen",
    "DECLINE_REQUEST_BUTTON": "Anfrage ablehnen",
    "DELETE": "Löschen",
    "DELETED": "Gelöscht",
    "DELETE_ASSET": "Anhang löschen",
    "DELETE_ASSET_PROMPT": "Sind Sie sicher, dass Sie den Anhang löschen möchten?",
    "DELETE_CONSULTATION_BUTTON": "Konsil löschen",
    "DELETE_EXERCISE_DESCRIPTION": "{{ filename }} löschen",
    "DELETE_EXERCISE_DESCRIPTION_PROMPT": "Die Daten werden unwiderruflich gelöscht.\nWenn sie {{ filename }} löschen möchten, klicken Sie auf „Löschen“.",
    "DELETE_FILE": "Datei löschen",
    "DELETE_FILE_PROMPT": "Sind Sie sicher, dass Sie diese Datei löschen möchten?",
    "DELETE_FILE_INCLUDING_ASSETS": "Möchten Sie die ausgewählte Datei mitsamt des Anhangs löschen?",
    "DELETE_GROUP_BUTTON": "Gruppe löschen",
    "DELETE_LEARNING_EXERCISE": "Lerneinheitvorlage löschen",
    "DELETE_ORDER": "Anfrage löschen",
    "DELETE_ORG_BUTTON": "Organisation löschen",
    "DELETE_PROGRAM_TEMPLATE_FAILURE_MESSAGE": "Beim Löschen der Programmvorlage ist ein Fehler aufgetreten.",
    "DELETE_SUPERVISOR_ACCOUNT_BUTTON": "Co-Betreuerkonto löschen",
    "DELETE_TAG": "{{label}} löschen",
    "DELETE_TASK_SUCCESS_MESSAGE": "Die Aufgabe wurde erfolgreich gelöscht.",
    "DELETE_TASK_FAILURE_MESSAGE": "Beim Löschen der Aufgabe ist ein Fehler aufgetreten.",
    "DELETE_THERAPIST_ACCOUNT_BUTTON": "Betreuerkonto löschen",
    "DELETE_TRAINING_SUCCESS_MESSAGE": "Das Training wurde erfolgreich gelöscht.",
    "DELETE_TRAINING_FAILURE_MESSAGE": "Beim Löschen des Trainings ist ein Fehler aufgetreten.",
    "DEPARTMENT": "Abteilung",
    "DESCRIPTION": "Beschreibung",
    "DESIGNATION": "Bezeichnung",
    "DESCRIPTION_EXERCISE": "Aufgabe",
    "DETAILS": "Details",
    "DISCARD": "Verwerfen",
    "DISCARD_CHANGES": "Änderungen verwerfen",
    "DISCARD_CHANGES_PROMPT": "Sind Sie sicher, dass Sie die Änderungen verwerfen möchten?",
    "DISABLED": "Deaktiviert",
    "DISTRICT": "Ortsteil",
    "DIVERSE": "Divers",
    "DOCUMENTATION": "Dokumentation",
    "DOCUMENTS_CARD_TITLE": "Dokumente",
    "DONE": "Erledigt",
    "DONE_STATE": "Deaktiviert",
    "ENABLE_STATE": "Aktiviert",
    "ENABLE": "Aktivieren",
    "DOWNLOAD": {
        "PDF": "PDF herunterladen",
        "FILE": "Datei herunterladen"
    },
    "DUE": "Fällig",
    "DUE_DATE": "Fällig am ",
    "DURATION": "Dauer",
    "DURATION_IN_DAYS": "Dauer (Tage)",
    "DURATION_UNIT": "Einheit für Dauer",
    "EARLIEST_POSSIBLE_EDIT": "Früheste Bearbeitung",
    "ECG": "EKG",
    "EDIT": "Bearbeiten",
    "RESET": "Zurücksetzen",
    "CORRECT": "Korrigieren",
    "EDIT_PATIENT_BUTTON": "Patient bearbeiten",
    "EMAIL": "E-Mail Adresse",
    "EMAIL_VERIFIED": "E-Mail bestätigt",
    "EMPLOYED": "Berufliche Situation",
    "EMPTY": "Notizen",
    "EN": "English",
    "END": "Ende",
    "ENDED": "Beendet",
    "END_DATE": "Enddatum",
    "END_DATE_INVALID": "Enddatum ist ungültig",
    "ENGLISH": "Englisch",
    "ERROR": {
        "LINK_INVALID": "Beim abrufen des Links ist ein Fehler aufgetreten.",
        "TITLE_NEEDED": "Es muss ein Text angegeben werden.",
        "TITLE_TOO_SHORT": "Der eingegebene Text ist zu kurz. Der eingegebene Text muss mindestens 1 Zeichen lang sein.",
        "TITLE_TOO_LONG": "Der eingegebene Text ist zu lang. Der eingegebene Text darf maximal 255 Zeichen betragen.",
        "INVALID_DATE_FORMAT": "Das Format des Datums ist ungültig.",
        "INVALID_MAX_DATE_RANGE": "Ungültiges Datum. Datum liegt nach dem erlaubten Zeitraum.",
        "INVALID_MIN_DATE_RANGE": "Ungültiges Datum. Datum liegt vor dem erlaubten Zeitraum.",
        "NOT_ALLOW_TO_VIDEOCONF": "Sie können der Videokonferenz nicht beitreten.",
        "SAVE_PROCESS": "Beim Speichern der Daten ist ein Fehler aufgetreten",
        "SEND_PROCESS": "Beim Versenden der Daten ist ein Fehler aufgetreten",
        "DELETE_PROCESS": "Beim Löschen der Daten ist ein Fehler aufgetreten",
        "INVALID_JSON_FORMAT": "Das Format des Inhalts ist ungültig"
    },
    "ERROR_LOADING_FORM": "Beim Abrufen der abgegebenen Formulare ist ein Fehler aufgetreten.",
    "EVALUATION": {
        "SINGULAR": "Auswertung",
        "PLURAL": "Auswertungen",
        "ERROR": "Die Auswertungen konnten nicht geladen werden.",
        "NONE": "Es liegen keine Auswertungen vor.",
        "TRUNCATED": "Es werden nicht alle {{totalPoints}} Werte aus diesem Zeitraum angezeigt.",
        "FIELD_VISIBILITY": "Sichtbarkeit je Feld",
        "WARNING_LIMIT": "Warngrenze",
        "ALARM_LIMIT": "Alarmgrenze"
    },
    "EVENT_HISTORY": "Historie",
    "EXAMINATION_REQUESTED": "Untersuchung\nangeordnet",
    "EXERCISE": "Übung",
    "EXERCISES": "Übungen",
    "EXERCISE_COMMENT": "Kommentare",
    "EXERCISE_COMPLETED": "Übung erledigt",
    "EXERCISE_DETAIL_PAGE_TITLE_NEW": "Sitzungsvorlage erstellen",
    "EXERCISE_FINISHED": "Übung abgeschlossen",
    "EXERCISE_LEAVED": "Übung ausgelassen",
    "EXERCISE_LIST_PAGE_TITLE": "Sitzungsvorlage",
    "EXERCISE_NAME": "Übungsname",
    "EXERCISE_OF_THERAPY_TEMPLATE": "Sitzungsvorlagen",
    "EXERCISE_PATIENT_CANCELLED": "Übung ausgelassen",
    "EXPIRED": "Abgelaufen",
    "EXTEND_CASE": "Fall verlängern",
    "F": "Weiblich",
    "FAILED_TO_FETCH_PROFILE_MESSAGE": "Profil konnte nicht geladen werden",
    "FAMILY_DOCTOR": "Hausarzt",
    "FAMILY_DOCTOR_PHONE_NUMBER": "Telefon",
    "FEEDBACK_OF_EXERCISE_SESSION": "Rückmeldung",
    "FEMALE": "Weiblich",
    "FETCH_CONSULTATIONS_FAILED": "Fehler beim Abrufen der Konsile",
    "FETCH_LEARNING_PLAN_FAILED": "Fehler beim Abrufen der Lernplan.",
    "FETCH_PATIENTS_FAILED": "Fehler beim Abrufen der Patienten",
    "FETCH_PATIENT_FAILED": "Fehler beim Abrufen des Patienten",
    "FHIR_QUESTIONNAIRE": "Formular (FHIR)",
    "FILE": "Datei",
    "FILENAME": "Dateiname",
    "FILES": "Unterlagen",
    "NO_FILES_PRESENT": "Keine Unterlagen ausgewählt.",
    "FILE_ONLY": "Nur die Datei",
    "FILL_IN_FORM_BUTTON": "Formular bearbeiten",
    "CORRECT_FORM_BUTTON": "Formular korrigieren",
    "FILLED_BY": "Ausgefüllt von",
    "FILTER": "Filtern",
    "FILTER_TITLE": "Filter",
    "FINDING": "Befund",
    "FINDING_APPROVED": "Befund\nfreigegeben",
    "FINDING_IN_APPROVAL": "Befund in\nFreigabe",
    "FINDING_IN_CREATION": "Befund in\nBearbeitung",
    "FINDING_RELEASE": "Befundfreigabe",
    "FINISHED": "Abgeschlossen",
    "FINISH_EXAMINATION": "Untersuchung abschließen",
    "FINISH_ORDER": "Schließung bestätigen",
    "FINISH_TASK": "Aufgabe abschließen",
    "FINISH_TASK_FAILURE": "Beim Abschließen der Aufgabe ist ein Fehler aufgetreten.",
    "FINISH_TASK_SUCCESS": "Die Aufgabe wurde erfolgreich abgeschlossen.",
    "FIRM": "Hart",
    "FIRST_NAME": "Vorname",
    "FLAG": {
        "SINGULAR": "Flag",
        "PLURAL": "Flaggen"
    },
    "FLESHLY_RED": "Fleischig rot",
    "FONT_SIZE": "Schriftgröße",
    "FORBIDDEN": "Ihnen fehlen notwendige Berechtigungen, Ihr Benutzererlebnis könnte beeinträchtigt sein.",
    "FORGOT_PASSWORD": "Passwort vergessen?",
    "FORM": "Formular",
    "FORMS_CARD_TITLE": "Formulare",
    "FOR_LOWER": "für",
    "FOR_TRACKING": "Zur Nachverfolgung",
    "FOUL_BAD_SMELL": "Fauliger schlechter Geruch",
    "FREETEXT": "Freitext",
    "FREETEXTS": "Freitexte",
    "FREE_PRICE": "kostenlos",
    "FREQUENCY": "Frequenz",
    "FRONT_LEFT_CORE": "Oberkörper vorne links",
    "FRONT_LEFT_HEAD": "Kopf vorne links",
    "FRONT_LEFT_LOWER_ARM": "Unterarm vorne links",
    "FRONT_LEFT_LOWER_LEG": "Unterschenkel vorne links",
    "FRONT_LEFT_UPPER_ARM": "Oberarm vorne links",
    "FRONT_LEFT_UPPER_LEG": "Oberschenkel vorne links",
    "FRONT_RIGHT_CORE": "Oberkörper vorne rechts",
    "FRONT_RIGHT_HEAD": "Kopf vorne rechts",
    "FRONT_RIGHT_LOWER_ARM": "Unterarm vorne rechts",
    "FRONT_RIGHT_LOWER_LEG": "Unterschenkel vorne rechts",
    "FRONT_RIGHT_UPPER_ARM": "Oberarm vorne rechts",
    "FRONT_RIGHT_UPPER_LEG": "Oberschenkel vorne rechts",
    "Fri": "Freitag",
    "GENDER": "Geschlecht",
    "GERMAN": "Deutsch",
    "GOAL": {
        "SINGULAR": "Ziel",
        "PLURAL": "Ziele"
    },
    "GREAT_DONE": "Gut gemacht!",
    "GREEN": "Grün",
    "GROUP_SESSION": "Gruppe",
    "GENERIC_DELETE": "{{title}} löschen",
    "HEADER": {
        "CREATE_DATE": "Erstellungs-\ndatum",
        "CHANGED_DATE": "Änderungs-\ndatum",
        "ADDED_AT": "Hinzugefügt\nam",
        "CREATOR": "Ersteller",
        "CANCELLED_AT": "Abbruch\nam",
        "DUE_AT": "Fällig\nam",
        "EXPIRED_AT": "Ablauf\nam",
        "FINISHED_AT": "Abschluss\nam",
        "PLANNED_AT": "Geplant\nam",
        "TITLE": "Titel",
        "TAGS": "Tags",
        "START": "Start",
        "END": "Ende"
    },
    "HEADER_TEXT_TEMPLATE": "Vorlage",
    "HEALED": "Geheilt",
    "HEALTH_INSURANCE_COVERAGE": "Krankenversicherung",
    "HEALTH_INSURANCE_COVERAGE_NUMBER": "Versichertennummer",
    "HEIGHT": "Körpergröße",
    "HEIGHT_CM": "Körpergröße (cm)",
    "HELLO": "Hallo",
    "HELP": "Hilfe",
    "HELP_MENU": "Hilfe",
    "HISTORY": "Verlauf",
    "HOME": {
        "STATISTICS": {
            "ALL_DONE": "Für heute ist alles erledigt! Glückwunsch!",
            "AND": "und",
            "HINT": "Sie finden {{list}} hier im Planer! Klicken Sie auf einen aktiven Eintrag, um die Beschreibung zu lesen.",
            "HINT_KIND": {
                "APPOINTMENT_PLURAL": { "ARTICLE": "diese", "NOUN": "Termine" },
                "APPOINTMENT_SINGULAR": { "ARTICLE": "diesen", "NOUN": "Termin" },
                "TASK_PLURAL": { "ARTICLE": "diese", "NOUN": "Aufgaben" },
                "TASK_SINGULAR": { "ARTICLE": "diese", "NOUN": "Aufgabe" },
                "TRAINING_PLURAL": { "ARTICLE": "diese", "NOUN": "Trainings" },
                "TRAINING_SINGULAR": { "ARTICLE": "dieses", "NOUN": "Training" }
            },
            "APPOINTMENT_PLURAL": "{{count}} Termine",
            "APPOINTMENT_SINGULAR": "{{count}} Termin",
            "PENDING_PLURAL": "Für heute stehen {{list}} an!",
            "PENDING_SINGULAR": "Für heute steht {{list}} an!",
            "TASK_PLURAL": "{{count}} Aufgaben",
            "TASK_SINGULAR": "{{count}} Aufgabe",
            "TRAINING_PLURAL": "{{count}} Trainings",
            "TRAINING_SINGULAR": "{{count}} Training"
        },
        "TITLE": {
            "CATALOG_CONFIG": "Katalogverwaltung",
            "USER_CONFIG": "Benutzerverwaltung",
            "MAIN": "Übersicht"
        }
    },
    "HOMEWORK": "Auftrag",
    "HOURS": "h",
    "HOUSE_NUMBER": "Hausnummer",
    "ICON": {
        "SINGULAR": "Icon",
        "PLURAL": "Icons",
        "ANY_ITEM": "Es liegen keine Icons vor."
    },
    "INCLUDING_ASSETS": "Inklusive Anhang",
    "INCOMPLETE": "unvollständig",
    "INCREASE": "Steigerung",
    "INITIATOR": "Initiator",
    "INSTITUTION": "Einrichtung",
    "INTENSITY": "Intensität",
    "INTENSITY_UNIT": "Einheit für Intensität",
    "IN_PROGRESS": "In Bearbeitung",
    "JITSI": "Jitsi",
    "VITERO": "Vitero",
    "JOB": "Beruf",
    "JOIN_VIDEO_CONFERENCE": "Videoraum betreten",
    "JOURNAL": {
        "EVENT_TITLE": {
            "CALENDAR_EVENT_AT": "Termin am",
            "CAREGIVERS_CHANGED": "Betreuer-Zuordnung geändert",
            "COURSE": "Kurssitzung: {{title}}",
            "LEARNING": "Lernmodul: {{title}}",
            "NOTE_CREATED": "Notiz erstellt",
            "NOTE_CHANGED": "Notiz geändert",
            "NOTE_DELETED": "Notiz gelöscht",
            "SUPERVISORS_CHANGED": "Co-Betreuer-Zuordnung geändert",
            "ROLES_CHANGED": "Benutzerrollen geändert",
            "TAG_ASSIGNED": "Tag hinzugefügt",
            "TAG_UNASSIGNED": "Tag entfernt",
            "TASK": "Aufgabe: {{title}}",
            "TASK_SUBTYPES": {
                "FHIR_QUESTIONNAIRE": "FHIR-Formular: {{title}}",
                "FREETEXT": "Freitext: {{title}}",
                "MISSION": "Auftrag: {{title}}",
                "QUESTIONNAIRE": "Formular: {{title}}",
                "UPLOAD": "Upload: {{title}}",
                "VIDEO_CONFERENCE": "Videogespräch: {{title}}"
            },
            "UPDATE_EMAIL_EVENT": "Email Adresse geändert",
            "USER_CREATED": "Benutzerkonto erstellt",
            "USER_PROP_CHANGED": "Stammdaten aktualisiert",
            "USER_CUSTOM_PROP_CHANGED": "Stammdaten aktualisiert",
            "USER_UPDATED": "Benutzerkonto geändert",
            "CORRECT_TASK": "Aufgabe korrigiert",
            "CORRECT_QUESTIONNAIRE": "Formular korrigiert"
        },
        "HOME_PAGE_EXPLANATION": "Ihr Kurs  ist startklar. Mit dem Planer können Sie sofort mit Ihrem Kurs starten.",
        "LAST_EDITED_BY_TOOLTIP": "Zuletzt bearbeitet von",
        "OPEN": "Planer öffnen",
        "PAGE_TITLE": "Planer",
        "PAST_ACTIVITIES": "Vergangene Aktivitäten",
        "RESPONSIBLE": "Verantwortlich",
        "RETURN_TODAY": "Heute",
        "TO_TODAY": "Zu\n Heute",
        "WEB_HOME_EXPLANATION": "Im Planer finden Sie alle Aufgaben.",
        "CREATED_TIMESTAMP": "Erstellt am {{date}} Uhr",
        "CHANGED_TIMESTAMP": "Geändert am {{date}} Uhr",
        "REMOVED_TIMESTAMP": "Entfernt am {{date}} Uhr",
        "INITIATOR_SUFFIX": "von {{fullname}}",
        "INVALIDATION": {
            "INFO_TIMESTAMP": "am {{ invalidationTimestamp }}",
            "MARKED_AS_INVALID": "Als ungültig gekennzeichnet {{ text }}",
            "UPDATE_ERROR": "Beim Aktualisieren des Berichts ist ein Fehler aufgetreten."
        }
    },
    "KILOGRAMS": "kg",
    "KILOMETER": "km",
    "KIOSK": {
        "OPEN": "Kioskmodus öffnen",
        "SINGULAR": "Kioskmodus",
        "BACK_TO_CURRENT_WEEK": "zurück zu Heute",
        "ANNOUNCEMENT": {
            "CONTENT_ACTION_TITLE": "Haben Sie die Information vollständig angesehen?",
            "ANY_ITEM": "Es liegen keine Neuigkeiten für Sie vor.",
            "CLOSE_NOTIFICATION": "Neuigkeiten schließen",
            "FINISH_CONTENT": "Hier klicken, um die Information zu\n schließen",
            "NEXT_NOTIFICATION": "Nachfolgende Neuigkeit",
            "ANSWER_NO": "Hier klicken, \num \"Nein\" zu antworten.",
            "ANSWER_YES": "Hier klicken, \num \"Ja\" zu antworten.",
            "PREVIOUS_NOTIFICATION": "Vorherige Neuigkeit",
            "REPEAT_CONTENT": "Hier klicken,um die Information\n erneut anzuschauen",
            "START_CONTENT": "Hier klicken, um die \nInformationen abzuspielen"
        },
        "CHAT": {
            "ANY_NOTIFICATION": "Es liegen keine Nachrichten für Sie vor.",
            "CLOSE_NOTIFICATION": "Nachricht schließen",
            "EXPLANATION_TO_OPEN_DATA": "Ihnen wurde eine Datei übermittelt, die Sie mit einem Klick öffnen können:",
            "NEXT_NOTIFICATION": "Nachfolgende Nachricht",
            "NOTIFICATIONS": "Nachrichten",
            "PREVIOUS_NOTIFICATION": "Vorherige Nachricht"
        },
        "DELETE_ACCOUNT": "Gelöschtes Benutzerkonto",
        "EMITTER": "Absender",
        "PHONE": "Telefonnummer",
        "EMAIL": "Email",
        "SUCCESSES": "Erfolge",
        "YOUR_PROGRESS": "Ihr Fortschritt",
        "TASK": {
            "FINISHED_MODAL_TITLE": "Super! Sie haben es abgeschlossen!",
            "PLAY_INFORMATION": "Hier klicken, \num die Informationen abzuspielen.",
            "FINISH_TASK": "Hier klicken, um die \nSeite zu schließen.",
            "END": "Beenden"
        },
        "TRAINING": {
            "CHANGE_EXERCISE_ACTION_TITLE_DETAILS": "Haben Sie die Übung {{series}} x {{duration}} {{durationUnit}} ausgeführt?",
            "CHANGE_EXERCISE_ACTION_TITLE": "Haben Sie die Übung ausgeführt?",
            "CONCLUSION": {
                "FINISHED_ALL_EXERCISES": "Super! Sie haben es abgeschlossen!",
                "FINISHED_NONE_EXERCISES": "Schade! Sie haben alle Übungen ausgelassen!",
                "FINISHED_SOME_EXERCISES": "Super! Sie haben {{exercises}} von {{allExercises}} abgeschlossen!",
                "POSITIVE_FEEDBACK": "Prima, machen Sie so weiter!",
                "ALERT_FEEDBACK": "Uns ist aufgefallen, dass Sie einige Übungen als zu anstrengend empfanden.\n\nSollten Sie sich unwohl fühlen und Unterstützung benötigen, zögern Sie nicht Ihren Arzt zu kontaktieren!",
                "REINFORCED_FEEDBACK": "Sie können das Training jederzeit wieder starten und zu Ende bringen!",
                "START": "Übunganleitung starten"
            },
            "FEEDBACK": {
                "FEEDBACK_COMMENT_TITLE": "Bitte hinterlassen Sie einen Kommentar",
                "FEEDBACK_BORG_TITLE": "Wie anstrengend empfanden Sie die Übung?",
                "PERSONAL_ASSESSMENT": "Haben Sie eine persönliche Bewertung?",
                "SAVE": "Rückmeldung speichern",
                "VALUES_DEVIATION_MESSAGE": "Da Sie Abweichungen dokumentiert haben, begründen Sie dies bitte über Ihre persönliche Bewertung!",
                "VALUES_DEVIATION_QUESTION": "Gab es Abweichungen zur Vorgabe?"
            },
            "CONTINUE_EXERCISE": "Übung fortsetzen",
            "CONTINUE_TRAINING": "Training fortsetzen",
            "CONTINUE_EXERCISE_DESCRIPTION": "Hier klicken, \num diese Übung fortzusetzen",
            "CONTINUE_TRAINING_DESCRIPTION": "Hier klicken, \num dieses Training fortzusetzen",
            "EXERCISE_ACTION_TITLE": "Möchten Sie diese Übung wirklich auslassen?",
            "LEAVE_EXERCISE": "Übung auslassen",
            "LEAVE_TRAINING_DESCRIPTION": "Hier klicken,\num zurück zum Kalender \nzu gelangen",
            "LEAVE_EXERCISE_DESCRIPTION": "Hier klicken,\num diese Übung auszulassen",
            "NEXT_EXERCISE_DESCRIPTION": "Hier klicken,\num zur nächsten Übung zu wechseln",
            "PAUSE_TRAINING_ACTION_TITLE": "Möchten Sie das Training wirklich pausieren?",
            "PAUSE_TRAINING": "Training pausieren",
            "PAUSE_TRAINING_INFO_TOP": "Sie können das Training jederzeit pausieren und zu einem beliebigen Zeitpunkt fortsetzen.",
            "PAUSE_TRAINING_INFO_BOTTOM": "Denken Sie bitte daran, Ihr Training heute noch abzuschließen!",
            "REPEAT_EXERCISE_DESCRIPTION": "Hier klicken,\num die Anleitung erneut anzuschauen",
            "START_EXERCISE": "Übunganleitung starten",
            "START_TRAINING": "Training starten",
            "START_EXERCISE_DESCRIPTION": "Hier klicken, um die\n Anleitung zu starten.",
            "START_TRAINING_DESCRIPTION": "Hier klicken, um das\n Training zu starten",
            "FINISH_EXERCISE": "Hier klicken, um die\n Seite zu schließen.",
            "FINISH_INSTRUCTIONS": "Anleitung beenden",
            "HIDE_DETAILS": "Details ausblenden",
            "SHOW_DETAILS": "Details einblenden"
        },
        "WEEKLY_REPORT": {
            "ENDED": "Beenden",
            "START": "Start",
            "EXPLANATION": "Hier klicken, um die\nSeite zu schließen.",
            "TITLE": "Super! Sie haben letzte Woche {{count}} von {{total}} Sterne erreicht!"
        },
        "COURSE": {
            "JOIN_VIDEO_CONFERENCE": "Videoraum betreten",
            "JOIN_VIDEO_CONFERENCE_ADVICE": "Hier klicken, um an der Sitzung teilzunehmen",
            "LOCATION": "Veranstaltungsort"
        }
    },
    "KMH": "km/h",
    "KNOWLEDGE": {
        "PLURAL": "Wissen",
        "CASE_STUDIES": {
            "ANY_ITEMS": "Es liegen keine Erfahrungen vor."
        },
        "TECHNOLOGIES": {
            "ANY_ITEMS": "Es liegen keine Produkte vor."
        }
    },
    "KNOWLEDGE_MANAGER": "Wissensmanager",
    "LANGUAGE": "Sprache",
    "LAST_ACTIVITY_DATE": "Letzte Änderung",
    "LAST_NAME": "Nachname",
    "LAST_UPDATE": "Aktualisiert am",
    "LAST_ON": "Zuletzt am",
    "LATEST_POSSIBLE_EDIT": "Späteste Bearbeitung",
    "LEARNING": {
        "PLURAL": "Lerneinheiten",
        "SINGULAR": "Lernen",
        "START_LATER": "Diese Lerneinheit können Sie erst ab dem {{date}} bearbeiten.",
        "UNTIL_DEADLINE": "Sie können diese Lerneinheit bis zum {{date}} bearbeiten.",
        "EXERCISE": {
            "DELETE_ACTION": "Lerneinheitvorlagen löschen",
            "ITEM_DELETE_MODAL_TITLE": "{{title}} löschen",
            "ITEM_DELETE_MODAL_DESCRIPTION": "Die Daten werden unwiderruflich gelöscht.\nWenn Sie die Lerneinheitvorlagen „{{title}}“ löschen möchten, klicken Sie auf „Löschen"
        },
        "PLAN": {
            "ADD": "Lernpläne hinzufügen",
            "ANY_ASSIGN": "Es sind keine Lernpläne zugeordnet.",
            "ADD_SUCCESS_MESSAGE": "Lernplan wurde hinzugefügt.",
            "FETCH_FAILED": "Fehler beim Abrufen des Lernplans.",
            "PLURAL": "Lernpläne",
            "REMOVE": "Lernplan entfernen",
            "REMOVE_EXPLANATION": "Durch das Entfernen des Lernplans werden alle zugehörigen noch anstehenden Lerneinheiten entfernt. Sind Sie sicher, dass Sie fortfahren möchten?",
            "REMOVE_SUCCESS_MESSAGE": "Lernplan wurde entfernt."
        },
        "MODULE": {
            "PLURAL": "Lernen",
            "SINGULAR": "Lernen"
        },
        "TEMPLATE": {
            "START_AS_DAY": "Start (Tag)",
            "END_AS_DAY": "Ende (Tag)",
            "CREATE": "Lernplanvorlage erstellen",
            "DELETE": "Lernplanvorlage löschen",
            "ITEM": {
                "ADD": "Lerneinheitvorlagen hinzufügen",
                "PLURAL": "Lerneinheitvorlagen",
                "SELECT": "Lerneinheitvorlage wählen",
                "SINGULAR": "Lerneinheitvorlage",
                "ANY_ITEM": "Es liegen keine Lerneinheitvorlage vor."
            },
            "NONE": "Keine Lernplanvorlagen vorhanden",
            "ADD": "Lernplanvorlage hinzufügen",
            "OPEN": "Lernplanvorlage öffnen",
            "REMOVE": "Lernplanvorlage löschen",
            "ANY_ITEM": "Es liegen keine Lernplanvorlagen vor.",
            "PLURAL": "Lernplanvorlagen",
            "SELECT": "Lernplanvorlage wählen",
            "SINGULAR": "Lernplanvorlage",
            "GET_ERROR_MESSAGE": "Beim Abrufen der Lernplanvorlage ist ein Fehler aufgetreten."
        },
        "ADVANCEMENT": "Fortschritt",
        "APPOINTMENT": {
            "DELETE_ERROR_MESSAGE": "Beim Löschen des Bearbeitungszeitraums ist ein Fehler aufgetreten.",
            "SET": "Bearbeitungszeitraum festlegen",
            "SET_ERROR_MESSAGE": "Beim Anlegen des Bearbeitungszeitraums ist ein Fehler aufgetreten.",
            "REMINDER_START_DATE": "Erinnerung zur frühesten Bearbeitungszeit",
            "REMINDER_DUE_DATE": "Erinnerung zum Ablauf der Fälligkeit",
            "REMINDER_END_DATE": "Erinnerung zur spätesten Bearbeitungszeit"
        },
        "LESSONS": "Lektionen",
        "ACTION_CANCEL": "Lerneinheit abbrechen"
    },
    "LEARNING_SAVE_SUCCESS_MESSAGE": "Die Lerneinheit wurde erfolgreich gespeichert.",
    "LEARNING_SAVE_FAILURE_MESSAGE": "Beim Speichern der Lerneinheit ist ein Fehler aufgetreten.",
    "LEVEL": "Stufe",
    "LIGHT": "Hell",
    "LOADING": {
        "DATA_IS_BEING_CREATED": "Daten werden erstellt.",
        "DATA_IS_BEING_DELETED": "Daten werden gelöscht.",
        "DATA_IS_BEING_SAVED": "Daten werden gespeichert.",
        "DATA_IS_BEING_UPDATED": "Daten werden aktualisiert.",
        "DATA_IS_LOADING": "Daten werden geladen."
    },
    "true": "Ja",
    "false": "Nein",
    "LOCATION": "Ort",
    "LOCKED": "Gesperrt ",
    "LOGIN": "Anmelden",
    "LOGIN_ERROR": {
        "TITLE": "Ups, es ist etwas schiefgelaufen.",
        "CHECK_CONNECTION": "Bitte prüfen Sie Ihre Internetverbindung.",
        "RETRY": "Erneut versuchen"
    },
    "LOGIN_FAILED": "Anmeldung fehlgeschlagen",
    "LOGOUT": "Abmelden",
    "LOOSE": "Locker",
    "M": "Männlich",
    "MAIN_GOAL": "Hauptziel",
    "MAIN_INFORMATION": "Allgemeine Daten",
    "MALE": "Männlich",
    "manage_course_and_meeting": "Kurse/Sitzungen bearbeiten",
    "MANUAL": {
        "SINGULAR": "Manual",
        "CONCEPT": "Konzept"
    },
    "MAIN_CONFIGURATION": "Einstellungen",
    "MARITAL_STATUS": "Familienstand",
    "MARK_AS_INVALID": "Als ungültig kennzeichnen",
    "MARK_AS_VALID": "Als gültig kennzeichnen",
    "MEASUREMENT_MARK": {
        "MARK_AS_AUDITED": "Als geprüft kennzeichnen",
        "MARK_AS_OPEN": "Als offen kennzeichnen",
        "MARK_AS_TRACKING": "Zur Nachverfolgung kennzeichnen"
    },
    "MEASUREMENTS": "Messungen",
    "MEASUREMENT_PLAN": "Messungen",
    "MEASUREMENT": {
        "VITAL": {
            "PLURAL": "Vitaldaten"
        },
        "SINGULAR": "Messung",
        "PLURAL": "Messungen",
        "RECORD": "Messung erfassen",
        "ANY": "Es liegen keine Messungen vor.",
        "CHART": {
            "ERROR": "Die Messungen konnten nicht geladen werden.",
            "SHOW": "Verlauf anzeigen",
            "HIDE": "Verlauf ausblenden"
        },
        "DATE": "Messdatum",
        "NOTES": "Anmerkungen",
        "NORM_VALUES": {
            "PLURAL": "Normwerte",
            "ANY": "Es liegen Keine Normwerte vor'"
        },
        "SAVE": "Die Messungen wurden gespeichert."
    },
    "MEDFLEX": "Medflex",
    "MEDIA": {
        "ADD": "Medium hinzufügen",
        "ADD_VIDEO_LINK": "Video-Link hinzufügen",
        "ERROR": {
            "ANY": "Beim Hochladen der Datei {{title}} ist ein Fehler aufgetreten.",
            "FILE_SIZE": "Die Datei {{title}} ist zu groß. Maximale Dateigröße 500 MB.",
            "MIME_TYPE": "Das Format der Datei {{title}} wird nicht unterstützt.",
            "QUEUE_LIMIT": "Datei {{title}} wurde nicht hochgeladen, es kann nur eine Datei gleichzeitig hochgeladen werden"
        },
        "EARMARKED": "Vorgemerkt",
        "NONE": "Keine Medien vorhanden",
        "PLURAL_LATIN": "Medium",
        "PLURAL": "Medien",
        "ACTIVE": "Medien (Aktiv)",
        "FINISHED": "Medien (Abgeschlossen)",
        "NO_SHOW": "Medien (Abgelaufen)",
        "CANCELED": "Medien (Abgebrochen)"
    },
    "MEDICAL_HISTORY": {
        "ADD_FILES": "Unterlage hochladen",
        "ALLERGIES": "Allergien",
        "ALL_FILES": "Allgemeine Unterlagen",
        "DIAGNOSES": "Diagnosen",
        "HEIGHT": "Körpergröße",
        "ANAMNESE_NEEDED": "Nach dem Erstellen einer Anamnese können Unterlagen hochgeladen werden.",
        "MEDICAL_CONTENTS": "Medizinische Unterlagen",
        "MEDICATION": "Medikation",
        "NOTES": "Besonderheiten",
        "SINGULAR": "Anamnese",
        "SYMPTOMS": "Symptome",
        "ERROR": {
            "UPLOAD": "Beim Hochladen der Datei {{}} ist ein Fehler aufgetreten.",
            "FILE_SIZE": "Die Datei {{title}} ist zu groß. Maximale Dateigröße 500 MB.",
            "MIME_TYPE": "Das Format der Datei {{title}} wird nicht unterstützt.",
            "QUEUE_LIMIT": "Datei {{title}} wurde nicht hochgeladen, es kann nur eine Datei gleichzeitig hochgeladen werden",
            "ANY": "Beim Hochladen der Datei {{title}} ist ein Fehler aufgetreten."
        }
    },
    "MEDICAL_REQUIREMENTS": "Medizinische Voraussetzungen",
    "MEDICATION": {
        "SINGULAR": "Medikation",
        "ANY_ITEM": "Es liegen keine Medikationsinformationen vor.",
        "ADD_MEDICATION": "Medikation hinzufügen",
        "ACTIVE_AGENT": "Wirkstoff",
        "TRADE_NAME": "Handelsname",
        "STRENGTH": "Stärke",
        "FORM": "Darreichungsform",
        "DOSING_REGIMEN": "Dosierschema",
        "CONSUMPTION_FREQUENCY_IN_DAYS": "Einnahme alle n Tage",
        "UNIT": "Dosiereinheit",
        "NOTE": "Hinweise",
        "REASON": "Grund",
        "IS_SELF_MEDICATION": "Selbstmedikation",
        "IS_CONSUMED_AT_SPECIFIC_TIMES": "Zu besonderen Zeiten anzuwenden",
        "DISCONTINUE_MEDICATION": "Medikation absetzen",
        "CONTINUE_MEDICATION": "Medikation aufnehmen",
        "PAUSE_MEDICATION": "Medikation pausieren",
        "FETCH_ERROR": "Beim Abrufen der Medikation ist ein Fehler aufgetreten.",
        "EDIT_ERROR": "Beim Bearbeiten der Medikation ist ein Fehler aufgetreten.",
        "EDIT_SUCCESS": "Der Eintrag wurde erfolgreich aktualisiert.",
        "CREATE_SUCCESS": "Der Eintrag wurde erfolgreich angelegt.",
        "ALREADY_EXIST_ERROR": "Dieser Medikationsstaus ist bereits gesetzt.",
        "CREATOR": "Erfasser",
        "CHANGED_DATE": "Änderungsdatum",
        "STATE_ACTIVE": "Aktiv",
        "STATE_PAUSED": "Pausiert",
        "STATE_DISCONTINUED": "Abgesetzt"
    },
    "METER": "m",
    "MINUTES": "Min",
    "MISS": "Frau",
    "MISSED": "Verpasst",
    "MISSION": "Auftrag",
    "MISTER": "Herr",
    "MOBILE_PHONE": "Mobiltelefonnummer",
    "MONTH": "Monat",
    "MODULE": {
        "PLURAL": "Module",
        "SINGULAR": "Modul",
        "SHOW_ONLY_SELECTED": "Nur diese Module anzeigen"
    },
    "MWT": {
        "6MWT": "6 Minuten Gehtest",
        "DATE": "Messdatum (Startzeit)",
        "TOTAL_STEPS": "Schritte (Gesamtzeit)",
        "DISTANCE": "Distanz",
        "INSTRUCTIONS": {
            "READY": {
                "INFO_1": "Um die Messung zu starten, klicken Sie auf “Daten erfassen.”",
                "INFO_2": "Danach haben Sie 30 Sekunden um Ihr Smartphone wie auf dem Bild an der Hüfte zu befestigen.",
                "INFO_3": "Achten Sie darauf, dass Sie die Position des Smartphones während der Messung nicht verändern. Ein Signalton kündigt Ihnen Anfang und Ende der Messung an."
            },
            "STARTED": {
                "INFO_1": "Sie haben 30 Sekunden zur Vorbereitung.",
                "INFO_2": "Die Datenerfassung startet in"
            },
            "RUNNING": "Datenerfassung läuft genau 6 Minuten und endet automatisch mit einem Signalton.",
            "FINISHED": "Ergebnisse der Datenerfassung",
            "FAILED": {
                "INFO_1": "Die Messung konnte nicht erfolgreich durchgeführt werden.",
                "INFO_2": "Dies kann verschiedene Gründe haben.",
                "INFO_3": "Bewegen Sie sich möglichst auf einer geraden und ebenen Strecke",
                "INFO_4": "Vermeiden Sie Treppen oder Kurven",
                "INFO_5": "Beenden Sie die Messung erst, wenn Sie den Signalton hören",
                "INFO_6": "Bitte starten sie die Datenerfassung erneut."
            }
        },
        "RECORD_MEASUREMENT": "Messung erfassen",
        "SAVE_MEASUREMENT": "Messung speichern",
        "SECONDS": "Sekunden",
        "START_MEASUREMENT": "Daten erfassen",
        "STATE": {
            "UNCONNECTED": "Sensor ist nicht verbindbar",
            "READY": "Sensor ist verbunden",
            "STARTED": "Datenerfassung wird gestartet",
            "RUNNING": "Datenerfassung läuft",
            "FINISHED": "Datenerfassung abgeschlossen",
            "FAILED": "Datenerfassung fehlgeschlagen"
        },
        "STEPS": "Schritte",
        "TOTAL_TIME": "Gesamtzeit"
    },
    "Mon": "Montag",
    "MINIMAL_MODE": "Minimalmodus",
    "MY": "Meine",
    "MY_PATIENTS": "Alle mir zugeordneten Patienten",
    "NAME": "Name",
    "NATIONALITY": "Staatsangehörigkeit",
    "NAVIGATE_TO_THERAPY_TEMPLATE": "Zur Kursvorlage",
    "NEXT_BUTTON": "Weiter",
    "NO": "Nein",
    "NONE": "Keine Angabe",
    "NONE_SELECTED": "Keine Angabe",
    "NOTE": {
        "ADD": "Notiz hinzufügen",
        "CREATE": "Notiz erstellen",
        "CREATE_TITLE": "Neue Notiz",
        "PLURAL": "Notizen",
        "SINGULAR": "Notiz",
        "ACTION_DELETE": "Notiz löschen",
        "ACTION_ADD": "Notiz eintragen",
        "ACTION_TRACK": "Zur Nachverfolgung kennzeichnen",
        "ACTION_UNTRACK": "Kennzeichnung entfernen",
        "IS_TRACKED": "Zur Nachverfolgung gekennzeichnet",
        "IS_NOT_TRACKED": "Nicht zur Nachverfolgung gekennzeichnet",
        "TRACKING": "Nachverfolgung",
        "ANY": "Es liegen keine Notizen vor.",
        "NOTE_SAVE_IN_PROGRESS": "Notiz wird gespeichert",
        "CREATE_SUCCESS": "Die Notiz wurde erfolgreich angelegt.",
        "UPDATE_SUCCESS": "Die Notiz wurde erfolgreich aktualisiert.",
        "UPDATE_ERROR": "Beim Bearbeiten der Notiz ist ein Fehler aufgetreten.",
        "DELETE_PROMPT": "Sind Sie sicher, dass Sie die Notiz löschen wollen?",
        "DELETE_SUCCESS": "Die Notiz wurde gelöscht.",
        "DELETE_ERROR": "Beim Löschen der Notiz ist ein Fehler aufgetreten.",
        "UPDATED_AT": "Änderungs-\ndatum"
    },
    "NOTIFICATIONS": "Nachrichten",
    "NOT_PLANNED": "Sitzung nicht festgelegt",
    "NOT_SET": "—",
    "NO_ALTERNATIVE_APPOINTMENT_EXERCISE": "Keine alternativen Sitzungsvorlagen ausgewählt.",
    "NO_ALTERNATIVE_COURSE_EXERCISE": "Keine alternativen Sitzungsvorlage ausgewählt",
    "NO_CATEGORY": "Keine Kategorie",
    "NO_COMMENT": "Keine Anmerkung",
    "NO_CHARACTERISTICS": "Es liegen keine Tags vor.",
    "NO_CONSULTATIONS_AVAILABLE": "Keine Konsile vorhanden",
    "NO_CONSULTATION_EVENTS_AVAILABLE": "Keine Konsilevents vorhanden",
    "NO_CONSULTATION_USERS_AVAILABLE": "Keine Konsiliarärzte vorhanden",
    "NO_CONTENT_AVAILABLE": "Keine Aufnahmen vorhanden",
    "NO_DOCUMENTS_AVAILABLE": "Keine Dokumente vorhanden",
    "NO_QUESTIONNAIRE_AVAILABLE": "Keine Formulare vorhanden",
    "NO_FORM_SELECTED": "Kein Formular",
    "NO_INFORMATION": "Keine Angabe",
    "NO_MEDICAL_REQUIREMENTS": "Es gibt keine medizinischen Voraussetzungen.",
    "NO_PATIENTS_AVAILABLE": "Keine Patienten vorhanden",
    "NO_PLAN_TEMPLATE_AVAILABLE": "Keine Planvorlagen vorhanden",
    "NO_SHOW": "Nicht teilgenommen",
    "NUMBERING_FREE_PLACES": "Anzahl freier Plätze",
    "OFFLINE_SYNC": {
        "START": "Offline-Synchronisation starten"
    },
    "OPAQUE": "Undurchsichtig",
    "OPEN": "Offen ",
    "OPENED": "Eröffnet",
    "OPEN_ARTICULATE_COURSE_BUTTON": "Lerneinheit öffnen",
    "OPEN_CHAT": "Chat öffnen",
    "OPEN_FORM_FAILURE": "Beim Öffnen des Formulars ist ein Fehler aufgetreten.",
    "OPEN_HOME_PAGE": "Übersicht öffnen",
    "OPEN_LERNEN": "Lerneinheit öffnen",
    "OPEN_REPORT": "Bericht öffnen",
    "OPEN_WEBSITE": "Webseite öffnen",
    "OPERATING_SITE": "Betriebsstätte",
    "ORDER": {
        "CHOOSE_FORM": "Formular wählen",
        "CHOOSE_PATIENT": "Patient wählen",
        "CREATE_PATIENT": "Patient anlegen",
        "FORM": "Formular",
        "MODIFY_PATIENT": "Patient bearbeiten",
        "JUSTIFY_INDICATION": "Rechtfertigende Indikation",
        "APPROVE_JUSTIFY_INDICATION": "Liegt eine rechtfertigende Indikation vor?",
        "REQ_MET": "Erfüllt",
        "REQ_NOT_MET": "Nicht erfüllt",
        "RELEASE_DATE": "Datum Freigabe",
        "RELEASE_BY": "Freigabe von",
        "PLURAL": "Aufträge",
        "CONFIGURATION": "Einstellungen für Aufträge",
        "MAKE_CHECKS": "Durchzuführende Untersuchungen",
        "PERFORMANCE_QUERY": {
            "LABEL": "Leistungsanfrage *",
            "ERROR": "Leistungsanfrage benötigt"
        },
        "ANY": "Es liegen keine Aufträge vor.",
        "QUESTIONNAIRE": {
            "ANY_ITEMS": "Es liegen keine Formulare vor."
        },
        "DATA_SAVE": "Daten gespeichert",
        "REQUESTED": "Anfrage gesendet",
        "ACCEPTED": "Anfrage angenommen",
        "EXAMINATION_FINISHED": "Untersuchung abgeschlossen",
        "FINDING_CREATED": "Befund erstellt",
        "FINDING_APPROVED": "Befund freigegeben",
        "FINDING_REOPENED": "Befund wieder geöffnet",
        "FINDING_IN_EDIT": "Befund wieder in Bearbeitung",
        "CLOSURE_CONFIRMED": "Schließung bestätigt",
        "DECLINED": "Auftrag abgelehnt",
        "REVOKED": "Auftrag widerrufen",
        "DELETED": "Auftrag gelöscht",
        "CANCELLED": "Auftrag abgebrochen",
        "REOPENED": "Auftrag wieder geöffnet",
        "DECLINE_ACTION": {
            "TITLE": "Auftrag ablehnen",
            "DESCRIPTION": "Sind Sie sicher, dass Sie diesen Auftrag ablehnen möchten?"
        },
        "REVOKE_ACTION": {
            "TITLE": "Auftrag widerrufen",
            "DESCRIPTION": "Sind Sie sicher, dass Sie diesen Auftrag widerrufen möchten?"
        },
        "DELETE_ACTION": {
            "TITLE": "Auftrag löschen",
            "DESCRIPTION": "Sind Sie sicher, dass Sie diesen Auftrag löschen möchten?"
        },
        "CANCEL_ACTION": {
            "TITLE": "Auftrag abbrechen",
            "DESCRIPTION": "Sind Sie sicher, dass Sie diesen Auftrag abbrechen möchten?"
        },
        "JUSTIFYING_INDICATION": "Rechtfertigende Indikation",
        "CLIENT_SERVICE_LABEL": "Anforderbare Leistungen (Auftragnehmer)",
        "CLIENT_SERVICE_TOOLTIP": "Anforderbare Leistungen, die der Auftragnehmer dem Auftraggeber zuweisen kann.",
        "PROVIDER_SERVICE_LABEL": "Anforderbare Leistungen (Auftraggeber)",
        "PROVIDER_SERVICE_TOOLTIP": "Anforderbare Leistungen, die der Auftraggeber dem Auftragnehmer zuweisen kann.",
        "ERROR": {
            "PROVIDER_SETTINGS": "Beim Abrufen der Einstellungen des Auftragnehmers ist ein Fehler aufgetreten.",
            "REQUEST": "Beim Senden der Anfrage ist ein Fehler aufgetreten.",
            "ACCEPT": "Beim Annehmen der Anfrage ist ein Fehler aufgetreten.",
            "FINISH_EXAMINATION": "Beim Abschließen der Untersuchung ist ein Fehler aufgetreten.",
            "CREATE_FINDING": "Beim Erstellen des Befunds ist ein Fehler aufgetreten.",
            "APPROVE_FINDING": "Beim Freigeben des Befunds ist ein Fehler aufgetreten.",
            "REOPEN_FINDING": "Beim Wiederöffnen des Befunds ist ein Fehler aufgetreten.",
            "CONFIRM_CLOSURE": "Beim Bestätigen der Schließung ist ein Fehler aufgetreten.",
            "DECLINE": "Beim Ablehnen des Auftrags ist ein Fehler aufgetreten.",
            "REVOKE": "Beim Widerrufen des Auftrags ist ein Fehler aufgetreten.",
            "DELETE": "Beim Löschen des Auftrags ist ein Fehler aufgetreten.",
            "CANCEL": "Beim Abbrechen des Auftrags ist ein Fehler aufgetreten.",
            "REOPEN": "Beim Wiederöffnen des Auftrags ist ein Fehler aufgetreten.",
            "DATA_SAVE": "Beim Speichern der Daten ist ein Fehler aufgetreten.",
            "PERFORMANCE_REQ_ANY": "Die Auftragnehmer Gruppe hat Leistungsanforderungen aktiviert, aber keine auswählbaren Leistungen definiert.",
            "NO_PERFORMANCE_REQ": "Keine Leistungsanforderung vorhanden.",
            "DUPLICATE_CASE_NUMBER_IN_GROUP": "Speichern fehlgeschlagen. Für diesen Auftraggeber existiert bereits ein anderer Auftrag mit der angegebenen Fallnummer."
        },
        "TOOLTIP": {
            "ENABLE_CENTRAL_FACILITY": "Alle Teilnehmer der Gruppe können Aufträge sehen und bearbeiten. Diese Gruppe kann beim Auftrag als Auftraggeber ausgewählt werden.",
            "ENABLE_COOPERATION_FACILITY": "Alle Teilnehmer der Gruppe können Aufträge sehen und anfragen.",
            "INDICATION_ACTIVATION": "Bei der Annahme eines Aufrags erfolgt eine Abfrage, ob eine rechtfertigende Indikation vorliegt.",
            "SERVICE_ACTIVATION": "Bei der Annahme eines Auftrags erfolgt eine Abfrage, welche Leistungen angefordert werden sollen."
        }
    },
    "ORDER_CANCELED": "Auftrag\nabgebrochen",
    "ORDER_CREATED": "Auftrag\nerstellen",
    "ORDER_DECLINED": "Auftrag\nabgelehnt",
    "ORDER_DELETED": "Auftrag\ngelöscht",
    "ORDER_FINISHED": "Auftrag\nabgeschlossen",
    "ORDER_REVOKED": "Auftrag\nwiderrufen",
    "ORDER_SUBJECT": "Fragestellung",
    "ORGANISATION_MANAGEMENT": {
        "ORGANISATION": {
            "SINGULAR": "Organisation",
            "PLURAL": "Organisationen",
            "DELETE": "Organisation löschen",
            "ANY_ITEM": "Es liegen keine Organisationen vor."
        },
        "GROUP": {
            "CHOOSE": "Gruppe wählen",
            "SINGULAR": "Gruppe",
            "PLURAL": "Gruppen",
            "DELETE": "Gruppe löschen",
            "ANY_ITEM": "Es liegen keine Gruppen vor.",
            "ADD_ACTION": "Gruppe hinzufügen"
        },
        "TENANT": {
            "SINGULAR": "Mandant",
            "PLURAL": "Mandanten",
            "DELETE": "Mandant löschen",
            "ANY_ITEM": "Es liegen keine Mandanten vor."
        }
    },
    "OTHERS": "Sonstiges",
    "OTOSCOPE": "Otoskop",
    "O_CLOCK": "Uhr",
    "PACE": "Tempo",
    "PAGE_NOT_FOUND": "Seite nicht gefunden",
    "PARTICIPANTS": "Teilnehmer",
    "PASSWORD": "Passwort",
    "PATIENT": "Patient",
    "PATIENT_ACCOUNT": "Stammdaten",
    "PATIENT_CANCELLED": "Sitzung vom Patient abgesagt",
    "PATIENT_CREATED_FAILURE_MESSAGE": "Anlegen des Patienten fehlgeschlagen",
    "PATIENT_CREATED_SUCCESS_MESSAGE": "Patient {{firstname}} {{lastname}} wurde erfolgreich angelegt",
    "PATIENT_DELETED_FAILURE_MESSAGE": "Fehler beim Löschen des Patienten",
    "PATIENT_DELETED_SUCCESS_MESSAGE": "Patient wurde gelöscht",
    "PATIENT_ID": "Patienten ID",
    "PATIENT_INFORMATION": "Patienteninformationen",
    "PATIENT_IS_INVITED": "Patient ist eingeladen",
    "PATIENT_IS_NOT_INVITED": "Patient ist nicht eingeladen",
    "PATIENT_LIST": {
        "COLUMN": {
            "ADD": "Spalte hinzufügen",
            "ADD_CUSTOM": "Benutzerdefinierte Spalte hinzufügen",
            "CUSTOM_COLUMNS": "Benutzerdefinierte Spalten",
            "CUSTOM_PROPERTY": "Dynamisches Stammdatum",
            "DATE_FORMAT": "Datumsformat",
            "DATE_FORMAT_NONE": "Ohne",
            "MAX_LINES": "Maximale Zeilenanzahl",
            "NONE": "Keine benutzerdefinierten Spalten vorhanden",
            "PIXEL_UNIT": "Pixel",
            "TYPE": {
                "CHAT": "Chat",
                "CUSTOM_PROPERTY": "Dynamische Stammdaten",
                "QUESTIONNAIRE": "Formularantworten",
                "TAGS": "Tags",
                "TASK": "Aufgaben",
                "TRAINING_FLAGS": "Trainings-Flaggen",
                "USER_PROPERTY": "Stammdaten",
                "RANDOMIZED_GROUP": "Randomisierungsgruppen",
                "QUESTIONNAIRE_FIELD": "Feldwerte"
            },
            "USER_PROPERTY": "Stammdatum",
            "WIDTH": "Spaltenbreite"
        },
        "CONFIGURATION": {
            "COPY_TO_CLIPBOARD": "Patientenlistendefinition in die Zwischenablage kopiert",
            "CREATE": "Konfiguration erstellen",
            "CREATE_NEW": "Neue Konfiguration erstellen",
            "DEFAULT": "Standard",
            "DELETE": "Patientenlistenkonfiguration entfernen",
            "DELETE_WARN": "Sie Entfernen die Patientenlistenkonfiguration: {{configName}}.\n\nSind Sie sicher, dass Sie fortfahren möchten?",
            "MESSAGE": {
                "DELETE_ERROR": "Fehler beim Löschen der Patientenlistenkonfiguration.",
                "DELETE_SUCCESS": "Patientenlistenkonfiguration erfolgreich entfernt.",
                "LOAD_ERROR": "Fehler beim Laden der Patientenlistenkonfiguration.",
                "SAVE_ERROR": "Beim speichern der Konfiguration ist ein Fehler aufgetreten.",
                "SAVE_SUCCESS": "Konfiguration wurde erfolgreich gespeichert."
            },
            "NAME": "Name",
            "NAME_PLACEHOLDER": "Name hinzufügen",
            "NEW": "Neue Konfiguration",
            "PAGINATION": "Pagination",
            "PLURAL:": "Listenkonfigurationen:",
            "SINGULAR": "Patientenlistenkonfiguration",
            "UPDATE": "Änderungen speichern"
        },
        "LEGEND": {
            "ADD_ITEM": "Legendeneintrag hinzufügen",
            "COLOR": "Farbe",
            "ICON": "Icon",
            "NONE": "Keine Legendeneinträge vorhanden",
            "SELECT_ICON": "Icon auswählen",
            "TEXT": "Text",
            "TITLE": "Legende"
        }
    },
    "PATIENT_NUMBER": "Benutzer-ID",
    "PATIENT_OVERVIEW_TITLE": "Patientenübersicht",
    "CREATE_PATIENT_REPORT": "Bericht erstellen",
    "PATIENT_UPDATED_FAILURE_MESSAGE": "Fehler beim Aktualisieren des Patienten",
    "PATIENT_UPDATED_SUCCESS_MESSAGE": "Patient erfolgreich aktualisiert",
    "PAYMENT_WEBSHOP": "Zahlung",
    "PENDING": "Anstehend",
    "PERSON": "Personenbezogene Daten",
    "PERSONAL_INFORMATION": "Persönliche Daten",
    "PHONE": "Telefonnummer",
    "PICTURE_PREVIEW": "Vorschaubild",
    "PLANNED": "Sitzung veröffentlicht",
    "PLANNED_ADJECTIVE": "Geplant",
    "PLAN_DESIGNATION": "Planbezeichnung",
    "PLEASE_SELECT": "Bitte auswählen",
    "POSTAL_CODE": "Postleitzahl",
    "POSTPONED": "Sitzung verschoben",
    "PREPARATION": "Vorbereitung",
    "PREVIOUS_EXERCISE_SESSION": "Vorherige Trainingsvorgabe",
    "PREVIOUS_VERSION": "Vorgängerversionen",
    "PRICE": "Preis",
    "PROCESSING_FILE": "{{filename}} wird verarbeitet...",
    "PRODUCT": {
        "ALL": "Alle Produkte",
        "PLURAL": "Produkte",
        "SINGULAR": "Produkt"
    },
    "PROFILE_TITLE": "Profil",
    "PROGRAM": {
        "ADD": "Programm hinzufügen",
        "ANY_ITEM": "Es liegen keine Programme vor.",
        "FETCH_FAILED": "Fehler beim Abrufen der Programme.",
        "REMOVE_EXPLANATION": "Durch das Entfernen des Programms werden alle zugehörigen noch anstehenden Elemente entfernt. Sind Sie sicher, dass Sie fortfahren möchten?",
        "REMOVE_SUCCESS_MESSAGE": "Programm wurde entfernt.",
        "REMOVE_ERROR": "Beim Entfernen des Programms ist ein Fehler aufgetreten.",
        "NO_WRITE_ACCESS": "Sie sind nicht berechtigt Programme zu editieren",
        "ACTION": {
            "OPEN_DETAIL": "Programm öffnen",
            "DELETE": "Programm entfernen"
        },
        "ALL": "Alle Programme",
        "PLURAL": "Programme",
        "SINGULAR": "Programm",
        "TEMPLATE": {
            "ANY_ITEM": "Es liegen keine Programmvorlagen vor.",
            "CREATE": "Programmvorlage erstellen",
            "NONE": "Keine Programmvorlagen vorhanden",
            "PLURAL": "Programmvorlagen",
            "SELECT": "Programmvorlage wählen",
            "SINGULAR": "Programmvorlage",
            "DELETE": "Programmvorlage löschen",
            "GET_ERROR_MESSAGE": "Beim Abrufen der Programmvorlage ist ein Fehler aufgetreten.",
            "DELETE_WITH_TITLE": "{{title}} löschen",
            "DELETE_DESCRIPTION": "Die Programmvorlage wird unwiderruflich gelöscht. Wenn Sie die Programmvorlage „{{title}}“ dennoch löschen möchten, klicken Sie auf „Löschen“.",
            "DELETE_SUCCESS": "Die Programmvorlage wurde erfolgreich gelöscht.",
            "DELETE_ERROR": "Beim Löschen der Programmvorlage ist ein Fehler aufgetreten.",
            "START_AS_DAY": "Start (Tag)",
            "SET_START_DAY": "Starttag festlegen",
            "START_DAY_HINT": "Tag 1 ist der Starttag des Programms."
        },
        "PLAN": {
            "ADD_SUCCESS_MESSAGE": "Program wurde hinzugefügt."
        },
        "ENDED": "Programm beenden",
        "DESCRIPTION_SHORT": "Beschreibung (kurz)",
        "EXPLANATION_FOR_CAREGIVER": "Hinweise für Betreuer",
        "START_DATE": "Startdatum",
        "END_DATE": "Enddatum",
        "WORKING_STATUS": "Bearbeitungsstatus",
        "SHOW_DUE_DATE": "Fälligkeit für Patienten anzeigen",
        "MEDIA_SIZE_TIP": "Tipp: Als Bildgröße ist 960x540 px bzw. ein Seitenverhältnis von 16:9 optimal für die Darstellung."
    },
    "PROGRAM_DETAIL_PAGE_TITLE": "Programm",
    "PROGRAM_DETAIL_PAGE_TITLE_NEW": "Programm erstellen",
    "PROVIDER_NAME": "Auftragnehmer",
    "PSEUDONYM": "Pseudonym",
    "PSEUDONYMIZED": "Pseudonymisierung",
    "PULL_TO_REFRESH": "",
    "PULSE": "Puls",
    "PULSE_BPM": "Puls (bpm)",
    "PURULENT": "Eitrig",
    "PAGINATION": {
        "PREVIOUS_PAGE": "Vorherige Seite",
        "NEXT_PAGE": "Nächste Seite"
    },
    "QUESTIONNAIRE": {
        "SINGULAR": "Formular",
        "PLURAL": "Formulare",
        "CONDITION": {
            "AND": "UND",
            "OR": "ODER",
            "SINGULAR": "Abhängigkeit",
            "PLURAL": "Abhängigkeiten",
            "ADD": "Abhängigkeit hinzufügen",
            "GROUP_ADD": "Gruppe hinzufügen"
        },
        "QUESTION": "Frage",
        "SELECT_QUESTION": "Frage auswählen",
        "SELECT_ANSWER": "Antwort auswählen",
        "RESPONSE": {
            "EMPTY": "Es wurden keine Angaben im Formular eingegeben."
        },
        "TYPE": {
            "DRAWING": "Zeichnung",
            "SIGNATURE": "Unterschrift"
        },
        "FILE": {
            "PICK": "Datei auswählen",
            "UPLOADING": "Wird hochgeladen..."
        }
    },
    "RECEIVER": "Empfänger",
    "RED": "Rot",
    "REFRESHING": "",
    "REGISTER": "Registrieren",
    "RELAXATION": "Entspannung",
    "REMINDER_EARLIEST_POSSIBLE_EDIT": "Erinnerung zur frühesten Bearbeitungszeit",
    "REMINDER_LATEST_POSSIBLE_EDIT": "Erinnerung zur spätesten Bearbeitungszeit",
    "REMINDER_PAST_DUE": "Erinnerung zum Ablauf der Fälligkeit",
    "REMOVE_TEMPLATE_FAILURE_MESSAGE": "Beim Entfernen der Vorlage ist ein Fehler aufgetreten.",
    "REMOVE_TEMPLATE_SUCCESS_MESSAGE": "Die Vorlage wurde erfolgreich entfernt.",
    "REOPEN_CONSULTATION_BUTTON": "Konsil wieder öffnen",
    "REOPEN_FINDINGS": "Befund wieder öffnen",
    "REOPEN_ORDER": "Auftrag wieder öffnen",
    "REOPEN_ORDER_REQUEST": "Anfrage wieder öffnen",
    "REPEAT": "Wiederholen",
    "REPETITIONS": "Wdh",
    "REPETITIONS_LABEL": "Wiederholungen",
    "REPLACED": "Alternativen Sitzung festgelegt",
    "REPORT": {
        "SINGULAR": "Bericht",
        "PLURAL": "Berichte",
        "CREATE": {
            "HIDE_CREATOR": "Nicht verwenden",
            "SHOW_CREATOR": "Verwenden"
        },
        "FOOTER": "Footer",
        "FOOTER_TOOLTIP": "Bilder sollten mindestens 1240px breit und dreimal so breit wie hoch sein",
        "HEADER": "Header",
        "HEADER_TOOLTIP": "Bilder sollten mindestens 1240px breit und dreimal so breit wie hoch sein",
        "SIGNATURE": "Unterschrift",
        "SIGNATURE_TOOLTIP": "Empfohlene Bildauflösung 640x267px",
        "VISIBILITY_TO_PATIENT": "Sichtbarkeit für Patienten",
        "VISIBILITY_TOOLTIP": "Der erstellte Bericht wird dem Patienten im Patientenplaner angezeigt.",
        "TEMPLATE": {
            "ANY_ITEM": "Es liegen keine Berichtsvorlagen vor.",
            "SELECT": "Berichtsvorlage auswählen"
        },
        "DATA_CATEGORIES": "Datenkategorien",
        "SELECT_DATA_CATEGORIES": "Datenkategorien auswählen",
        "QUESTIONNAIRES": "Formulare",
        "SELECT_QUESTIONNAIRES": "Formulare auswählen",
        "DISPLAY_LETTER_SUBJECT": "Betreff im Bericht anzeigen",
        "DISPLAY_PATIENT_REFERENCE": "Patientenreferenz im Bericht anzeigen",
        "DISPLAY_PAGE_NUMBER": "Seitenzahlen im Bericht anzeigen"
    },
    "REMOVE": "Entfernen",
    "REPORT_TEMPLATE": "Berichtsvorlage",
    "REMOVE_FILTER": "Filter verwerfen",
    "REQUESTED": "In Prüfung",
    "REQUESTER": "Auftraggeber",
    "REQUEST_IN_CREATION": "Anfrage in\nBearbeitung",
    "REQUEST_UNDER_REVIEW": "Anfrage in\nPrüfung",
    "REQUIREMENTS_WEBSHOP": "Nutzungs-\nbedingungen",
    "RESET_SELECTION": "Auswahl zurücksetzen",
    "RESPONSIBLE": "Zuständigkeit",
    "RESPONSIBLE_FOR": "Zuständig",
    "RESPONSIBLE_ROLE": "Zuständige Rolle",
    "RESPONSIBLE_CAREGIVER_PLURAL": "Zuständige Betreuer",
    "RESPONSIBLE_PERSON": "Zuständige Person",
    "RESPONSIBLE_SUPERVISOR_PLURAL": "Zuständige Co-Betreuer",
    "RESULTS_FOUND": "Ergebnisse gefunden",
    "REVOKE": "Widerrufen",
    "REVOKED": "Widerrufen",
    "RUN_TIME": "Laufzeit",
    "REVOKE_CONSULTATION_BUTTON": "Konsil widerrufen",
    "REVOKE_ORDER": "Anfrage widerrufen",
    "ROLE": {
        "PLURAL": "Rollen",
        "SELECT_SEVERAL": "Rollen wählen",
        "SINGULAR": "Rolle"
    },
    "RUNNING": "läuft",
    "RUNNING_STATE": "Freigegeben",
    "SAVE": "Speichern",
    "SAVE_CHANGES": "Änderungen übernehmen",
    "SAVE_CHANGES_PROMPT": "Änderungen übernehmen?",
    "SAVE_TASK_FAILURE_MESSAGE": "Beim Speichern der Aufgabe ist ein Fehler aufgetreten. Bitte prüfen sie ihre Internetverbindung und versuchen es später erneut.",
    "SAVE_TASK_SUCCESS_MESSAGE": "Die Aufgabe wurde erfolgreich gespeichert.",
    "SAVE_TEXT": "Text speichern",
    "SAVE_USERNAME": "Benutzername merken",
    "SCHEDULED": "Sitzung festgelegt",
    "SCREENING": {
        "CHOOSE_FORM": "Formular wählen",
        "CHOOSE_PATIENT": "Patient wählen",
        "CREATE_PATIENT": "Patient anlegen",
        "FORM": "Formular",
        "MODIFY_PATIENT": "Patient bearbeiten",
        "NAME": "Screening",
        "ANY_ITEM": "Es liegt kein Screening vor."
    },
    "SEARCH": "Suchen",
    "SEARCH_CONSULTANT": "Konsildienst",
    "SECONDS": "Sek",
    "SELECT": "Auswählen",
    "SELECT_CONSULTANT": "Konsildienst wählen",
    "SELECT_CONSULTANT_BUTTON": "Konsildienst wählen",
    "SELECT_DATE": "Datum",
    "SELECT_EXERCISE": "Sitzungsvorlage auswählen",
    "SELECT_ITEM_CONFIRM": "Auswahl bestätigen",
    "SELECT_PATIENT": "Patient wählen",
    "SELECT_PLAN_TEMPLATE": "Planvorlage wählen",
    "SELECTED_BY": "Ausgewählt von",
    "SELECTION": {
        "EXPANDS": "Auswahl erweitert die angezeigten Ergebnisse",
        "CONSTRAINTS": "Auswahl schränkt die angezeigten Ergebnisse ein"
    },
    "SEND": "Versenden",
    "SENDER": "Absender",
    "SEND_REQUEST": "Anfrage senden",
    "SEND_REQUEST_BUTTON": "Anfrage senden",
    "SERIES": {
        "PLURAL": "Serien",
        "SINGULAR": "Serie"
    },
    "SEROUS": "Serös",
    "SETPOINTS": {
        "UPPER_ALARM_THRESHOLD": "Alarmbereich Obergrenze",
        "UPPER_WARNING_THRESHOLD": "Warnbereich Obergrenze",
        "UPPER_NORMAL_THRESHOLD": "Normbereich Obergrenze",
        "TARGET_VALUE": "Zielwert",
        "LOWER_NORMAL_THRESHOLD": "Normbereich Untergrenze",
        "LOWER_WARNING_THRESHOLD": "Warnbereich Untergrenze",
        "LOWER_ALARM_THRESHOLD": "Alarmbereich Untergrenze",
        "INVALID_ORDER": "Die Werte müssen von unten nach oben aufsteigend sein.",
        "INVALID_DEVIATION_ORDER": "Die Abweichungen müssen vom Zielwert aus nach außen zunehmen.",
        "ZERO_DEVIATION": "Eine Abweichung von 0 % begrenzt keinen Bereich.",
        "SET": "Ziel- und Grenzwerte",
        "FLAGS": "Grenzwerte",
        "BASIS": "Bezugsgröße",
        "BASIS_OPTIONS": {
            "ABSOLUTE": "Absolut",
            "PERCENTAGE": "Prozent"
        },
        "COLUMN": {
            "LABEL": "Bezeichnung",
            "BASIS": "Bezug",
            "UPPER_ALARM": "Alarm\noben",
            "UPPER_WARNING": "Warn\noben",
            "UPPER_NORMAL": "Norm\noben",
            "TARGET_VALUE": "Zielwert",
            "LOWER_NORMAL": "Norm\nunten",
            "LOWER_WARNING": "Warn\nunten",
            "LOWER_ALARM": "Alarm\nunten"
        },
        "NONE": "Es liegen keine Ziel- und Grenzwerte vor.",
        "SAVE_SUCCESS": "Die Ziel- und Grenzwerte wurden gespeichert.",
        "SAVE_ERROR": "Beim Speichern der Ziel- und Grenzwerte ist ein Fehler aufgetreten."
    },
    "SETTINGS": "Einstellungen",
    "NORMAL_RANGE": {
        "SET": {
            "SINGULAR": "Normbereich einstellen",
            "PLURAL": "Normbereiche einstellen"
        }
    },
    "SET_PARTICIPANTS": "Teilnehmer festlegen",
    "SHOP_CONCLUSION_PROCESS_EXPLANATION": "Zum Abschluss der Registrierung haben Sie eine Willkommens-E-Mail mit Benutzername und Aufforderung zum Erstellen eines Passwortes erhalten.",
    "SHOW": "Teilgenommen",
    "SHOW_FORM": "Formular anzeigen",
    "SHOW_LEARNING_PROGRESS": "Lernfortschritt anzeigen",
    "SHOW_LESS": "Weniger anzeigen",
    "SHOW_MORE": "Mehr anzeigen",
    "SHOW_RESULT": "Ergebnis anzeigen",
    "SINCE": "seit",
    "SINGLE": "Einzel",
    "SIZE": "Größe",
    "SKIP": "Überspringen",
    "SKIPPED_AT": "Übersprungen am",
    "SOFT": "Weich",
    "SPECIALIST_PHYSICIAN": "Facharzt",
    "SPECIFIED_TRAINING_CONFIGURATION": "Angegebene Trainingswerte",
    "SPECTATOR_MODE": "Zuschauermodus",
    "SPIROMETRY": "Spirometrie",
    "SPO2": "SpO2",
    "SPO2_PERCENT": "SpO2 (%)",
    "STAMINA": "Ausdauer",
    "START": "Starten",
    "START_NOUN": "Start",
    "START_DATE": "Startdatum",
    "START_NEW_CONSULTATION_BUTTON": "Neues Konsil starten",
    "STARTED_ON": "Gestartet am",
    "STATE": "Status",
    "STATE_DETAILS": {
        "ACTIVE_UNTIL_DUE_Date": "Sie können diese Aufgabe bis zum {{date}} bearbeiten.",
        "CANCELLED_AT": "{{translatedType}} abgebrochen am {{date}}",
        "CANCELLED_AT_NOTYPE": "Abgebrochen",
        "COMPLETED_AT": "{{translatedType}} abgeschlossen am {{date}}",
        "COMPLETED_AT_NOTYPE": "Abgeschlossen",
        "CREATED_AT": "Erstellt am {{date}} Uhr",
        "CREATED_AT_BY": "Erstellt am {{date}} Uhr von {{fullName}}",
        "DELETED_AT": "Entfernt am {{date}} Uhr",
        "DUE_AT": "Fällig am {{date}}",
        "DUE_DATE": "{{translatedType}} fällig am {{date}}",
        "EARLIEST_START": "Bearbeitung frühestens ab {{date}}",
        "EXPIRED_AT": "Abgelaufen",
        "MEETING_NO_SHOW": "Nicht Teilgenommen",
        "MEETING_WAIT_FINISHED": "Dokumentation in bearbeitung",
        "MEETING_PARTICIPANT_FINISHED": "Teilgenommen",
        "LATEST_SUBMISSION_DATE": "Bearbeitung bis spätestens am {{date}}",
        "LOCKED": "Pausiert seit {{date}} wegen Überarbeitung",
        "MODIFIED_AT": "Geändert am {{date}} Uhr",
        "START_AT": "Startet am {{date}} Uhr",
        "SKIPPED": "Übersprungen",
        "TRAINING": "{{completed}}. von {{planned}} Einheiten für diese Woche",
        "INACTIVE_CAUSE_OF_PRECONDITION": "Inaktiv wegen Voraufgabe",
        "INACTIVE_CAUSE_OF_DUE_DATE": "Diese Aufgabe können Sie erst ab dem {{date}} abschließen.",
        "INACTIVE_CAUSE_OF_DUE_DATE_AUTO_CLOSE": "Diese Aufgabe können Sie erst ab dem {{date}} bearbeiten.",
        "VERIFIED_AT": "verifiziert am {{date}} Uhr"
    },
    "STREET": "Straße und Hausnummer",
    "STRENGTHENING": "Kräftigung",
    "SUBJECT": "Betreff",
    "SUBMIT_PROVIDED_SERVICES": "Leistungsanforderung übermitteln",
    "SUCCESS_WEBSHOP": "Buchung\nabgeschlossen",
    "SUPERVISED_PATIENTS": "Patienten",
    "SUPERVISOR": "Co-Betreuer",
    "SUPERVISOR_VISIBILITY": {
        "IS_NOT_VISIBLE": "Nicht sichtbar für Co-Betreuer",
        "IS_VISIBLE": "Sichtbar für Co-Betreuer",
        "TITLE": "Sichtbarkeit für Co-Betreuer"
    },
    "SHOP": {
        "BOOKING_OPTION": "Buchungsoptionen",
        "PAYMENT_OPTION": "Zahlungsgsoptionen",
        "PAYMENT_MODALITY": "Zahlungsmodalität",
        "AVAILABLE": "Verfügbar",
        "ANY_NEW_ARTICLE": "Es liegen keine verfügbaren Kurse vor.",
        "ANY_PROGRAM": "Es liegen keine zugeordneten Kurse vor."
    },
    "FREE_OF_CHARGE": "Kostenfrei",
    "SELF_PAYER": "Selbstzahler",
    "SYSTEM": "System",
    "Sat": "Samstag",
    "Sun": "Sonntag",
    "TAG": {
        "ACTION_MODIFY": "Tag anpassen",
        "ADD_NEW": "Tags hinzufügen",
        "MODIFY": "Tags bearbeiten",
        "CREATE": "Tag erstellen",
        "DELETE": "Tag löschen",
        "NONE": "Es liegen keine Tags vor.",
        "NONE_ASSIGNED": "Kein Tag zugeordnet",
        "REMOVE_FILTER": "Filter verwerfen",
        "PLURAL": "Tags",
        "SINGULAR": "Tag",
        "UPDATE": "Tag anpassen",
        "ERROR": {
            "TOO_SHORT": "Name des Tags muss mindestens ein Zeichen lang sein. Bitte längeren Namen wählen.",
            "GENERAL_ERROR": "Die Aktion kann nicht ausgeführt werden.",
            "ALREADY_EXISTS": "Dieses Tag existiert bereits. Bitte anderen Namen wählen."
        },
        "SUCCESS": {
            "CREATE": "Tag '{{label}}' wurde erfolgreich erstellt."
        },
        "CATEGORY": {
            "CREATE": "Kategorie erstellen",
            "ERROR": {
                "ALREADY_EXISTS": "Diese Kategorie existiert bereits. Bitte anderen Namen wählen",
                "GENERAL_ERROR": "Die Aktion kann nicht ausgeführt werden.",
                "TOO_SHORT": "Name der Kategorie muss mindestens ein Zeichen lang sein. Bitte längeren Namen eingeben."
            },
            "PROMPT": {
                "DELETE": "Die Kategorie wird unwiderruflich gelöscht.\n Wenn Sie die Kategorie „{{label}}“ löschen möchten, klicken Sie auf „Löschen“."
            },
            "SUCCESS": {
                "CREATE": "Kategorie wurde erfolgreich erstellt.",
                "DELETE": "Die Kategorie wurde gelöscht"
            },
            "UPDATE": "Kategorie anpassen",
            "DELETE": "Kategorie löschen"
        },
        "COURSE": {
            "UPDATE": "Sitzungs-Tag anpassen"
        }
    },
    "TAG_COURSE_IS_CREATE": "Tag wurde erstellt",
    "TAG_COURSE_IS_DELETE": "Tag wird unwiderruflich gelöscht.\n Wenn Sie das Tag „{{label}}“ löschen möchten, klicken Sie auf „Löschen“.",
    "TAG_COURSE_WAS_DELETE": "Tag wurde gelöscht",
    "TAG_IS_DELETE": "Tag wird unwiderruflich gelöscht.\n Wenn Sie das Tag „{{label}}“ löschen möchten, klicken Sie auf „Löschen“.",
    "TAG_LEARNING_IS_DELETE": "Die Aufgabe wird unwiderruflich gelöscht.\n Wenn Sie die Aufgabenvorlage „{{label}}“ dennoch löschen möchten, klicken Sie auf „Löschen“.",
    "TAG_PROGRAM_IS_DELETE": "Die Programmvorlage wird unwiderruflich gelöscht.\n Wenn Sie die Programmvorlage „{{label}}“ dennoch löschen möchten, klicken Sie auf „Löschen“.",
    "TAG_PROGRAM_WAS_DELETE": "Die Programmvorlage wurde erfolgreich gelöscht.",
    "TAG_TASK_IS_DELETE": "Tag wird unwiderruflich gelöscht.\n Wenn Sie das Tag „{{label}}“ löschen möchten, klicken Sie auf „Löschen“.",
    "TAG_TASK_WAS_DELETE": "Tag wurde gelöscht",
    "TAG_TRAINING_IS_CREATE": "Tag wurde erstellt",
    "TAG_TRAINING_IS_DELETE": "Tag wird unwiderruflich gelöscht.\n Wenn Sie das Tag „{{label}}“ löschen möchten, klicken Sie auf „Löschen“.",
    "TAG_TRAINING_WAS_DELETE": "Tag wurde gelöscht",
    "TAG_TRAINING_THERAPY_IS_DELETE": "Das Training wird unwiderruflich gelöscht.\n Wenn Sie das Training „{{label}}“ dennoch löschen möchten, klicken Sie auf „Löschen“.",
    "TAG_WAS_DELETED": "Tag wurde gelöscht",
    "TASK": {
        "ADMINISTRATION": "Aufgabenkonfiguration",
        "EMERGENCY_CREW": "🚑 {{name}}",
        "EMERGENCY_CREW_UNNAMED": "Rettungsdienst",
        "EMERGENCY_CREW_VEHICLE": "🚑 {{vehicle}} · {{name}}",
        "SUB_TYPE": {
            "MISSION": "Auftrag",
            "LEARNING": "Lernen",
            "FREETEXT": "Freitext",
            "QUESTIONNAIRE": "Formular",
            "UPLOAD": "Upload",
            "VIDEO_CONFERENCE": "Videogespräch"
        },
        "DESCRIPTION": {
            "ACTIVE": "Beschreibung (Aktiv)",
            "FINISHED": "Beschreibung (Abgeschlossen)",
            "NO_SHOW": "Beschreibung (Abgelaufen)",
            "CANCELED": "Beschreibung (Abgebrochen)"
        },
        "SAVE_TEXT": "Text speichern",
        "FETCH_FAILED": "Fehler beim Abrufen der Aufgabe.",
        "ADD": "Aufgabe hinzufügen",
        "CORRECT": "Aufgabe korrigieren",
        "ANY": "Es liegen keine Aufgaben vor.",
        "CONDITION": "Bedingung",
        "EXERCISE": {
            "ITEM_WAS_DELETE": "Die Aufgabenvorlage wurde erfolgreich gelöscht",
            "DELETE_ACTION": "Aufgabenvorlage löschen",
            "CREATE_ACTION": "Aufgabenvorlage erstellen",
            "ITEM_DELETE_MODAL_TITLE": "{{title}} löschen",
            "ITEM_DELETE_MODAL_DESCRIPTION": "Die Daten werden unwiderruflich gelöscht.\nWenn Sie die Aufgabenvorlage „{{title}}“ löschen möchten, klicken Sie auf „Löschen",
            "ENABLE_OPEN_PDF_ACTION": "Nach Abschluss für Patient als PDF speicherbar"
        },
        "DELETE": "Aufgabenvorlage löschen",
        "DURATION": "Vorgabe für Dauer",
        "WORKING_DURATION": "Dauer der Bearbeitung",
        "DURATION_TEMPLATE": "Vorgabe für Dauer (aus Vorlage)",
        "NOTIFICATION": "Benachrichtigung",
        "RESPONSIBLE_USER": "Zuständiger Benutzer",
        "RESPONSIBLE_ROLES": "Alle mit dieser Rolle",
        "RESPONSIBLE_SUPERVISORS": "Alle zugeordneten Co-Betreuer",
        "PLAN": {
            "ANY_ASSIGN": "Es sind keine Aufgabenpläne zugeordnet.",
            "SINGULAR": "Aufgabenplan",
            "PLURAL": "Aufgabenpläne",
            "ADD": "Aufgabenplan hinzufügen",
            "ADD_SUCCESS_MESSAGE": "Aufgabenplan wurde hinzugefügt.",
            "FETCH_FAILED": "Fehler beim Abrufen des Aufgabenplans.",
            "NO_READ_ACCESS": "Sie sind nicht berechtigt Aufgabenpläne zu lesen",
            "NO_WRITE_ACCESS": "Sie sind nicht berechtigt Aufgabenpläne zu editieren",
            "UPDATE_SUCCESS": "Aufgabenplan erfolgreich gespeichert",
            "REMOVE_SUCCESS_MESSAGE": "Aufgabenplan wurde entfernt.",
            "REMOVE_ERROR": "Beim Löschen des Aufgabenplans ist ein Fehler aufgetreten.",
            "REMOVE": "Aufgabenplan entfernen",
            "REMOVE_EXPLANATION": "Durch das Entfernen des Aufgabenplans werden alle zugehörigen noch anstehenden Aufgaben entfernt. Sind Sie sicher, dass Sie fortfahren möchten?",
            "CAREGIVER_EXPLANATION": "Der ausgewählte Betreuer wird beim Erstellen des Aufgabenplans automatisch jeder Aufgabe zugeordnet,  bei der die Rolle Betreuer zuständig ist. ",
            "SUPERVISOR_EXPLANATION": "Der ausgewählte Co-Betreuer wird beim Erstellen des Aufgabenplans automatisch jeder Aufgabe zugeordnet,  bei der die Rolle Co-Betreuer zuständig ist. Dafür muss der Co-Betreuer vorher bereits dem Patienten zugeordnet sein.",
            "CHANGE_CAREGIVER_EXPLANATION": "Der ausgewählte Betreuer wird jeder geplanten, aktiven und abgelaufenen Aufgabe des Aufgabenplans automatisch hinzugefügt, bei der die Rolle Betreuer zuständig ist.",
            "CHANGE_SUPERVISOR_EXPLANATION": "Der ausgewählte Co-Betreuer wird jeder geplanten, aktiven und abgelaufenen Aufgabe des Aufgabenplans automatisch hinzugefügt, bei der die Rolle Co-Betreuer zuständig ist.",
            "RESPONSIBLE_CAREGIVER": "Zuständiger Betreuer",
            "RESPONSIBLE_SUPERVISOR": "Zuständiger Co-Betreuer"
        },
        "QUESTIONNAIRE": {
            "ANY_ITEMS": "Es liegen keine Formulare vor.",
            "CHOOSE": "Formular wählen",
            "EDIT": "Formularvorlage bearbeiten",
            "FINISH": "Formular abgeben",
            "SAVE": "Formular speichern",
            "SAVED": "Formular erfolgreich gespeichert",
            "ADD_CONDITION": "Abhängigkeit hinzufügen",
            "CONDITIONS": "Abhängigkeiten",
            "SHOW_QUESTION": "Frage anzeigen",
            "IF_CONDITION": "Wenn",
            "DELETE_CONDITIONS": "Abhängigkeiten löschen",
            "NEXT_QUESTIONS": "Weiter",
            "PREVIOUS_QUESTIONS": "Zurück",
            "TEMPLATE": {
                "SINGULAR": "Formularvorlage",
                "PLURAL": "Formularvorlagen",
                "DELETE": "Formularvorlage löschen",
                "DELETE_TITLE": "Formularvorlage “{{name}}” löschen",
                "DELETE_SUCCESS": "Formularvorlage erfolgreich gelöscht",
                "DELETE_CONFIRMATION": "Die Formularvorlage “{{name}}” wird gelöscht, aber nicht aus bereits zugeordneten Aufgabenvorlagen entfernt. Die Aufgabenvorlagen müssen nachträglich bearbeitet werden. Wenn Sie die Formularvorlage löschen möchten, klicken Sie auf ”Löschen”.",
                "SAVE_SUCCESS": "Die Formularvorlage wurde erfolgreich erstellt",
                "SAVE_ERROR": "Fehler beim Erstellen der Formularvorlage",
                "UPDATE_SUCCESS": "Formularvorlage erfolgreich gespeichert",
                "UPDATE_ERROR": "Fehler beim Speichern der Formularvorlage",
                "ANY_ITEMS": "Es liegen keine Formularvorlagen vor.",
                "LOAD_ERROR": "Beim Laden der Formularvorlage ist ein Fehler aufgetreten",
                "CREATE": "Formularvorlage erstellen",
                "REQUIRED_ERROR": "Der Inhalt der Formularvorlage darf nicht leer sein",
                "UNAVAILABLE_FOR_SYSTEM_ERROR": "Es sind keine Formularvorlagen für das System hinterlegt.",
                "INVALID_TEMPLATE_ERROR": "Zugeordnete Formularvorlage wurde gelöscht. Bearbeitung erforderlich.",
                "REQUIRED_MATRIX_QUESTION": {
                    "CONFIGURE": "Matrix Pflichtfragen konfigurieren",
                    "ONE_PER_QUESTION": "Eine Antwort pro Matrix",
                    "ONE_PER_ROW": "Eine Antwort pro Zeile",
                    "ONE_PER_COLUMN": "Eine Antwort pro Spalte"
                },
                "JSON": {
                    "OPEN": "Inhalt als JSON anzeigen",
                    "COPY": "In die Zwischenablage kopieren",
                    "COPY_TO_CLIPBOARD": "Formularinhalt in die Zwischenablage kopiert",
                    "COPY_ERROR": "Der Formularinhalt konnte nicht in die Zwischenablage kopiert werden"
                },
                "AUTHORING": {
                    "HINT": "Wie soll der Inhalt dieses Formulars erstellt werden?",
                    "FIELDS": "Felder hinzufügen",
                    "CONTENT": "Inhalt als JSON eingeben"
                },
                "FIELD": {
                    "ADD": "Feld hinzufügen",
                    "NONE_SELECTED": "Es wurden noch keine Felder hinzugefügt",
                    "NONE_SELECTED_ERROR": "Bitte fügen Sie mindestens ein Feld hinzu",
                    "NONE_AVAILABLE": "Es stehen keine weiteren Felder zur Auswahl",
                    "REQUIRED": "Pflichtfeld",
                    "ACTIONS": "Weitere Optionen",
                    "EDIT_DEPENDENCIES": "Abhängigkeiten bearbeiten",
                    "EDIT_VARIABLES": "Kennzeichen bearbeiten",
                    "REMOVE": "Feld entfernen"
                },
                "QUESTION_CONTENT": {
                    "ADD": "Bild zuordnen",
                    "UPLOAD": "Bild hochladen",
                    "UPLOAD_ERROR": "Beim Hochladen des Bildes ist ein Fehler aufgetreten.",
                    "UPLOAD_SUCCESS": "Bild erfolgreich hochgeladen."
                },
                "CONDITION": {
                    "SHOW_QUESTION": "Frage anzeigen",
                    "IF": "Wenn",
                    "SINGULAR": "Abhängigkeit",
                    "PLURAL": "Abhängigkeiten",
                    "ADD": "Abhängigkeit hinzufügen",
                    "DELETE": "Abhängigkeit löschen",
                    "EDIT_DISABLED_UNTIL_SAVED": "Um bedingte Fragen konfigurieren zu können, muss der Fragebogen zuvor gespeichert werden."
                },
                "VARIABLE": {
                    "QUESTION": "Frage",
                    "ANSWER": "Antwort",
                    "SINGULAR": "Kennzeichen",
                    "PLURAL": "Kennzeichen",
                    "ADD": "Kennzeichen hinzufügen",
                    "DELETE": "Kennzeichen löschen",
                    "NONE_ASSIGNED": "Es wurden noch keine Kennzeichen zugeordnet",
                    "EDIT_DISABLED_UNTIL_SAVED": "Um Kennzeichen konfigurieren zu können, muss der Fragebogen zuvor gespeichert werden.",
                    "TYPE_ICON": "Icon einer Frage zuordnen",
                    "TYPE_IGNORE_QUESTION": "Frage im Bericht ausblenden",
                    "INVALID_ICON": "Format: idef_<Icontyp>_<Name>_cdef_<Farbtyp>_<Farbe>, z. B. idef_ion_flag_cdef_css_red"
                },
                "SCORE": {
                    "ANSWER": "Antwort",
                    "QUESTION": "Frage",
                    "SINGULAR": "Score",
                    "PLURAL": "Scores",
                    "ADD": "Score zuweisen",
                    "VALUE": "Score-Wert",
                    "RESET": "Score zurücksetzen",
                    "ASSIGN": "Score zuweisen",
                    "EDIT_DISABLED_UNTIL_SAVED": "Um Scores zuweisen zu können, muss der Fragebogen zuvor gespeichert werden."
                },
                "INLINE": {
                    "ANSWER": "Antwort",
                    "QUESTION": "Frage",
                    "PLURAL": "Querverweise",
                    "ADD": "Querverweis hinzufügen",
                    "RESET": "Querverweise zurücksetzen",
                    "ASSIGN": "Querverweise hinzufügen",
                    "EDIT_DISABLED_UNTIL_SAVED": "Um Querverweise hinzufügen zu können, muss der Fragebogen zuvor gespeichert werden."
                },
                "FORMULA": {
                    "SINGULAR": "Formel",
                    "PLURAL": "Formeln",
                    "INVALID": "Ungültige Formel {{formula}}",
                    "NO_RESULT": "Formel ohne Ergebnis {{formula}}"
                },
                "REFERENCE": {
                    "ORPHANED_WARNING": "Folgende Einträge verweisen auf eine gelöschte Frage. Bitte anpassen oder entfernen, bevor gespeichert werden kann:",
                    "SOURCE_CONDITION": "Abhängigkeit",
                    "SOURCE_SCORE": "Score",
                    "SOURCE_INLINE_VARIABLE": "Querverweis"
                }
            },
            "FIELD": {
                "NONE": "Es liegen keine Felder vor.",
                "CREATE": "Feld erstellen",
                "DELETE": "Feld löschen",
                "LOAD_ERROR": "Beim Laden der Felder ist ein Fehler aufgetreten",
                "SAVE_SUCCESS": "Feld wurde erfolgreich erstellt",
                "SAVE_ERROR": "Beim Erstellen des Feldes ist ein Fehler aufgetreten",
                "UPDATE_SUCCESS": "Feld wurde erfolgreich aktualisiert",
                "UPDATE_ERROR": "Beim Aktualisieren des Feldes ist ein Fehler aufgetreten",
                "DELETE_SUCCESS": "Feld wurde erfolgreich gelöscht",
                "DELETE_TITLE": "\"{{name}}\" löschen",
                "DELETE_CONFIRMATION": "Die Daten werden unwiderruflich gelöscht. Wenn Sie das Feld \"{{name}}\" löschen möchten, klicken Sie auf \"Löschen\".",
                "SINGULAR": "Feld",
                "PLURAL": "Felder",
                "NAME": "Name",
                "TEXT": "Frage",
                "SHORT_NAME": "Kurzbezeichnung",
                "DESCRIPTION": "Beschreibung",
                "TYPE": "Eingabetyp",
                "EVALUATION_VISIBILITY": {
                    "TITLE": "Sichtbarkeit",
                    "CONTEXT": {
                        "PLANER": "Planer",
                        "HISTORY": "Verlauf",
                        "AKTE": "Akte"
                    },
                    "VIEW": {
                        "CHART": "Diagramm",
                        "LIST": "Listenansicht"
                    }
                },
                "DATE_FORMAT": "Datumsformat",
                "STATUS": "Status",
                "STATUS_OPTIONS": {
                    "true": "Aktiv",
                    "false": "Inaktiv"
                },
                "STATUS_OPERATIONS": {
                    "ACTIVATE": "Aktivieren",
                    "DEACTIVATE": "Deaktivieren"
                },
                "TYPE_OPTIONS": {
                    "DATE": "Datum",
                    "STRING": "Text einzeilig",
                    "TEXT": "Text mehrzeilig",
                    "MULTIPLE_CHOICE": "Mehrfachauswahl",
                    "SINGLE_CHOICE": "Einfachauswahl",
                    "DECIMAL": "Zahl",
                    "INFOTEXT": "Infotext",
                    "SIGNATURE": "Unterschrift",
                    "UPLOAD": "Upload",
                    "DRAWING": "Zeichnung",
                    "BLOOD_GLUCOSE": "Blutzucker",
                    "BLOOD_PRESSURE": "Blutdruck",
                    "MATRIX": "Matrix"
                },
                "DATE_FORMAT_OPTIONS": {
                    "DD_MM_YYYY_HHmm": "TT.MM.JJJJ HH:mm",
                    "DD_MM_YYYY": "TT.MM.JJJJ",
                    "MM_YYYY": "MM.JJJJ",
                    "YYYY": "JJJJ"
                },
                "ANSWER_OPTION": {
                    "TITLE": "Antwortoptionen",
                    "LABEL": "Antwortoption {{index}}",
                    "ADD": "Antwortoption hinzufügen"
                },
                "MATRIX_CONFIG": {
                    "TITLE": "Matrix",
                    "CHOICE_TYPE": "Auswahlart",
                    "ROW_PLACEHOLDER": "Zeile {{index}}",
                    "COLUMN_PLACEHOLDER": "Spalte {{index}}"
                },
                "COMPONENT": {
                    "ID": "ID",
                    "LABEL": "Bezeichnung",
                    "UNIT": "Einheit",
                    "ADD": "Bestandteil hinzufügen"
                },
                "DECIMAL_CONFIG": {
                    "TITLE": "Zahlenkonfiguration",
                    "VIEW": "Ansicht",
                    "VIEW_OPTIONS": {
                        "INPUT": "Eingabefeld",
                        "SLIDER": "Slider"
                    },
                    "UNIT": "Einheit",
                    "MIN": "Minimum",
                    "MAX": "Maximum",
                    "STEP": "Skalenschritte",
                    "DECIMAL_PLACES": "Nachkommastellen",
                    "DECIMAL_PLACES_OPTIONS": {
                        "0": "Ganzzahl",
                        "1": "1 Nachkommastelle",
                        "2": "2 Nachkommastellen",
                        "UNLIMITED": "Beliebig viele"
                    }
                },
                "SETPOINTS": {
                    "ENABLED": "Ziel- und Grenzwerte festlegen",
                    "ENABLED_OPTIONS": {
                        "true": "Ja",
                        "false": "Nein"
                    },
                    "NONE": "Es liegen keine Ziel- und Grenzwerte vor."
                },
                "MAX_LENGTH": "Anzahl Zeichen (Max.)",
                "DEVICE_MODEL": "Gerät",
                "DEVICE_MODEL_NONE": "Kein Gerät",
                "MEDIA": "Medien (unter der Beschreibung)",
                "ANSWER_MEDIA": "Medien (über der Antwort)",
                "DRAWING_BACKGROUND": "Hintergrundbild (der Zeichnung)",
                "INTERFACE_CONFIG": {
                    "GDT": "GDT-Schnittstelle",
                    "HL7_V2": "HL7 v2.x Bezeichner",
                    "HL7_FHIR": "HL7 FHIR Bezeichner"
                }
            },
            "ERROR": {
                "NO_ANSWER_OPTIONS": "Formular fehlerhaft: Diese Frage ist eine Pflichtfrage und kann nicht beantwortet werden, da die Antwortoptionen fehlen.",
                "REQUIRED": "*Pflichtfeld",
                "DEFAULT": "Ungültige Angabe"
            }
        },
        "CALENDAR_EVENT": {
            "DELETE_ERROR_MESSAGE": "Beim Löschen des Termins ist ein Fehler aufgetreten.",
            "START_TIME": "Start des Termins",
            "END_TIME": "Ende des Termins",
            "SET_MEETING": "Termin festlegen",
            "WORKING_DURATION": "Dauer des Termins",
            "IS_PATIENT_PARTICIPANT": "Ist Patient zum Termin eingeladen",
            "INVITED_CAREGIVERS": "Eingeladene Betreuer",
            "INVITED_SUPERVISORS": "Eingeladene Co-Betreuer"
        },
        "APPOINTMENT": {
            "DELETE_ERROR_MESSAGE": "Beim Löschen des Bearbeitungszeitraums ist ein Fehler aufgetreten.",
            "SET": "Bearbeitungszeitraum festlegen",
            "SET_ERROR_MESSAGE": "Beim Anlegen des Bearbeitungszeitraums ist ein Fehler aufgetreten.",
            "REMINDER_START_DATE": "Erinnerung zur frühesten Bearbeitungszeit",
            "REMINDER_DUE_DATE": "Erinnerung zum Ablauf der Fälligkeit",
            "REMINDER_END_DATE": "Erinnerung zur spätesten Bearbeitungszeit"
        },
        "FINISH_TIMESTAMP": "Abschlussdatum",
        "NAME": "{count, plural, =0{Aufgabe} one{Aufgabe} other{Aufgaben}}",
        "PLURAL": "Aufgaben",
        "SINGULAR": "Aufgabe",
        "NOTE": "Hinweis",
        "NOTES": "Hinweise",
        "PRECONDITION_LABEL": "Aufgaben, die vorab abgeschlossen sein müssen",
        "TEMPLATE": {
            "CREATE": "Aufgabenplanvorlage erstellen",
            "ITEM": {
                "ADD": "Aufgabenvorlage hinzufügen",
                "ANY_ITEM": "Es liegen keine Aufgabenvorlagen vor.",
                "PLURAL": "Aufgabenvorlagen",
                "SINGULAR": "Aufgabenvorlage",
                "SELECT": "Aufgabenvorlage wählen",
                "REMOVE": "Aufgabenvorlage entfernen",
                "DELETE_WARNING_MESSAGE": "Die Vorlage wird unwiderruflich gelöscht.\nWenn Sie die Aufgabenvorlage „{{title}}“ dennoch löschen möchten, klicken Sie auf „Löschen“.",
                "DELETE_SUCCESS_MESSAGE": "Die Vorlage wurde erfolgreich gelöscht.",
                "DELETE_ERROR_MESSAGE": "Beim Löschen der Vorlage ist ein Fehler aufgetreten.",
                "GET_FAILURE_MESSAGE": "Beim Abrufen der Vorlage ist ein Fehler aufgetreten.",
                "REFRESH_ERROR_MESSAGE": "Beim Aktualisieren der Vorlage ist ein Fehler aufgetreten.",
                "SAVE_ERROR_MESSAGE": "Beim Speichern der Vorlage ist ein Fehler aufgetreten.",
                "SAVE_SUCCESS_MESSAGE": "Die Vorlage wurde erfolgreich gespeichert."
            },
            "ANY_ITEM": "Es liegen keine Aufgabenvorlagen vor.",
            "NONE": "Keine Aufgabenplanvorlagen vorhanden",
            "PLAN": {
                "SELECT": "Aufgabenplanvorlage auswählen"
            },
            "ADD": "Aufgabenplanvorlage hinzufügen",
            "REMOVE": "Aufgabenplanvorlage entfernen",
            "OPEN": "Aufgabenplanvorlage öffnen",
            "GET_ERROR_MESSAGE": "Beim Abrufen der Aufgabenplanvorlage ist ein Fehler aufgetreten.",
            "PLURAL": "Aufgabenplanvorlagen",
            "EDIT": "Aufgabenplan bearbeiten",
            "SELECT": "Aufgabenplan hinzufügen",
            "SINGULAR": "Aufgabenplanvorlage",
            "PRECONDITIONS_SELECTION": "Vor-Aufgaben auswählen",
            "START_AS_DAY": "Start (Tag)",
            "DUE_AS_DAY": "Fällig (Tag)",
            "END_AS_DAY": "Ende (Tag)",
            "AUTO_CREATE_REPORT": "Bei Abschluss automatisch einen Bericht erstellen",
            "SELECT_REPORT_TEMPLATE": "Bitte wählen sie eine Berichtsvorlage aus"
        },
        "STATE_DETAILS": {
            "CANCELED": "Aufgabe abgebrochen",
            "ACTIVE": "Aufgabe aktiv",
            "ACTIVE_UNTIL_DUE_DATE": "Sie können diese Aufgabe bis zum {{date}} bearbeiten.",
            "INACTIVE_CAUSE_OF_DUE_DATE": "Diese Aufgabe können Sie erst ab dem {{date}} abschließen.",
            "INACTIVE_CAUSE_OF_PRECONDITION": "Diese Aufgabe können Sie erst mit Abschluss von Voraufgaben bearbeiten.",
            "TASK_STATUS_FINISHED_NO_SHOW": "Abgelaufen am {{date}}, {{time}} Uhr",
            "INACTIVE_CAUSE_OF_DUE_DATE_AUTO_CLOSE": "Diese Aufgabe können Sie erst ab dem {{date}} bearbeiten.",
            "TASK_STATUS_SKIPPED_AT": "Übersprungen am {{date}}"
        },
        "SKIP_COMMENT": "Kommentar",
        "SKIP_REASON": "Grund",
        "SKIP_REASONS": "Gründe für Überspringen",
        "SKIP_REASONS_EMPTY_LIST": "Es sind noch keine Gründe für das Überspringen von Aufgaben definiert.",
        "SKIP_REASONS_ADD": "Überspringen-Grund hinzufügen",
        "SKIP_REASONS_UPDATE": "Überspringen-Grund ändern",
        "SKIP_REASONS_DELETE": "Überspringen-Grund löschen",
        "SKIP": "Aufgabe überspringen",
        "TASK_SETTINGS": {
            "QUESTIONNAIRE": {
                "FINISH_AUTOMATICALLY": "Aufgabe automatisch schließen nach Ausfüllen des Formulars",
                "NOT_FINISH_AUTOMATICALLY": "Aufgabe nicht automatisch schließen"
            },
            "MISSION": {
                "FINISH_AUTOMATICALLY": "Aufgabe schließt nach dem Öffnen von der zuständigen Rolle automatisch",
                "NOT_FINISH_AUTOMATICALLY": "Aufgabe schließt nicht automatisch nach dem Öffnen von der zuständigen Rolle"
            }
        },
        "TRACKING": "Kennzeichen",
        "SESSION": {
            "OPEN_PDF": "Formular als PDF\nherunterladen"
        },
        "TOOLTIP": {
            "VISIBILITY_FOR_PATIENT": "Wenn die Dauer der Sichtbarkeit für Patienten aktiviert ist, wird diese Aufgabe automatisch beim Patienten im Planer ausgeblendet, sobald die Aufgabe abgeschlossen hat."
        },
        "HIDE_AFTER_FINISHED_FOR_PATIENT": "Nach Abschluss für Patient ausblenden"
    },
    "TASKS": "Aufgaben",
    "TASK_EXPIRED_AT": "Aufgabe abgelaufen am ",
    "TASK_PLAN": "Aufgaben",
    "TASK_STATUS_ACTIVE": "Aufgabe aktiv",
    "TASK_STATUS_PLANNED": "Aufgabe geplant",
    "TECHNOLOGY": {
        "SINGULAR": "Technology",
        "PLURAL": "Technologien "
    },
    "TECH_PROBLEM": "Entschuldigt gefehlt",
    "TEMPERATURE": "Temperatur",
    "TEMPERATURE_DEGREE_CELSIUS": "Temperatur (°C)",
    "TENANT": "Mandant",
    "TERMS_AND_CONDITIONS": {
        "LONG": "Allgemeine Geschäftsbedingungen (AGB)",
        "SHORT": "AGB"
    },
    "TERM_OF_APPLICATION": "Anmeldefrist",
    "THERAPIST": "Betreuer",
    "THERAPY_DETAIL_PAGE_TITLE": "Kurs",
    "THERAPY_DETAIL_PAGE_TITLE_NEW": "Kurs erstellen",
    "THERAPY_LIST_PAGE_TITLE": "Kurse",
    "THERAPY_PLAN": "Therapieplan",
    "THERAPY_TEMPLATE_DETAIL_PAGE_TITLE": "Sitzungsplanvorlage",
    "THERAPY_TEMPLATE_DETAIL_PAGE_TITLE_NEW": "Sitzungsplanvorlage erstellen",
    "THERAPY_TEMPLATE_EXPLANATION": "Beschreibung",
    "THERAPY_TEMPLATE_LIST_PAGE_TITLE": "Kursvorlagen",
    "TIMESTAMP": "Zeit",
    "TIME_TO_DO": "Bearbeitungszeit",
    "TITLE": "Titel",
    "TITLE_EXERCISE": "Name",
    "TITLE_THERAPY_TEMPLATE": "Name",
    "TODAY": "Heute",
    "TOOLBAR_CONSULTATIONS_TITLE": "Konsile",
    "TOOLBAR_PATIENTS_TITLE": "Patienten",
    "TOOLBAR_PROFILE_TITLE": "Profil",
    "TO_COMPLETE": "Abzuschließen",
    "TRAINING": {
        "COMMENT": {
            "ANY_ITEM": "Es liegen keine Kommentare vor.",
            "CREATE_ACTION": "Kommentar erstellen"
        },
        "CONTENT": {
            "ADD_ITEM": "Unterlage hochladen",
            "ADD_ITEM_FROM_SERVER": "Unterlage auswählen",
            "ANY_ITEM": "Es liegen keine Elemente vor."
        },
        "FEEDBACK": {
            "COMMENT": "Wie fühlen Sie sich nach dieser Übung?",
            "BORG_EXPLANATION": "Wie anstrengend empfanden Sie die Übung? (nach Borg)",
            "PAIN_EXPLANATION": "Hatten Sie Schmerzen bei der Übung?",
            "FROM_DATE": "Rückmeldung vom {{date}}"
        },
        "EXERCISE": {
            "CHOOSE_PLURAL": "Übungen wählen",
            "SEARCH_PLURAL": "Übungen suchen",
            "ADD_SUCCESS": "Die Übung wurde erfolgreich hinzugefügt",
            "ADD_ERROR": "Beim Hinzufügen der Übung ist ein Fehler aufgetreten",
            "DELETE_ACTION": "Übung löschen",
            "ACTIVE": "Aktiv",
            "DELETE_COMMENT": "Übungskommentar löschen",
            "ITEM_DELETE_MODAL_TITLE": "{{title}} löschen",
            "ITEM_DELETE_MODAL_DESCRIPTION": "Die Daten werden unwiderruflich gelöscht.\nWenn Sie die Übung „{{title}}“ löschen möchten, klicken Sie auf „Löschen“.",
            "ITEM_WAS_DELETE": "Die Übung wurde gelöscht",
            "ITEM_WAS_DELETE_ERROR": "Beim Löschen der Übung ist ein Fehler aufgetreten",
            "ADD_ITEM": "Übungen hinzufügen",
            "NO_ITEM_ADDED": "Es liegen kein Übungen vor",
            "PLURAL": "Übungen",
            "SINGULAR": "Übung",
            "PULSE_VARIANCE": "Puls Variance",
            "VERBAL_FEEDBACK": "Verbales Feedback",
            "PICTURE_PREVIEW": "Vorschaubild",
            "NEW": "Neue Übung",
            "NEW_COMMENT": "Übungskommentar erstellen",
            "UPDATE_COMMENT": "Übungskommentar anpassen",
            "ANY_UNIT_WITH_PARENTHESES": "(keine)",
            "INTENSITY_UNIT": {
                "KILOGRAMS": "kg",
                "LEVEL": "Stufe",
                "WATT": "Watt",
                "KMH": "Geschwindigkeit",
                "PACE": "Tempo"
            },
            "DURATION_UNIT": {
                "REPETITIONS": "Wdh",
                "SECONDS": "Sek",
                "MINUTES": "Min",
                "METER": "Meter",
                "KILOMETER": "Km"
            },
            "FEEDBACK": {
                "SINGULAR": "Feedback",
                "REQUIRE_EFFORT": "Anstrengung nach Borg",
                "REQUIRE_PAIN": "Schmerzen nach 0-10",
                "REQUIRE_STRESS": "Beanspruchung nach Puls",
                "REQUIRE_COMMENT": "Übungskommentare",
                "REQUIRE_EXERCISE_PARAMS": "Abweichungen vom Trainingsplan"
            }
        },
        "EXERCISE_SERIES": {
            "ADD_PLURAL": "Übungsreihen hinzufügen",
            "ADD_SUCCESS": "Die Übungsreihen wurden erfolgreich hinzugefügt",
            "ADD_ERROR": "Beim Hinzufügen der Übungsreihen ist ein Fehler aufgetreten",
            "EDIT": "Übungsreihe bearbeiten",
            "SHOW": "Übungsreihe anzeigen",
            "TITLE": "Übungsreihe {{title}}",
            "REMOVE": "Übungsreihe entfernen",
            "REMOVE_CONFIRMATION_TITLE": "{{title}} löschen",
            "REMOVE_CONFIRMATION_DESCRIPTION": "Die Daten werden unwiderruflich gelöscht.\nWenn Sie die Übungsreihe „{{title}}“ löschen möchten, klicken Sie auf „Löschen“.",
            "REMOVE_SUCCESS": "Die Übungsreihe wurde erfolgreich gelöscht",
            "REMOVE_ERROR": "Beim Löschen der Übungsreihe ist ein Fehler aufgetreten",
            "LOOPS": "Startet am Ende neu mit erster Übung",
            "DOES_NOT_LOOP": "Hält bei letzter Übung an",
            "TEMPLATE": {
                "CARD_TITLE": "Übungen der Reihe und Trainingsvorgaben",
                "CREATE": "Übungsreihenvorlage\nerstellen",
                "CREATE_ERROR": "Beim Erstellen der Übungsreihenvorlage ist ein Fehler aufgetreten",
                "CREATE_SUCCESS": "Die Übungsreihenvorlage wurde erfolgreich erstellt",
                "DELETE": "Übungsreihenvorlage löschen",
                "DELETE_CONFIRMATION": "Die Übungsreihenvorlage \"{{title}}\" wird unwiderruflich gelöscht. Wenn Sie die Übungsreihenvorlage löschen möchten, klicken Sie auf \"Löschen\".",
                "DELETE_ERROR": "Beim Löschen der Übungsreihenvorlage ist ein Fehler aufgetreten",
                "DELETE_SUCCESS": "Die Übungsreihenvorlage wurde erfolgreich gelöscht",
                "EDIT": "Übungsreihenvorlage bearbeiten",
                "EDIT_ERROR": "Beim Bearbeiten der Übungsreihenvorlage ist ein Fehler aufgetreten",
                "EDIT_SUCCESS": "Die Übungsreihenvorlage wurde erfolgreich bearbeitet",
                "LINE_BREAK_BUTTON": "Übungsreihen-\nvorlagen",
                "LOAD_ERROR": "Beim Laden der Übungsreihenvorlage ist ein Fehler aufgetreten.",
                "LOOP": "Verhalten zum Ende der Reihe",
                "LOOP_ENABLE": "Startet am Ende neu mit erster Übung",
                "LOOP_DISABLE": "Hält bei letzter Übung an",
                "NOT_FOUND": "Es liegen keine Übungsreihenvorlagen vor.",
                "SINGULAR": "Übungsreihenvorlage"
            }
        },
        "FINISH": "Training abschließen",
        "PLAN": {
            "ADD": "Trainingsplan hinzufügen",
            "ANY_ITEM": "Es liegen keine Trainingsplanvorlagen vor.",
            "AUTO_LOCK": "Trainingsplan bei roter Flagge sperren",
            "CONDITIONS": "Bedingungen",
            "DESCRIPTION": "Bemerkungen",
            "DURATION": "Dauer",
            "GET_ERROR": "Beim Abrufen der Trainingspläne ist ein Fehler aufgetreten.",
            "EXERCISE": {
                "AUTOMATIC_PROGRESSION": "Autom. Progr.",
                "DEBIT_VALUES": "SOLL Werte",
                "INFO": "Info",
                "LAST_COMPLETED_GOAL": "Letztes Training",
                "REMOVE": "Übung entfernen",
                "SINGULAR": "Übung"
            },
            "GOAL": "Trainingsplanziel",
            "NO_PLAN": "Keine Trainingspläne vorhanden.",
            "PLURAL": "Trainingspläne",
            "DELETE": "Trainingsplan löschen",
            "DELETE_DESCRIPTION": "Die Daten werden unwiderruflich gelöscht.\nWenn Sie den Trainingsplan „{{title}}“ löschen möchten, klicken Sie auf „Löschen“.",
            "DELETE_SUCCESSFULLY": "Der Trainingsplan wurde gelöscht.",
            "OPEN": "Trainingsplan öffnen",
            "REMOVE_LAST_EXERCISE_CONFIRMATION": "Sie entfernen die letzte Übung aus dieser Übungsreihe. Die Übungsreihe wird aus diesem Trainingsplan entfernt. Wenn Sie die Übung entfernen möchten, klicken Sie auf „Löschen“.",
            "REST_DAYS": "Anzahl Pausentage \nzwischen zwei Einheiten.",
            "REST_INFORMATION_LATEST_TRAINING_DATE": "Sie haben diese Einheit zuletzt am {{date}} absolviert.",
            "REST_INFORMATION_1_DAY": "Denken Sie daran, zwischen zwei Trainingstagen einen Pausentag einzulegen.",
            "REST_INFORMATION_2_DAY": "Denken Sie daran, zwischen zwei Trainingstagen zwei Pausentage einzulegen.",
            "REST_INFORMATION_3_DAY": "Denken Sie daran, zwischen zwei Trainingstagen drei Pausentage einzulegen.",
            "REST_INFORMATION_4_DAY": "Denken Sie daran, zwischen zwei Trainingstagen vier Pausentage einzulegen.",
            "REST_INFORMATION_5_DAY": "Denken Sie daran, zwischen zwei Trainingstagen fünf Pausentage einzulegen.",
            "REST_INFORMATION_6_DAY": "Denken Sie daran, zwischen zwei Trainingstagen sechs Pausentage einzulegen.",
            "REVISION": "Trainingsplan in Überarbeitung",
            "REVISION_DESCRIPTION": "Dieser Trainingsplan wurde aufgrund ihrer letzten Trainingsrückmeldung pausiert und wird aktuell für Sie überarbeitet. \n\nEr wird zeitnah wieder für Sie verfügbar sein.",
            "SELECT": "Trainingsplan wählen",
            "SINGULAR": "Trainingsplan",
            "SESSIONS_COMPLETED": "Einheiten abgeschlossen",
            "SESSIONS_PER_WEEK": "Einheiten pro Woche",
            "SESSION": {
                "ANY_ITEM": "Es liegen keine Einheiten vor."
            },
            "TEMPLATE": {
                "DELETE_SUCCESS": "Die Trainingsplanvorlage wurde erfolgreich gelöscht",
                "LOAD_ERROR": "Beim Laden der Trainingsplanvorlage ist ein Fehler aufgetreten.",
                "NEW": "Neue Trainingsplanvorlage",
                "SINGULAR": "Trainingsplanvorlage",
                "DELETE_ACTION": "Trainingsplanvorlage löschen",
                "ITEM_DELETE_MODAL_TITLE": "{{title}} löschen",
                "ITEM_DELETE_MODAL_DESCRIPTION": "Die Daten werden unwiderruflich gelöscht.\nWenn Sie die Trainingsplanvorlage „{{title}}“ löschen möchten, klicken Sie auf „Löschen“.",
                "REMOVE_LAST_EXERCISE_CONFIRMATION": "Sie entfernen die letzte Übung aus dieser Übungsreihe. Die Übungsreihe wird aus dieser Trainingsplanvorlage entfernt. Wenn Sie die Übung entfernen möchten, klicken Sie auf „Löschen“."
            },
            "TITLE": "Planbezeichnung",
            "WEEKS": "Wochen"
        },
        "STATISTICS": {
            "ANY_ITEM": "Es liegen keine Übungsstatistiken vor."
        },
        "PROGRESSION": {
            "ACTIVATE_SUCCESS": "Die Progression wurde erfolgreich aktiviert",
            "ACTIVATE_ERROR": "Beim Aktivieren der Progression ist ein Fehler aufgetreten",
            "BASE_VALUES": "Basiswerte",
            "DEACTIVATE_SUCCESS": "Die Progression wurde erfolgreich deaktiviert",
            "DEACTIVATE_ERROR": "Beim Deaktivieren der Progression ist ein Fehler aufgetreten",
            "DEBIT_VALUES": "SOLL-Werte (progressiert)",
            "DEBIT_VALUES_ERROR": "Es liegt eine ungültige Berechnung der Progressionsvorgaben vor. Entweder ändere die Basiswerte oder wähle eine andere Progressionsstufe oder ein anderes Progressionsschema aus.",
            "EDIT": "Progression bearbeiten",
            "EDIT_SUCCESS": "Die Progression wurde erfolgreich bearbeitet",
            "EDIT_ERROR": "Beim Bearbeiten der Progression ist ein Fehler aufgetreten",
            "INTENSITY": "Intensität",
            "PULSE": "Puls",
            "REMOVE_SUCCESS": "Die automatische Progression wurde erfolgreich deaktiviert",
            "SCHEME": "Progressionsschema",
            "SELECT": "Progressionsschema wählen",
            "SERIES_DURATION": "Serien/Dauer",
            "SINGULAR": "Progression",
            "TEMPLATE": {
                "CREATE": "Progressionschema\nerstellen",
                "CREATE_ERROR": "Beim Erstellen des Progressionsschemas ist ein Fehler aufgetreten",
                "CREATE_SUCCESS": "Das Progressionsschema wurde erfolgreich erstellt",
                "DELETE": "Progressionsschema löschen",
                "DELETE_CONFIRMATION": "Das Progressionsschema \"{{title}}\" wird unwiderruflich gelöscht. Das Progressionsschema wird aus allen zugeordneten Übungen in den Trainingsplanvorlagen entfernt. Wenn Sie das Progressionsschema löschen möchten, klicken Sie auf \"Löschen\".",
                "DELETE_ERROR": "Beim Löschen des Progressionsschemas ist ein Fehler aufgetreten",
                "DELETE_SUCCESS": "Das Progressionsschema wurde erfolgreich gelöscht",
                "EDIT_ERROR": "Beim Bearbeiten des Progressionsschemas ist ein Fehler aufgetreten",
                "EDIT_SUCCESS": "Das Progressionsschema wurde erfolgreich bearbeitet",
                "LINE_BREAK_BUTTON": "Progressions-\nschema",
                "LOAD_ERROR": "Beim Laden des Progressionsschemas ist ein Fehler aufgetreten.",
                "NOT_FOUND": "Es liegen keine Progressionsschemata vor.",
                "SINGULAR": "Progressionsschema",
                "ERROR": {
                    "NAME_TOO_LONG": "Der eingegebene Name ist zu lang. Der eingegebene Name darf maximal 100 Zeichen lang sein.",
                    "DESCRIPTION_TOO_LONG": "Die eingegebene Beschreibung ist zu lang. Die eingegebene Beschreibung darf maximal 250 Zeichen lang sein."
                }
            },
            "STEP": {
                "ADD": "Stufe hinzufügen",
                "ADD_ERROR": "Beim Hinzufügen der Stufe ist ein Fehler aufgetreten",
                "ADD_SUCCESS": "Die Stufe wurde erfolgreich hinzugefügt",
                "DELETE": "Stufe löschen",
                "DELETE_CONFIRMATION": "Die Stufe wird unwiderruflich gelöscht. Die Stufe wird aus allen zugeordneten Übungen in den Trainingsplanvorlagen entfernt. Wenn Sie die Stufe löschen möchten, klicken Sie auf \"Löschen\".",
                "DELETE_ERROR": "Beim Löschen der Stufe ist ein Fehler aufgetreten",
                "DELETE_SUCCESS": "Die Stufe wurde erfolgreich gelöscht",
                "DURATION_OPERATOR": "Dauer Operator",
                "DURATION_OPERATOR_HEADER": "Dauer Oper.",
                "DURATION_VALUE": "Dauer",
                "DURATION_VALUE_HEADER": "Dauer Wert",
                "EDIT": "Stufe bearbeiten",
                "EDIT_ERROR": "Beim Bearbeiten der Stufe ist ein Fehler aufgetreten",
                "EDIT_SUCCESS": "Die Stufe wurde erfolgreich bearbeitet",
                "INTENSITY_OPERATOR": "Intensität Operator",
                "INTENSITY_OPERATOR_HEADER": "Intensität Oper.",
                "INTENSITY_VALUE": "Intensität",
                "INTENSITY_VALUE_HEADER": "Intensität Wert",
                "NOT_FOUND": "Es liegen keine Progressionsstufen vor.",
                "ORDER": "Stufe",
                "SINGULAR": "Belastungsstufe",
                "PLURAL": "Progressionsstufen",
                "REORDER_ERROR": "Beim bearbeiten der Stufen ist ein Fehler aufgetreten",
                "REORDER_SUCCESS": "Die Stufen wurden erfolgreich bearbeitet",
                "SERIES_OPERATOR": "Serien Operator",
                "SERIES_OPERATOR_HEADER": "Serien Oper.",
                "SERIES_VALUE": "Serien",
                "SERIES_VALUE_HEADER": "Serien Wert",
                "STRESS_OPERATOR": "Beanspruchung Operator",
                "STRESS_OPERATOR_HEADER": "Beanspr. Oper.",
                "STRESS_VALUE": "Beanspruchung",
                "STRESS_VALUE_HEADER": "Beanspr. Wert",
                "ERROR": {
                    "SERIES_TOO_BIG": "Die Eingabe ist ungültig. Der Wert darf keine Kommazahl sein und 99 nicht übersteigen.",
                    "DURATION_TOO_BIG": "Die Eingabe ist ungültig. Der Wert darf keine Kommazahl sein und 9999 nicht übersteigen.",
                    "INTENSITY_TOO_BIG": "Die Eingabe ist ungültig. Der Wert darf maximal eine Nachkommastelle haben und 9999 nicht übersteigen.",
                    "STRESS_TOO_BIG": "Die Eingabe ist ungültig. Der Wert darf keine Kommazahl sein und 220 nicht übersteigen."
                }
            }
        },
        "REQUIREMENT_AND_EXERCISE": "Trainingsvorgaben und Übungen",
        "RETURN_TO_EXERCISE": "Zurück zur Übung",
        "SINGULAR": "Training",
        "START_NEXT_EXERCISE": "Nächste Übung starten",
        "TEMPLATE": {
            "ADD": "Trainingsplanvorlage hinzufügen",
            "NONE": "Keine Trainingsplanvorlagen vorhanden",
            "SINGULAR": "Trainingsplanvorlage",
            "PLURAL": "Trainingsplanvorlagen",
            "SELECT": "Trainingsplanvorlage wählen",
            "ASSIGNMENT": "Zuordnung",
            "UNITS_PER_WEEK": "Einheiten pro Woche",
            "DESCRIPTION": "Bemerkung",
            "ANY_ITEM": "Es liegen keine Trainingsplanvorlagen vor.",
            "REMOVE": "Trainingsplanvorlage entfernen",
            "OPEN": "Trainingsplanvorlage öffnen"
        },
        "SESSION": {
            "SINGULAR": "Trainingseinheit",
            "PLURAL": "Trainingseinheiten",
            "ERROR": {
                "SUBMIT_FEEDBACK": "Beim versenden des Feedbacks ist ein Fehler aufgetreten",
                "FINISH_SESSION": "Beim Abschließen der Trainingseinheit ist ein Fehler aufgetreten",
                "CANCEL_SESSION": "Beim Abbrechen der Trainingseinheit ist ein Fehler aufgetreten"
            }
        }
    },
    "TRAINING_FINISHED_LABEL": "Sie haben das Training abgeschlossen.",
    "TRAINING_PARAMETER_1": "Einstellungsmöglichkeit 1",
    "TRAINING_PARAMETER_2": "Einstellungsmöglichkeit 2",
    "TRAINING_PLAN": "Training",
    "TRAINING_TEMPLATES": "Trainingsplan-\nvorlagen",
    "TYPE": "Typ",
    "Thu": "Donnerstag",
    "Tue": "Dienstag",
    "UNKNOWN": "Unbekannt",
    "UNLIMITED": "Unbegrenzt",
    "SAVE_IN_PROGRESS": "Wird gespeichert",
    "UPLOADING_FILE": "{{filename}} wird hochgeladen: {{progress}}%",
    "UPLOADED_FILE": "Datei wurde hochgeladen.",
    "UPLOAD_CONTENT": "Aufnahme hochladen",
    "UPLOAD_DOCUMENT": "Dokument hochladen",
    "UPLOAD_FILE_BUTTON": "Datei hochladen",
    "UPLOAD_NEW_FORM": "Formular ausfüllen",
    "USER": {
        "ANALYST": {
            "ANY_ITEM": "Es liegen keine Analysten vor.",
            "PLURAL": "Analysten",
            "SINGULAR": "Analyst",
            "DELETE": "Analyst löschen",
            "ADD_ACCOUNT": "Analystkonto hinzufügen",
            "ACCOUNT": "Analystkonto"
        },
        "ASSIGN_GROUP": "Gruppe zuordnen",
        "ASSIGN_ROLES": "Rollen zuordnen",
        "ROLLE": {
            "PLURAL": "Rollen",
            "ANY_ASSIGN": "Es ist keine Rolle zugeordnet.",
            "UPDATE_ERROR": "Beim Aktualisieren der Benutzer ist ein Fehler aufgetreten."
        },
        "DELETED": "Gelöschter Benutzer",
        "DELETE_ACCOUNT_TITLE": "{{name}} löschen",
        "DELETE_ACCOUNT_DESCRIPTION": "Die Daten werden unwiderruflich gelöscht.\nWenn Sie den Benutzer „{{name}}“ löschen möchten, klicken Sie auf „Löschen“.",
        "DELETE_ACCOUNT_SUCCESS": "Das Benutzerkonto wurde erfolgreich gelöscht.",
        "CAREGIVER": {
            "ADD": "Betreuer hinzufügen",
            "DELETE": "Betreuer löschen",
            "ANY_ITEM": "Es liegen keine Betreuer vor.",
            "ANY": "Es liegen keine Betreuer vor.",
            "SINGULAR": "Betreuer",
            "PLURAL": "Betreuer",
            "CHOOSE": "Betreuer wählen",
            "ASSIGN": "Betreuer zuordnen",
            "ANY_ASSIGN": "Es sind keine Betreuer zugeordnet.",
            "ANY_ITEMS": "Es sind keine Betreuer zugeordnet.",
            "ADD_ACCOUNT": "Betreuerkonto hinzufügen",
            "ACCOUNT": "Betreuerkonto"
        },
        "GROUP": {
            "PLURAL": "Gruppen",
            "ANY": "Bitte eine Gruppe zuordnen.",
            "EDIT_REQUESTED_SERVICE": "Anforderbare Leistung bearbeiten",
            "CREATE_REQUESTED_SERVICE": "Anforderbare Leistung erstellen",
            "ANY_SERVICE": "Es liegen keine Leistungen vor.",
            "DELETE_SERVICE": "Leistung entfernen",
            "PROVIDED_SERVICE": "Leistungsanforderung",
            "SERVICE": {
                "PLURAL": "Leistungen"
            }
        },
        "CATALOG_MANAGER": {
            "2_WORDS": "Katalog-manager",
            "SINGULAR": "Katalogmanager",
            "PLURAL": "Katalogmanager",
            "ANY_ITEM": "Es liegen keine Katalogmanager vor.",
            "DELETE": "Katalogmanager löschen",
            "ADD_ACCOUNT": "Katalogmanagerkonto hinzufügen",
            "ACCOUNT": "Katalogmanagertkonto"
        },
        "MANUAL": {
            "DEFAULT": "Handbuch",
            "PATIENT": "Handbuch für Patienten",
            "NON_PATIENT": "Handbuch für Betreuer"
        },
        "PATIENT": {
            "ANY_ITEM": "Es liegen keine Patienten vor.",
            "ANY_ITEMS": "Es sind keine Patienten zugeordnet.",
            "LIST": "Patientenliste",
            "PLURAL": "Patienten",
            "SINGULAR": "Patient",
            "DELETE": "Patient löschen",
            "DELETE_ACCOUNT": "Patientenkonto löschen",
            "ADD_ACCOUNT": "Patientenkonto hinzufügen",
            "REMOVE_ACCOUNT": "Patientenkonto entfernen",
            "PATIENT_DETAILS_OPEN": "Patientenakte öffnen",
            "ASSIGN": "Patienten zuordnen",
            "CHOOSE": "Patienten wählen",
            "PSEUDONYM": "Pseudo-ID",
            "PSEUDONYM_DEFINITION": "Pseudonym",
            "PATIENT_NUMBER": "Benutzer-ID",
            "ANY_ASSIGN": "Es sind keine Patienten zugeordnet.",
            "ANY_SUPERVISOR_ASSIGN": "Diesem Patienten sind keine Co-Betreuer zugeordnet. Co-Betreuer können einem Patient über die Stammdatenverwaltung zugeordnet werden.",
            "ACCOUNT": "Patientenkonto",
            "FILTER": {
                "ALL": "Alle",
                "PASSIVE": "Passiv",
                "REGISTERED": "Registriert",
                "ACTIVE": "Aktiv",
                "INACTIVE": "Inaktiv",
                "HAS_THERAPY": "In Betreuung",
                "FINISHED_THERAPIES": "Beendet",
                "DISABLED": "Deaktiviert"
            }
        },
        "ROLE": {
            "ANALYST": "Analyst",
            "ASSIGN_GROUP": "Gruppe zuordnen",
            "ASSIGN_ROLES": "Rollen zuordnen",
            "CAREGIVER": "Betreuer",
            "CATALOG_MANAGER": "Katalogmanager",
            "create_supervised_patient": "Co-Betreuer Patient anlegen. (Erweiterung)",
            "KNOWLEDGE_MANAGER": "Wissensmanager",
            "manage_course_and_meeting": "Kurse/Sitzungen bearbeiten",
            "PATIENT": "Patient",
            "patient_coordination": "Patienten koordinieren (Erweiterung)",
            "patient_recruitment": "Patienten rekrutieren (Erweiterung)",
            "read_chat": "Chat lesen (Erweiterung)",
            "read_medical_patientdata": "Medizinische Daten lesen (Erweiterung)",
            "read_note": "Notizen lesen (Erweiterung)",
            "SUPERVISOR": "Co-Betreuer",
            "USER": "Benutzer",
            "USER_MANAGER": "Benutzermanager",
            "write_medical_patientdata": "Medizinische Daten bearbeiten (Erweiterung)",
            "write_note": "Notizen bearbeiten (Erweiterung)",
            "write_chat": "Chat bearbeiten (Erweiterung)",
            "write_announcement": "Neuigkeiten bearbeiten (Erweiterung)",
            "read_task_plan": "Aufgabenpläne von Patienten lesen (Erweiterung)",
            "write_task_plan": "Aufgabenpläne für den Patienten erstellen und löschen (Erweiterung)",
            "manage_my_courses_and_meetings": "Kurse/Sitzungen bearbeiten",
            "read_randomization_assignment": "Zuordnungen zwischen Patienten und Randomisierungsgruppen lesen (Erweiterung)",
            "manage_patient_dossier": "Patientenakte bearbeiten (Erweiterung)",
            "read_medication": "Medikation lesen (Erweiterung)",
            "manage_medication": "Medikation bearbeiten (Erweiterung)"
        },
        "SELECT": "Benutzer wählen",
        "SUPERVISOR": {
            "DELETE": "Co-Betreuer löschen",
            "ANY_ITEM": "Es liegen keine Co-Betreuer vor.",
            "ANY_ITEMS": "Es sind keine Co-Betreuer zugeordnet.",
            "ADD": "Co-Betreuer hinzufügen",
            "SINGULAR": "Co-Betreuer",
            "PLURAL": "Co-Betreuer",
            "CHOOSE": "Co-Betreuer wählen",
            "ASSIGN": "Co-Betreuer zuordnen",
            "SELF_ASSIGN": "Sich selbst zuordnen",
            "ANY_ASSIGN": "Es sind keine Co-Betreuer zugeordnet.",
            "ADD_ACCOUNT": "Co-Betreuerkonto hinzufügen",
            "ACCOUNT": "Co-Betreuerkonto"
        },
        "USER": "Benutzer",
        "KNOWLEDGE_MANAGER": {
            "DELETE": "Wissensmanager löschen",
            "SINGULAR": "Wissensmanager",
            "PLURAL": "Wissensmanager",
            "ANY_ITEM": "Es liegen keine Wissensmanager vor.",
            "ADD_ACCOUNT": "Wissensmanagerkonto hinzufügen",
            "ACCOUNT": "Wissensmanager"
        },
        "USER_MANAGER": {
            "DELETE": "Benutzermanager löschen",
            "2_WORDS": "Benutzer-manager",
            "SINGULAR": "Benutzermanager",
            "PLURAL": "Benutzermanager",
            "ANY_ITEM": "Es liegen keine Benutzermanager vor.",
            "ADD_ACCOUNT": "Benutzermanagerkonto hinzufügen",
            "ACCOUNT": "Benutzermanagerkonto"
        },
        "ERROR": {
            "DELETE_OWN_ACCOUNT": "Das eigene Benutzerkonto kann nicht gelöscht werden.",
            "FETCH_LIST": "Fehler beim Abrufen der Benutzerliste.",
            "FETCH_CARE_RELATIONSHIPS": "Fehler beim Abrufen der Patientenbetreuung.",
            "SAVE_CARE_RELATIONSHIPS": "Fehler beim Speichern der Patientenbetreuung.",
            "EMAIL_TAKEN": "Die E-Mail Adresse \"{{email}}\" ist bereits einem Benutzerkonto zugewiesen."
        },
        "PASSWORD": {
            "CHANGE_ACTION": "Passwort ändern"
        },
        "NORMAL": {
            "VIEW": "Normalmodus"
        }
    },
    "USERNAME": "Benutzername",
    "USER_ACCOUNT": "Benutzerkonto",
    "USER_MANAGER": "Benutzermanager",
    "USER_MASTER_DATA": "Stammdaten",
    "USER_PREFERENCES": {
        "VIEW": "Ansicht",
        "SAVE_ERROR": "Die Einstellungen konnten nicht gespeichert werden.",
        "NOTIFICATIONS": "Benachrichtigungen",
        "FONT_SIZE": {
            "SMALL": "Klein",
            "NORMAL": "Normal",
            "LARGE": "Groß"
        },
        "EMAIL_NOTIFICATION_SCOPE": {
            "LABEL": {
                "TASK_START": "Aufgabe startet in Kürze",
                "TASK_DUE_DATE": "Aufgabe ist in Kürze fällig",
                "TASK_FINISHED_DATE": "Aufgabe läuft in Kürze ab",
                "CHAT": "Ungelesene Chat-Nachrichten",
                "TERMIN_START": "Termin steht in Kürze an",
                "TERMIN_CHANGE": "Termin wurde geändert",
                "ANNOUNCEMENT": "Ungelesene Neuigkeiten",
                "NEW_PATIENT": "Neues Patientenkonto auf Plattform erstellt",
                "NEW_ASSIGNED_PATIENT": "Patient dem Benutzer zugeordnet",
                "TRAINING_START": "Training startet bald",
                "TRAINING_END": "Training endet bald"
            },
            "ALL_CARE_USER": "Für alle Patienten",
            "ME_PATIENT": "Aktiviert",
            "ME_CARE_USER": "Für mir zugeordnete Patienten",
            "NONE": "Deaktiviert"
        }
    },
    "USER_UPDATED_FAILURE_MESSAGE": "Fehler beim Aktualisieren des Benutzers",
    "USER_UPDATED_SUCCESS_MESSAGE": "Benutzer erfolgreich aktualisiert",
    "UUID": "UUID",
    "VIDEO_CONFERENCE": "Videogespräch",
    "VIDEO_CONFERENCE_EXTERNAL_URL": "Externe Videogespräch",
    "VISIBILITY": "Sichtbarkeit",
    "VORANMELDUNG_ATTACHMENT": {
        "PLURAL": "Anhänge Voranmeldung",
        "KIND": {
            "IMAGE": "Foto",
            "PDF": "PDF",
            "ECG_PDF": "EKG",
            "ECG_PDF_LEADS": "EKG ({{leads}} Ableitungen)"
        }
    },
    "WATERY_CLEAR": "Wässrig klar",
    "WATERY_LIGHT": "Wässrig hell",
    "WATERY_YELLOWISH": "Wässrig gelblich",
    "WEBPRAX": "webPRAX",
    "WEBSHOP_ARTICLE_BOOK_NOW": "Kurs buchen",
    "WEBSHOP_ARTICLE_CURRENCY": "Währung",
    "WEBSHOP_ARTICLE_DESC": "Beschreibung im Katolog",
    "WEBSHOP_ARTICLE_DETAILS_TITLE": "Kurs",
    "WEBSHOP_ARTICLE_INFO": "Buchungsoptionen",
    "WEBSHOP_ARTICLE_LOCATION": "Ort",
    "WEBSHOP_ARTICLE_MEDIA_FILES": "Vorschaumedien",
    "WEBSHOP_ARTICLE_MEDICAL_REQUIREMENTS": "Hinweistext für medizinische\nVoraussetzungen",
    "WEBSHOP_ARTICLE_NO_LONGER_AVAILABLE": "Der gewünschte Artikel ist leider nicht mehr erhältlich.",
    "WEBSHOP_ARTICLE_PRICE": "Preis (inkl. MwSt.)",
    "WEBSHOP_ARTICLE_PUBLISH_STATUS": "Sichtbarkeit im Katalog",
    "WEBSHOP_ARTICLE_SEATS_MAX": "Maximale Teilnehmeranzahl",
    "WEBSHOP_ARTICLE_SEATS_MIN": "Minimale Teilnehmeranzahl",
    "WEBSHOP_ARTICLE_SUMMARY": "Zusammenfassung",
    "WEBSHOP_ARTICLE_USER_REQUIREMENTS": "Nutzungsbedingungen",
    "WEBSHOP_ARTICLE_VARIANT_CARD_TITLE": "Kursdetails",
    "WEBSHOP_ARTICLE_VAT": "MwSt",
    "WEBSHOP_AVAILABLE_ARTICLES": "Kursangebote",
    "WEBSHOP_AVAILABLE_OTHER_ARTICLES": "Weitere Kursangebote",
    "WEBSHOP_CHECKOUT_CANCEL": "Bezahlvorgang abgebrochen",
    "WEBSHOP_CHECKOUT_HEALTH_REQUIREMENTS": "Gesundheitliche Voraussetzungen",
    "WEBSHOP_CHECKOUT_ORDER_NOW": "Zahlungspflichtig kaufen",
    "WEBSHOP_CHECKOUT_SUCCESS": "Buchungsbestätigung",
    "WEEK": "Woche",
    "WEIGHT": "Gewicht",
    "WELCOME": "Herzlich willkommen!",
    "WELCOME_PATIENT_HOME_PAGE": "Schön, dass Sie hier sind!",
    "WELL_DONE": "Gut gemacht",
    "WITHOUT_ACCOUNT_USER_SHOP_EXPLANATIONS": "Falls Sie noch kein Konto haben, können Sie sich für ein Konto selbst registrieren.",
    "WITH_ACCOUNT_USER_SHOP_EXPLANATIONS": "Um den Kurs buchen zu können, müssen Sie sich mit Ihrem Konto anmelden.",
    "WOUND_DOC": "Wunddoku",
    "Wed": "Mittwoch",
    "YEAR": "Jahr",
    "YELLOW": "Gelb",
    "YES": "Ja",
    "YOUR_ADVANCEMENTS": "Ihr Fortschritt",
    "YOUR_COURSE": "Ihr Kurs",
    "YOUR_COURSES_AND_PROGRAMS": "Ihre Kurse und Programme",
    "YOUR_DOCUMENTS": "Ihre Dokumente",
    "YOUR_FORMS": "Ihre Formulare",
    "YOUR_MEASUREMENTS": "Ihre Messungen",
    "YOU_HAVE_ANY_NOTIFICATION": "Sie haben keine neuen Nachrichten.",
    "YOU_HAVE_MULTIPLE_NOTIFICATIONS": "Sie haben {{number}} neue Nachrichten!",
    "YOU_HAVE_ONE_NOTIFICATION": "Sie haben 1 neue Nachricht!",
    "ZIP": "PLZ",
    "application/msword": "doc",
    "application/pdf": "pdf",
    "application/vnd.ms-excel": "xls",
    "application/vnd.ms-powerpoint": "ppt",
    "application/vnd.oasis.opendocument.presentation": "odp",
    "application/vnd.oasis.opendocument.spreadsheet": "ods",
    "application/vnd.oasis.opendocument.text": "odt",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "application/x-7z-compressed": "7z",
    "application/x-rar-compressed": "rar",
    "application/xml": "xml",
    "application/zip": "zip",
    "create_supervised_patient": "Co-Betreuer Patient anlegen. (Erweiterung)",
    "d": "Tag",
    "day": "Tag",
    "days": "Tag",
    "h": "Stunde",
    "hour": "Stunde",
    "hours": "Stunde",
    "image/gif": "gif",
    "image/jpeg": "jpeg",
    "image/jpg": "jpg",
    "image/png": "png",
    "image/tiff": "tiff",
    "m": "Minuten",
    "minute": "Minute",
    "minutes": "Minuten",
    "month": "Monate",
    "months": "Monate",
    "patient_coordination": "Patienten koordinieren (Erweiterung)",
    "patient_recruitment": "Patienten rekrutieren (Erweiterung)",
    "read_chat": "Chat lesen (Erweiterung)",
    "read_medical_patientdata": "Medizinische Daten lesen (Erweiterung)",
    "read_note": "Notizen lesen (Erweiterung)",
    "read_task_plan": "Aufgabenpläne von Patienten lesen (Erweiterung)",
    "write_task_plan": "Aufgabenpläne für den Patienten erstellen und löschen (Erweiterung)",
    "manage_patient_dossier": "Patientenakte bearbeiten (Erweiterung)",
    "write_announcement": "Neuigkeiten bearbeiten (Erweiterung)",
    "read_randomization_assignment": "Zuordnungen zwischen Patienten und Randomisierungsgruppen lesen (Erweiterung)",
    "manage_my_courses_and_meetings": "Kurse/Sitzungen bearbeiten",
    "read_medication": "Medikation lesen (Erweiterung)",
    "manage_medication": "Medikation bearbeiten (Erweiterung)",
    "text/csv": "csv",
    "w": "Woche",
    "week": "Woche",
    "weeks": "Woche",
    "write_chat": "Chat bearbeiten (Erweiterung)",
    "write_medical_patientdata": "Medizinische Daten bearbeiten (Erweiterung)",
    "write_note": "Notizen bearbeiten (Erweiterung)",
    "y": "Jahre",
    "year": "Jahre",
    "years": "Jahre",
    "INVALID_DATE_FORMAT_ERROR": "Das Format des Datums ist ungültig.",
    "INVALID_MAX_DATE_RANGE_ERROR": "Datum liegt nach dem erlaubten Zeitraum.",
    "INVALID_MIN_DATE_RANGE_ERROR": "Datum liegt vor dem erlaubten Zeitraum.",
    "SELF_PAY": "Selbstzahler",
    "TEXT": "Text",
    "LIST": "Liste",
    "LIST_VIEW": "Listenansicht",
    "CALENDAR": "Kalender",
    "SHORT_NAME": "Kürzel",
    "RECEPTIONIST": "Assistent",
    "MANAGER": "Führungskräfte",
    "REPEAT_VALIDATION_ERROR": "Validierung ist ungültig",
    "CSV_PATIENT_IMPORT": {
        "CSV_IMPORT": "CSV Import",
        "IMPORTED": "Importiert",
        "IMPORT_PATIENTS_AS_CSV": "Patienten über CSV importieren",
        "SUCCESSFUL_ADDED": "✅ Hinzugefügt",
        "SKIPPED_INVALID": "❌ Ausgelassen, da ungültig",
        "SKIPPED_ALREADY_EXIST": "❌ Ignoriert, da schon vorhanden"
    },
    "MYMEDAX": {
        "WAITING_FOR_SUBMISSION": "Die Fragebogen Abgabe wird verarbeitet..."
    },
    "PDF_REPORT_CREATION_FAILED": "Das Erstellen des PDF Berichts ist fehlgeschlagen.",
    "PDF_REPORT_CREATION_SUCCESS": "PDF Bericht ist erfolgreich erstellt worden.",
    "UPDATE_EMAIL": {
        "ALREADY_VERIFIED": "Diese E-Mail Adresse wurde bereits bestätigt.",
        "SAME": "Diese E-Mail Adresse ist bereits die Aktuelle.",
        "INITIATION_SUCCESS": "Die Änderungen wurden übernommen. Dem Benutzer wurde eine E-Mail zur Bestätigung an die neue E-Mail Adresse gesendet.",
        "INITIATION_FAILED": "Die Änderung der E-Mail konnte nicht übernommen werden.",
        "LINK_EXPIRED": "Der Bestätigungslink der E-Mail ist abgelaufen.",
        "LOADING_INITIATION": "Änderung der E-Mail Adresse. E-Mail mit Bestätigungslink wird an die neue E-Mail Adresse versendet...",
        "LOADING_VERIFICATION_REFRESH": "Der Bestätigungslink wird erneut an die neue E-Mail Adresse gesendet.",
        "NEW_EMAIL": "Neue E-Mail Adresse",
        "SEND_AGAIN": "Erneut senden",
        "UNEXPECTED_EMAIL": "Diese E-Mail Adresse stimmt nicht mit der gewünschten Änderung überein.",
        "VERIFICATION_FAILED": "Bei der Bestätigung der neuen E-Mail Adresse ist ein Fehler aufgetreten. Die neue E-Mailadresse wurde nicht übernommen.",
        "VERIFICATION_NEEDED": "Die neue E-Mail Adresse ist durch den Benutzer zu bestätigen.",
        "VERIFICATION_OBSOLETE": "Die Änderung zu dieser E-Mail Adresse ist nicht mehr gültig.",
        "VERIFICATION_REFRESH_FAILED": "Bei der Änderung der E-Mail Adresse ist ein Fehler aufgetreten.",
        "VERIFICATION_REFRESH_SUCCESS": "Die E-Mail zur Bestätigung wurde erneut gesendet. ",
        "VERIFICATION_SUCCESS": "Neue E-Mail Adresse wurde bestätigt!",
        "VERIFICATION_UNAUTHORIZED": "Sie sind nicht berechtigt, die neue E-Mail Adresse zu bestätigen."
    },
    "VALUE": "Wert",
    "VERIFIED_AT": "Verifiziert um",
    "CONNECT_EXTERN_ACCOUNT": "Externe Konten verbinden",
    "OEMBED": {
        "URL": "Video-URL",
        "INPUT_PLACEHOLDER": "https://curafida.euvideocdn.com/...",
        "ADD": "Übernehmen",
        "ERROR": {
            "INVALID_URL": "Ungültige Video-URL",
            "UNSUPPORTED_DOMAIN": "Diese Video-Plattform wird nicht unterstützt",
            "PLAYBACK_FAILED": "Video konnte nicht geladen werden",
            "NOT_FOUND": "Video nicht gefunden oder nicht öffentlich zugänglich",
            "PROVIDER_UNAVAILABLE": "Video-Anbieter ist vorübergehend nicht erreichbar",
            "UNKNOWN": "Ein unerwarteter Fehler ist aufgetreten",
            "SAVE_FAILED": "Das Video konnte nicht gespeichert werden. Bitte versuchen Sie es erneut."
        },
        "VIDEO": "Video",
        "PLAY": "abspielen",
        "PREVIEW": "Video Vorschau",
        "NO_DATA": "Kein Videoinhalt verfügbar"
    },
    "INSTANCE_CONTACT": {
        "CREATE": "Kontakt hinzufügen",
        "EDIT": "Kontakt bearbeiten",
        "DELETE": "Kontakt löschen",
        "DELETE_WARN": "Soll der Kontakt {{name}} wirklich gelöscht werden?",
        "EMPTY": "Es sind noch keine Kontakte hinterlegt.",
        "CATEGORIES": "Kategorien",
        "NO_CATEGORY": "Bitte mindestens eine Kategorie auswählen.",
        "EMAIL_INVALID": "Bitte eine gültige E-Mail-Adresse angeben.",
        "EMAIL_DUPLICATE": "Ein Ansprechpartner mit dieser E-Mail-Adresse existiert bereits.",
        "CATEGORY": {
            "NOTIFICATION": "Benachrichtigungen",
            "TECHNICAL": "Technischer Ansprechpartner",
            "PROJECT": "Fachlicher Ansprechpartner"
        },
        "DIRECTION": {
            "INFORMATION_ONLY": "Nur Information",
            "INFORMATION_AND_QUESTIONS": "Info + Rückfragen"
        },
        "OCCASIONS": {
            "NOTIFICATION": "Geplante Updates, Hotfixes, ungeplante Ausfälle, Infrastrukturprobleme. Verteiler möglich.",
            "TECHNICAL": "DNS-Records, Zertifikate, Netzwerk, technische Konfiguration.",
            "PROJECT": "Modulauswahl, fachliche Konfigurationsanpassungen."
        },
        "MESSAGE": {
            "LOAD_ERROR": "Die Ansprechpartner konnten nicht geladen werden.",
            "SAVE_SUCCESS": "Der Ansprechpartner wurde gespeichert.",
            "SAVE_ERROR": "Der Ansprechpartner konnte nicht gespeichert werden.",
            "DELETE_SUCCESS": "Der Ansprechpartner wurde gelöscht.",
            "DELETE_ERROR": "Der Ansprechpartner konnte nicht gelöscht werden."
        },
        "CATEGORIES_TITLE": "Kategorien",
        "CONTACTS_TITLE": "Kontakte",
        "CATEGORIES_HINT": "(mindestens eine)",
        "OPTIONAL": "(optional)",
        "NAME_HINT": "Person oder Bezeichnung des Verteilers, z. B. „IT-Betrieb“.",
        "NAME_REQUIRED": "Bitte einen Namen angeben.",
        "EMAIL_REQUIRED": "Bitte eine E-Mail-Adresse angeben.",
        "FUNCTION_PLACEHOLDER": "z. B. IT-Administration",
        "STATUS": "Status",
        "STATUS_ACTIVE_HINT": "Aktive Kontakte werden benachrichtigt und stehen für Rückfragen zur Verfügung.",
        "STATUS_INACTIVE_HINT": "Deaktivierte Kontakte werden nicht benachrichtigt. Ihre Daten bleiben erhalten.",
        "ACTIVE": "Aktiv",
        "INACTIVE": "Deaktiviert",
        "NO_ACTIVE_CONTACT": "Kein aktiver Kontakt",
        "ACTIVE_COUNT_ONE": "1 aktiver Kontakt",
        "ACTIVE_COUNT": "{{count}} aktive Kontakte",
        "INACTIVE_COUNT_ONE": "1 Kontakt deaktiviert",
        "INACTIVE_COUNT": "{{count}} Kontakte deaktiviert",
        "COLUMN": {
            "NAME": "Name",
            "EMAIL": "E-Mail",
            "STATUS": "Status"
        },
        "FIELD": {
            "NAME": "Name",
            "EMAIL": "E-Mail",
            "FUNCTION": "Funktion"
        },
        "CATEGORY_SHORT": {
            "NOTIFICATION": "Benachr.",
            "TECHNICAL": "Technisch",
            "PROJECT": "Fachlich"
        },
        "OCCASIONS_SHORT": {
            "NOTIFICATION": "Updates, Hotfixes, Ausfälle. Verteiler möglich.",
            "TECHNICAL": "DNS, Zertifikate, Netzwerk, technische Konfiguration.",
            "PROJECT": "Modulauswahl, fachliche Konfiguration."
        },
        "TAB": "Ansprechpartner"
    }
}
